export default {
    ACADEMIC_PERIOD: {
        FIELD: {
            GRADING_DUE_DATE: 'Last Grading Date',
            TERM: 'Term',
        },
        MESSAGE: {
            ERROR: {
                TERM_ALREADY_DEFINED: '{{term}} already defined',
            },
            INFO: {
                STANDART_BASED_PACKAGE: 'If the `Standard Based Report Cart` will be used you can set it',
                ADD_NEW_PACKAGE: 'Add New Package',
            },
        },
        TITLE: {
            ACADEMIC_YEAR: {
                NAME: 'Academic Period Name',
                NEW: 'Add Academic Period',
                NEW_ACADEMIC_YEAR: 'New Academic Period',
            },
            BROWSER: 'Academic Period',
            BROWSER_WITH_PARAM: 'Academic Period - {{param}}',
            END_DATE: 'End Date',
            INFO: 'Period Info',
            NEW: 'Add Academic Period',
            QUARTER: {
                NAME: 'Quarter Name',
                NEW: 'Add Quarter',
                NEW_QUARTER: 'New Quarter',
            },
            SELECT: 'Select an Academic Period..',
            SEMESTER: {
                NAME: 'Semester Name',
                NEW: 'Add Semester',
                NEW_SEMESTER: 'New Semester',
            },
            START_DATE: 'Start Date',
            REPORT_CARD_AVAILABLE: 'Allow Report Card Creation',
            REPORT_CARD_DUE_DATE: 'Report Card Due Date',
            WARNING: 'There is no active Academic Period, set an Academic Period to status "active" and try again.',
        },
    },
    ANNOUNCEMENT: {
        BUTTON: {
            PUBLISH: 'Publish',
            UNPUBLISH: 'Unpublish',
            VIEW_MORE: 'View All',
            HIDE: "Don't Show Again",
        },
        FIELD: {
            ANNOUNCEMENT: 'Announcement',
            CONTENT: 'Content',
            IS_ENDLESS: 'Show always',
            SHOW_ON_LOGIN: 'Show After User login',
            PUBLISH_START_TIME: 'Pub.Start',
            PUBLISH_END_TIME: 'Pub.End',
            SUBJECT: 'Subject',
            CONDITION: 'Condition',
            NEW_ANNOUNCEMENT: 'New Announcement',
        },
        MESSAGE: {
            CONFIRM: {
                DELETE: 'Do you want to delete the announcement?',
                SAVE_PUBLISH: 'Are you sure to save and publish the {{item}}?',
                UNPUBLISH: 'Are you sure to unpublish the {{item}}?',
            },
            ERROR: {
                PUBLISH_END_TIME_REQUIRED: 'Publish End Time required',
                PUBLISH_START_BEFORE_END: 'Start time must be before End Time',
                SUBSCRIBERS_EMPTY: 'Subscribers list is empty',
            },
            SUCCESS: {
                PUBLISHED: '{{item}} successfully published',
                UNPUBLISHED: '{{item}} successfully unpublished',
                HIDDEN: 'Announcement successfully hidden',
            },
        },
        TITLE: {
            ADD: 'Add Announcement',
            ADD_SUBSCRIBERS: 'Add Subscriber',
            ADD_USER: 'Add User',
            ATTACHED_FILE: 'Attached File',
            ATTACHMENTS: 'Attachments',
            BROWSER: 'Announcements',
            NEW: 'New Announcement',
            SUBSCRIBERS: 'Subscribers',
            TYPE: 'Type',
        },
    },
    ATTACHMENT: {
        TITLE: {
            PDF_VIEWER: 'PDF Viewer',
            NEW_FOLDER: 'New Folder',
            RENAME_FILE: 'Rename File',
            RENAME_FOLDER: 'Rename Folder',
        },
        BUTTONS: {
            ATTACH_FILES: 'Attach Files...',
            ATTACH_FILE: 'Attach File...',
            CAMERA: 'Camera',
            DOWNLOAD: 'Download',
            UPLOAD: 'Upload',
            FROM_LOCAL: 'From Local',
            FROM_GOOGLE_DRIVE: 'From Google Drive™',
            FROM_MY_FILES: 'From My Files',
            MY_FILES: 'My Files',
        },
        MESSAGES: {
            FILE_IS_TOO_LARGE: 'File size is too large. Maximum file size is {{item}} MB',
            FILE_NAME_MISSING: 'File name missing or blank',
            FILE_NAME_TOO_LONG: 'File name is too long. Maximum file name length is {{item}}',
            FILE_NOT_FOUND: 'File not found',
            FILE_NOT_SUPPORTED: 'File type is not supported.',
            FILE_NOT_SUPPORTED_WITH_PARAM: 'File type is not supported. Supported file types: {{item}}',
            SOMETHING_WRONG: 'Something get wrong',
            TOTAL_FILE_SIZE_TOO_LARGE: 'Total size of files should not exceed {{item}} MB.',
            FILE_NOT_EXCEL_FILE: 'Only excel file accepted',
            DUPLICATE_FILE: 'File is already exist',
            IMAGE_WIDTH_TOO_LARGE: 'Image width is too big. Maximum image width is {{item}} pixels',
            IMAGE_HEIGHT_TOO_LARGE: 'Image height is too big. Maximum image height is {{item}} pixels',
            ADD_FILE_FROM_LOCAL: 'Upload a file from your local computer.',
            ADD_FILE_FROM_DRIVE: 'Upload a file from your Google Drive™.',
            ADD_FILE_FROM_MY_FILES: 'Select a file you have already uploaded.',
            UPLOAD_FILE_HINT: 'Upload or select a file you have already uploaded.',
            VALIDATION_MESASGE: 'Please upload or select a file you have already uploaded to continue.',
            SELECTED_FILE_DELETE: 'Are you sure do you want to deleted selected files?',
        },
    },
    ATTESTATION: {
        FIELD: {
            ATTESTATION: 'Attestation',
        },
        TITLE: {
            ADD: 'Add Attestation',
            BROWSER: 'Attestations',
            NEW: 'New Attestation',
        },
    },
    ANALYTICS: {
        TITLE: {
            COURSE_WEEKLY_ATTENDANCE:
                'The rate of participation in a course on a weekly basis in the given date range. It shows interest in the selected course.',
            STUDENT_COURSE_ATTENDANCE:
                'The participation rate of a student for all courses s/he currently takes. It may reveal students interest on courses.',
            STUDENT_WEEKLY_ATTENDANCE:
                'Weekly based total participation rate of a student. It can reflect some alarming situation according to the attendance the student. It may reveal students interest on school',
            TEACHER_COURSE_WEEKLY_ATTENDANCE:
                'Weekly based participation rate  in courses a teacher currently delivers. It can reflect some alarming situation like decreasing interest on the courses',
            SUBJECT_TEACHER_WEEKLY_ATTENDANCE:
                'Weekly based participation rate  in a specific course the teachers currently deliver. It can reflect popularity of teachers in the selected course and some alarming situation',
            COURSE_STUDENT_PERCENTAGES:
                'List of the students whose participation rate is lower/bigger than given percentage. It shows students at risk of failing or engaged students',
            COURSE_PERCENTAGES:
                'List of the courses whose students participation rate is lower/bigger than given percentage. It shows courses at risk of losing interest or  with engaged students',
        },
        MESSAGE: {
            DO_NOT_HAVE_PERMISSION: 'You do not have a permission to view these analytic reports',
        },
    },
    ATTENDANCE_EXCUSE: {
        TITLE: {
            ADD: 'Add Attendance Excuse',
            BROWSER: 'Attendance Excuses',
            EDIT: 'Attendance Excuse',
            NEW: 'New Attendance Excuse',
            VIEW_MORE: 'View All',
            YOUR_MESSAGE: 'Your Message',
            PARENT_MESSAGE: "Parent's Message",
            STUDENT_MESSAGE: "Student's Message",
            HEAD_TEACHER_MESSAGE: "Head Teacher's Message",
            ALLOW_TO_STUDENT: 'Allow attendance excuse requests from Student',
        },
        MESSAGE: {
            SELECTED_COUSES_WILL_BE_EXCUSED: 'The Attendance of the selected courses above will be accepted as Excused',
            ACCEPT_CONFIRMATION:
                'Are you sure that you accept the current Attendance Excuse? Attendance of Student will be changed to "Excused" automatically',
            DECLINE_CONFIRMATION: 'Are you sure that you decline the current Attendance Excuse?',
            ATTENDANCE_CHANGE_CONFIRM: 'Are you sure you want to save the changed attendance information?',
        },
    },
    BBB_SETTINGS: {
        FIELD: {
            MODERATOR_PW: 'Moderators Password',
            ATTENDEE_PW: 'Attendee Password',
            GUEST_POLICY: 'Guest Policy',
            BREAKOUT: 'Breakout',
            IS_BREAKOUT: 'Allow Creating Breakout Rooms',
            BREAKOUT_FREE_JOIN: 'Allow Choosing Breakout Rooms',
            MUTE_ON_START: 'Mute on Start',
            ALLOW_MODS_TO_UNMUTE_USERS: 'Allow moderators to unmute attendees',
            SHOW_MODS_IN_ATTENDEES: 'Show moderators in attendees list',
            END_NO_MODERATOR: 'End meeting when no moderator',
            END_NO_MODERATOR_IN_MINUTE: 'End meeting in(min)',
            MEETING_COUNT: 'Meetings',
            ATTENDEES_COUNT: 'Attendees',
            VIDEO_COUNT: 'Videos',
            RECORDING_COUNT: 'Recordings',
            MODERATOR_COUNT: 'Moderators',
            LOCK_SETTINGS: {
                DISABLE_CAM: 'Disable Webcameras',
                DISABLE_MIC: 'Disable Microphones',
                DISABLE_PRIVATE_CHAT: 'Disable Private Chat',
                DISABLE_PUBLIC_CHAT: 'Disable Public Chat',
                DISABLE_NOTE: 'Disable Share Note',
                LOCKED_LAYOUT: 'Lock Layout',
            },
            ALLOW_START_STOP_RECORDING: 'Allow Start/Stop',
            ANIMATIONS: 'Animations',
            APPLICATION_SETTINGS: 'Application',
            AUDIO_ALERTS_FOR_CHAT: 'Audio Alerts for Chat',
            AUDIO_ALERTS_FOR_USER_JOIN: 'Audio Alerts for User Join',
            AUDIO_ALERTS_FOR_USER_JOIN_TOOLTIP: 'Audio Alerts for User Join',
            AUTO_START_RECORDING: 'Auto Start Recording',
            AVATAR_URL: 'Avatar URL',
            CLIENT_URL: 'Client URL',
            CONFIG_TOKEN: 'Config Token',
            DATA_SAVING: 'Data Saving',
            DURATION: 'Duration (min)',
            ENABLE_DESKTOP_SHARING: 'Enable Desktop Sharing',
            ENABLE_WEBCAMS: 'Enable Webcams',
            ASSIGNMENT_SETTINGS: 'Assignment',
            LATE_TIME: 'Attendee Late Time (min, "0" always accept)',
            LOGOUT_URL: 'Logout URL',
            MAX_UPLOAD_FILE_SIZE: 'Max Upload File Size (MB)',
            MAXIMUM_PARTICIPANTS: 'Maximum Participants',
            MODERATOR_ONLY_MESSAGE: 'Moderator only Message',
            NOTIFY_STUDENT_ASSIGNMENT_ATTACHED: 'Notify Student',
            NOTIFY_REPRESENTATIVES_ASSIGNMENT_ATTACHED: 'Notify Parents',
            PARAMETERS: 'Parameters',
            POPUP_ALERTS_FOR_CHAT: 'Popup Alerts for Chat',
            POPUP_ALERTS_FOR_USER_JOIN: 'Popup Alerts for User Join',
            POPUP_ALERTS_FOR_USER_JOIN_TOOLTIP: 'Popup Alerts for User Join',
            PUBLISH: 'Publish',
            RECORD: 'Record',
            RECORD_SETTINGS: 'Record',
            SECRET_CODE: 'Secret Code',
            URL: 'URL',
            WHITEBORD_URL: 'Whiteboard URL',
            VOICE_BRIDGE: 'Voice Bridge',
            WEIGHT: 'Weight',
            WELCOME_MESSAGE: 'Welcome Message',
            WELCOME_MESSAGE_INFO: 'This Welcome Message will appear in meeting',
            ALLOW_RECORDING_VIEW_FOR_ATTENDEE: 'Allow attendees to view recording',
            NOT_ALLOW_RECORDING_VIEW_FOR_ATTENDEE: 'Don`t Allow attendees to view recording',
            MAX_RECORDING_DURATION: 'Max. Recording Duration(min)',
            MIN_DURATION_FOR_PRESENT: 'Min. Duration for Present(min)',
            ATTENDANCE_SETTINGS: 'Attendance',
            DEFAULT_PRESENT_CODE: 'Present Default Code',
            DEFAULT_ABSENT_CODE: 'Absent Default Code',
        },
        TITLE: {
            ASSIGNMENT_PUBLISHED_NOTIFICATION: 'Notify when assignment published',
            RECORD_SETTINGS: 'Record Settings',
            RECORD_IS_READY_NOTIFICATION: 'Notify moderators when recordings are ready:',
            RECORD_IS_READY_NOTIFICATION_ATTENDEES: 'Notify attendees when recordings are ready:',
            VIA_EMAIL: 'via E-mail',
            VIA_SMS: 'via SMS',
        },
    },
    BANK_ACCOUNT: {
        TITLE: {
            ADD: 'Add Bank Account',
            BROWSER: 'Bank Accounts',
            CURRENCY: 'Currency',
            IBAN: 'IBAN',
            NEW: 'New Bank Account',
        },
        WARNING: {
            NOT_DEFINED: '{{account}} is not defined',
        },
    },
    BUDGET: {
        FIELD: {
            CATEGORY: 'Category',
            COST_CENTER: 'Cost Center',
            COST_CENTER_OR_DEPARTMENT: 'Cost Center / Department',
            DEPARTMENT: 'Department',
            PERMISSION_TYPE: 'Permission Type',
            ROLES: 'Roles',
            USERS: 'Users',
            BUDGET_FROM: 'Copy from Budget:',
            VERSION_FROM: 'From Version:',
            VERSION_TO: 'To Version:',
        },
        INFO: 'Budget Info',
        PERMISSIONS: 'Permissions',
        TITLE: {
            ADD: 'Add Budget',
            ADD_NEW_PERMISSION: 'Add New Permission',
            BROWSER: 'Budgets',
            NEW: 'New Budget',
            COPY_TO: 'Copy To ',
        },
        MESSAGE: {
            ACTUAL_DATA_IMPORTING_STARTED: 'Importing Actual Data Started...',
        },
    },
    BUDGET_ACCOUNTS: {
        BUTTON: {
            NEW: 'Add Formula',
            CHECK_ACCOUNTS: 'Check-Accounts',
        },
        CROSS_ACCOUNT: {
            ACCOUNT_CATEGORY: 'Account Category',
            CODE: 'Account Code',
            MESSAGE_APPLY_SUB: 'Apply this contra account formula to sub accounts',
            NEW: 'Add Contra Account',
            TITLE: 'Contra Account',
        },
        FIELD: {
            APPLY: 'Apply this budget account formula to sub accounts',
            BUDGET_ACCOUNT_FORMULA: 'Formula',
            BUDGET_TYPE: 'Budget Type',
            CODE: 'Account Code',
            COST_CENTER_REQUIRED: 'Cost Center Required',
            USE_THIS_ACCOUNT_PREFIX: 'Expense account code prefixes',
        },
        MESSAGE: {
            CONFIRM: {
                IMPORT: 'Do you want to import Budget Accounts?',
            },
            ERROR: {
                INTEGRATION_CODE_DUPLICATED: 'Duplicated integration codes are not allowed!',
                INVALID_BUDGET_ACCOUNT: 'Invalid Budget Account',
                ORDER_EXISTS: 'Please choose another Order number!',
            },
            SUCCESS: {
                IMPORTED: 'Expenses: {{expense}},  Incomes: {{income}} was successfully imported',
            },
        },
        TITLE: {
            ADD: 'Add Account',
            ADD_FORMULA: 'Add Formula',
            BROWSER: 'Budget Accounts',
            NEW: 'New Account',
            TEMPLATE: 'Budget Accounts Template',
            IMPORT: 'Budget Accounts Import',
            UPLOAD_ERROR_DIALOG: 'Excel Upload Errors',
        },
    },
    BUDGET_BALANCE_ACTUAL_REPORT: {
        FIELD: {
            ACCOUNT_CATEGORY: 'Account Category',
            ACCOUNT_CODE: 'Account Code',
            ACCOUNT_CODE_DETAIL: 'Account Code (Detail)',
            ACCOUNT_NAME: 'Account Name',
            ACCOUNT_TYPE: 'Account Type',
            BALANCE: 'Difference',
            BALANCE_CREDIT: 'Balance Credit',
            BUDGET: 'Budget',
            REALISE: 'Realized(%)',
            TOTAL: 'Plan',
            TOTAL_ACTUAL: 'Actual',
        },
        TITLE: {
            BROWSER: 'Plan Actual Report',
        },
        MESSAGE: {
            SUCCESS: 'The report was successfully generated',
        },
    },
    BUDGET_BALANCE_REPORT: {
        FIELD: {
            ACCOUNT_CATEGORY: 'Account Category',
            ACCOUNT_CODE: 'Account Code (Detail)',
            ACCOUNT_NAME: 'Account Name',
            ACCOUNT_TYPE: 'Account Type',
            BALANCE_CREDIT: 'Balance Credit',
            BALANCE_DEBIT: 'Balance Debit',
            BUDGET: 'Budget',
            EXCLUDE: 'Exclude',
            HIDE_ZERO_VALUES: 'Hide Rows with Zero Values',
            TOTAL_CREDIT: 'Total Credit',
            TOTAL_DEBIT: 'Total Debit',
        },
        TITLE: {
            BROWSER: 'Budget Balance',
            EXCLUDE_HINT: 'Selected transaction types will be excluded from balance',
        },
    },
    BUDGET_CLOSE_ACCOUNTS: {
        FIELD: {
            NET_PROFIT_OR_LOSS_ACCOUNT: 'Net Profit or Loss Account',
            PERIOD_PROFIT_OR_LOSS_ACCOUNT: 'Period Profit or Loss Account',
            PERIOD_TAX_ACCOUNT: 'Period Tax Account',
            PROFIT_OR_LOSS_ACCOUNT: 'Profit or Loss Account',
            TAX_ACCOUNT: 'Tax Account',
            TAX_FORMULA: 'Tax Formula (Ex: AMOUNT*0.1)',
        },
        MESSAGE: {
            ERROR_CLOSING_ACCOUNTS_NOT_FOUND:
                'Closing accounts not found. In order to complete budget, add closing accounts.',
        },
    },
    BUDGET_EXCEL_REPORT: {
        FIELD: {
            ADD: 'Add Budget Report',
            BUDGET_REPORT: 'Budget Report',
            CREATED_BY: 'Created By',
            CURRENCY_RATE: 'Currency Rate',
            EXCEL_TEMPLATE_NAME: 'Excel Template Name',
        },
        MESSAGE: {
            ERROR: {
                START_MONTH_BEFORE_END_MONTH: 'In variable {{item}} Start Month must be before End Month',
            },
            SUCCESS: {
                RUNNING: 'Excel report running',
            },
        },
        TITLE: {
            BROWSER: 'Budget Reports',
            NEW: 'New Budget Report',
        },
    },
    BUDGET_EXCEL_TEMPLATE: {
        FIELD: {
            ADD: 'Add Budget Excel Template',
            LATEST_VERSION: 'Latest Version',
            PERIOD_COUNT: 'Period Count',
            VERSIONS: 'Versions',
        },
        TITLE: {
            ADD_VERSION: 'Add Version',
            BROWSER: 'Budget Excel Template',
            BUDGET_TEMPLATE: 'Budget Template',
            EXAMPLE_EXCEL_TEMPLATE: 'Budget Template Example',
            NEW: 'New Budget Excel Template',
            NEW_EXCEL_TEMPLATE: 'New Excel Template',
            SAVE_FIRST: 'Save first to add versions!',
        },
    },
    BUDGET_EXCEL_TEMPLATE_SHARE: {
        FIELD: {
            PERMISSIONS: 'Permissions',
        },
        MESSAGE: {
            REMOVED_SUCCESS: 'Share with school successfully removed',
            SHARED_SUCCESS: 'Excel template was successfully shared with school',
        },
        TITLE: {
            SHARE_WITH: 'Share Template with ...',
        },
    },
    BUDGET_EXPENSES: {
        FIELD: {
            BUDGET_ACCOUNT: 'Budget Account',
            EXPENSE: 'Expense',
            FILTER: 'Code or Name of Account',
            TOTAL: 'TOTAL',
        },
        MESSAGE: {
            CONFIRM: {
                APPROVE: 'Do you want to approve this expenses?',
                CALCULATE: 'Do you want to calculate expenses according to formulas? All previous data will be lost!',
                CLEAR: 'Do you want to clear all values?',
                UNAPPROVE: 'Do you want to unapprove this expenses?',
            },
            ERROR: {
                HAS_ERROR: 'Some errors were found during approve, please resolve them',
                HAS_FORMULA_ERROR: 'Some formula errors found, please resolve them before saving',
                NEW_BUDGET_EXPENSES_FOUND: 'New Budget Expenses found',
            },
            SUCCESS: {
                SAVED: 'Budget expenses saved successfully',
            },
            WARNING: {
                SWITCH_TO_WEB_MODE: 'To make you comfortable, you need to switch to web mode',
            },
        },
        TITLE: {
            BROWSER: 'Budgets Expenses',
            BROWSER_WITH_PARAM: 'Budgets Expenses - {{param}}',
        },
    },
    BUDGET_EXPENSE_REQUEST: {
        ADD_ITEM: 'Add Item',
        BUTTON: {
            DECLINE: 'Decline',
        },
        CONFIRM_UPDATE_RESET: 'This request will be reset if you change items or cost center',
        ERROR: {
            ITEM_DUPLICATED: 'There is already Item with name "{{item}}"',
            ITEM_NOT_FILLED: 'There is Item not filled with name "{{item}}"',
        },
        FIELD: {
            APPROVED_AMOUNT: 'Approved Amount',
            EVENT_DATE: 'Date of Event',
            EVENT_SUMMARY: 'Event Summary',
            ITEM: 'Item',
            REQUEST: 'Budget Request',
            REQUEST_DATE: 'Date of Request',
            REQUESTED_AMOUNT: 'Amount Requested',
            REQUESTED_USER: 'Requested User',
            RESPONSE_TIME: 'Response Time',
            RESPONSIBLE_USER: 'Responsible User',
            TOTAL_APPROVED_AMOUNT: 'Total Approved Amount',
            TOTAL_REQUESTED_AMOUNT: 'Total Requested Amount',
        },
        INFO: 'Request Info',
        RESPONSE_STATUS: 'Status of Responses',
        TITLE: {
            BROWSER: 'Budget Requests',
            DECLINE_REASON: 'Decline Reason',
            NEW: 'New Budget Request',
        },
    },
    BUDGET_EXPENSE_REQUEST_CHAIN: {
        FIELD: {
            USERS_CHAIN: 'Users Chain for Request Approvement',
        },
        HINT: 'The approval process will be as ordered above',
        TITLE: {
            BROWSER: 'Expense Request Setup',
        },
    },
    BUDGET_EXPENSE_TRANSFER: {
        BUTTON: {
            DECLINE: 'Decline',
        },
        FIELD: {
            SOURCE_ACCOUNT: 'Source Account',
            SOURCE_COST_CENTER: 'Source Cost Center',
            TARGET_ACCOUNT: 'Target Account',
            TARGET_COST_CENTER: 'Target Cost Center',
            TRANSFER: 'Budget Expense Transfer',
            MONTH: 'Month',
        },
        MESSAGE: {
            CONFIRM: {
                APPROVE: 'Do you want to approve this transfer?',
                DECLINE: 'Do you want to decline this transfer?',
            },
            SUCCESS: {
                DECLINED: 'Budget expense transfer declined successfully',
            },
        },
        TITLE: {
            ADD: 'Add Budget Expense Transfer',
            BROWSER: 'Budget Expense Transfer',
            NEW: 'New Budget Expense Transfer',
        },
    },
    BUDGET_GENERAL: {
        FIELD: {
            ACCOUNT: 'Account',
            CARRY_OVER: 'Carry Over',
            FILTER: 'Code or Name of Account',
            TILL: 'Till Date',
        },
        MESSAGE: {
            CONFIRM: {
                APPROVE: 'Do you want to approve this accounts?',
                CALCULATE: 'Do you want to calculate accounts according to formulas? All previous data will be lost!',
                UNAPPROVE: 'Do you want to unapprove this accounts?',
            },
            ERROR: {
                AMOUNT_MUST_BE_EQUAL_TO_ZERO: 'Amount must be equal to zero',
                AMOUNT_MUST_NOT_BE_NEGATIVE: 'Amount cannot be negative',
                CREDIT_MUST_NOT_BE_POSITIVE: 'Credit account amount cannot be positive',
                DEBIT_MUST_NOT_BE_NEGATIVE: 'Debit Account amount cannot be negative',
                NEW_BUDGET_GENERALS_FOUND: 'New Budget Generals found',
            },
        },
        TITLE: {
            BROWSER: 'General Budget',
            BROWSER_WITH_PARAM: 'General Budget - {{param}}',
            IMPORT_BALANCE: 'Import General Budget Balance',
        },
    },
    BUDGET_GROUP: {
        ADD_CONSTANT: 'Add Parameter',
        CONSTANTS: 'Parameters',
        END_DATE: 'Budget Info Entering End Date',
        INFO: 'Budget Group Info',
        START_DATE: 'Budget Info Entering Start Date',
        BUDGET_GROUP_FROM: 'Copy from Budget Group:',
        TITLE: {
            ADD: 'Add Budget Group',
            BROWSER: 'Budget Groups',
            NEW: 'New Budget Group',
        },
    },
    BUDGET_INCOME: {
        MESSAGE: {
            CONFIRM: {
                APPROVE: 'Do you want to approve this incomes?',
                CALCULATE: 'Do you want to calculate incomes according to formulas? All previous data will be lost!',
                UNAPPROVE: 'Do you want to unapprove this incomes?',
            },
        },
        TITLE: {
            BROWSER: 'Budget Incomes',
            BROWSER_WITH_PARAM: 'Budget Incomes - {{param}}',
        },
    },
    BUDGET_INVESTMENT: {
        TITLE: {
            BROWSER: 'Budget Investments',
            BROWSER_WITH_PARAM: 'Budget Investments - {{param}}',
            FORM: 'Budget Investment',
        },
    },
    BUDGET_INVESTMENTS: {
        FIELD: {
            INVESTMENT: 'Investment',
        },
        MESSAGE: {
            CONFIRM: {
                APPROVE: 'Do you want to approve this investments?',
                CALCULATE:
                    'Do you want to calculate investments according to formulas? All previous data will be lost!',
                UNAPPROVE: 'Do you want to unapprove this investments?',
            },
            ERROR: {
                NEW_BUDGET_INVESTMENTS_FOUND: 'New Budget Investments Found',
            },
        },
    },
    BUDGET_PROJECTS: {
        FIELD: {
            HAS_DEADLINE: 'Has Deadline',
            PROJECT: 'Project',
            COPY_FROM: 'Copy from Budget Project',
        },
        TITLE: {
            BROWSER: 'Budget Projects',
            BUDGET_PROJECT: 'Budget Project',
            NEW: 'New Budget Project',
        },
    },
    BUDGET_SALARY: {
        MESSAGE: {
            CONFIRM: {
                APPROVE: 'Do you want to approve this budget salaries?',
                CALCULATE: 'Do you want to calculate salaries according to formulas? All previous data will be lost!',
                UNAPPROVE: 'Do you want to unapprove this budget salaries?',
            },
        },
        TITLE: {
            BROWSER: 'Salary Budget',
            BROWSER_WITH_PARAM: 'Budget Salaries - {{param}}',
        },
    },
    CALENDAR: {
        MONTH: {
            APR: 'April',
            AUG: 'August',
            DEC: 'December',
            FEB: 'February',
            JAN: 'January',
            JUL: 'July',
            JUN: 'June',
            MAR: 'March',
            MAY: 'May',
            NOV: 'November',
            OCT: 'October',
            SEP: 'September',
        },
        NEXT_YEAR: 'Next Year',
        NEXT_MONTH: 'Next Month',
        PREVIOUS_YEAR: 'Previous Year',
        PREVIOUS_MONTH: 'Previous Month',
        DATE_RANGE_PRESETS: {
            TODAY: 'Today',
            LAST_7_DAYS: 'Last 7 days',
            THIS_WEEK: 'This week',
            THIS_MONTH: 'This month',
            THIS_YEAR: 'This year',
            LAST_WEEK: 'Last week',
            LAST_MONTH: 'Last month',
            LAST_YEAR: 'Last year',
        },
        NAV: {
            MONTH: 'Month',
            WEEK: 'Week',
            DAY: 'Day',
            LIST: 'List',
            TODAY: 'Today',
            ADD: 'Add',
        },
    },
    CALENDAR_EVENT: {
        FIELD: {
            EVENT_TYPE: 'Event Type',
            DISPLAY_TO_STUDENT: 'Display note to student',
            MISSED_MINUTES: 'Missed (minutes)',
            CHART_TOTAL: '{{total}} out of {{grandTotal}}',
            MARK_OTHERS_AS: 'Mark Others As:',
            LESSON_TOPIC: 'Lesson Topic',
            TRAINING_PURPOSE: 'Learning Objectives',
            LESSON_PURPOSE: 'Lesson Objectives',
            LESSON_STEPS: 'Lesson Steps',
            LESSON_STEP: 'Lesson Step / Time',
            TEACHER_ACTION: 'Teacher Action',
            STUDENT_ACTION: 'Student Action',
            EVALUATION: 'Evaluation',
            RESOURCE: 'Resource',
            LESSON_PLAN: 'Lesson Plan',
        },
        BUTTON: {
            BULK_CHANGE: 'Bulk Change',
            ADD_LESSON: 'Add Lesson',
            GOOGLE_CALENDAR: 'Google Calendar',
            NEW_GOOGLE_CALENDAR: 'New Google Calendar',
            GOOGLE_MEET: 'Google Meet',
        },
        TITLE: {
            NEW_EVENT_TYPE: 'Type of New Event',
            NEW_CUSTOM_EVENT: 'New Event',
            CUSTOM_EVENT: 'Event',
            ATTENDANCE_NOT_SAVED: 'No attendance records have been taken for this course(s) or student(s)!',
            DAILY_ATTENDANCE_NOT_SAVED: 'No daily attendance have been taken for the student',
            NOT_SAVED_ATTENDANCES: '{{size}} student not attendance record has been taken!',
            PRESENT: 'Present',
            TARDY: 'Tardy',
            PERMITTED: 'Permitted',
            EXCUSED: 'Excused',
            ABSENT: 'Absent',
            CANCELED: 'Canceled',
            TOTAL_LESSONS: 'Total Lesson',
            TOTAL_ATTENDANCE: 'Total Attendance',
            TOTAL_STUDENTS: 'Total Students',
            TOTAL_COURSES: 'Total Courses',
            CREATE_NEW_LESSON: 'Create New Course Event',
            NOTIFY_ABOUT_LESSON: 'Notify students about lesson',
            DELETE_LESSON: 'Do you want to delete this course event?',
            EVENT_WITH_PARAM: 'Event - {{param}}',
            RELATED_SYLLABUS_TOPICS: 'Related Syllabus Topics',
            TODAYS_LESSONS: "Today's Lessons",
            FILE_NOT_SAVED: 'File not Saved!',
            PLANNED: 'Planned',
            COMPLETED: 'Completed',
            SYNC_WITH_GOOGLE: 'Sync Google Calendar?',
        },
        MESSAGE: {
            HAVE_NEW_EVENT: 'You have a new event. Please check your calendar',
            CANCELED: 'Event is canceled.',
        },
    },
    CHANGE_PASSWORD: {
        TITLE: {
            DIALOG: 'Change Password',
        },
    },
    CITIZENSHIP: {
        TITLE: {
            ADD: 'Add Citizenship',
            BROWSER: 'Citizenships',
            NEW: 'New Citizenship',
        },
    },
    CITY: {
        TITLE: {
            ADD: 'Add City',
            ALL: 'All',
            BROWSER: 'Cities',
            EDIT: 'City',
            NEW: 'New City',
        },
    },
    CONSTRAINTS: {
        TITLE: {
            BROWSER: 'Constraints',
            AVAILABLE: 'Available',
            NOT_AVAILABLE: 'Unavailable',
            CONDITIONAL: 'Conditional',
        },
    },
    COST_CENTER: {
        ERROR: {
            CONSTANT_KEY_DUPLICATED: 'There is already parameter with key "{{item}}"',
            NEW_CONSTANT: 'New Parameter',
        },
        FIELD: {
            CONSTANTS: 'Parameters',
            COST_CENTER: 'Cost Center',
            ORDER_NO: 'Order No',
            COPY_FROM: 'Copy from Cost Center:',
        },
        TITLE: {
            ADD: 'Add Cost Center',
            BROWSER: 'Cost Centers',
            NEW: 'New Cost Center',
            NEW_CONSTANT: 'New Parameter',
        },
    },
    COURSE: {
        TITLE: {
            ADD: 'Add Course',
            BROWSER: 'Courses',
            NEW: 'New Course',
            EDIT: 'Course',
            SYNC_WITH_GOOGLE_CLASSROOM: 'Sync Classroom™',
            ASSIGN_COURSES: 'Enroll Courses',
            ASSIGN_COURSES_TO_SELECTED_STUDENTS: 'Enroll Selected Students to Courses',
            STUDENT_COURSES: 'Student Courses',
            STUDENT_COURSE_PAGE: 'Student Course Page',
            ASSIGN_COURSE: 'Enroll Course',
            COURSE_EVENT_HISTORY: 'History',
            ADD_GROUP: 'Add Group',
            NEW_GROUP: 'New Group',
            EDIT_GROUP: 'Group',
            GROUP: 'Group',
            COURSE_EVENT: 'Course Event',
            GRADING_DISABLED: 'Grading is disabled. Please contact your system administrator!',
            COURSE_LESSONS: 'Course Lessons',
            COURSE_LESSONS_WITH_PARAM: '{{param}} - Course Lessons',
            LESSON: 'Lesson',
            ASSIGNED_LESSONS: 'Assigned Lessons',
            ASSIGN_LESSONS_FROM_SYLLABUS: 'Assign Lessons from Syllabus',
            ASSIGN_LESSON: 'Assign Lesson',
            COURSE_CHAT: 'Course Chat',
            COURSE_STUDENTS: 'Course Students',
            COURSE_OVERVIEW: 'Course Overview',
            REMOVE_STUDENT_FROM_COURSE: 'Remove From Course',
            COURSE_MATERIALS_CREATED: 'Total Amount of Course Materials Created',
            COURSE_MATERIALS_BREAKDOWN: 'Course Materials Breakdown',
            MATERIALS: 'Contents',
            COURSE_SETTINGS: 'Course Settings',
            INCLUDE_TO_GPA: 'Include to GPA',
            INCLUDE_TO_TRANSCRIPT: 'Include to Transcript',
            SELF_ENROLLMENT: 'Enable Self Enrollment',
            REGISTRATION_OPEN: 'Registration Open',
            DELETE_SELECTED_STUDENTS: 'Delete selected Students',
            COURSE_SYNCHRONIZED: 'Course synchronized successfully',
            GRADE_DISABLED: 'Grading disabled',
            CHANGE_ENROLLMENT_DATE: 'Change Enrollment Date',
            CLASSROOM_COURSES: 'Classroom Classes',
            CLASSROOM_CREATE_NEW_OR_SELECT: 'Create New One or Select From Existing',
            CLASSROOM_CREATE_NEW: 'Create New One',
            CLASSROOM_ASSIGNMENTS: 'From Classroom Assignment',
            CLASSROOM_SEND_INVITATION: 'Send Classroom Invitation Mail',
            CLASSROOM_LINK: 'Classroom Link ™',
            BULK_OPS: 'Bulk Changes',
        },
        FIELD: {
            PRIMARY_TEACHER: 'Primary Teacher',
            SECONDARY_TEACHER: 'Secondary Teacher',
            TEACHERS: 'Teachers',
            REPORT_CARD_DESCRIPTION: 'Report Card Description',
            INFO: 'Information',
            LOCATION: 'Location',
            LESSONS_PER_WEEK: 'Number of Lessons per Week',
            MAX_LESSONS_PER_DAY: 'Maximum Number of Lessons per Day',
            BBB_SETTINGS_NOT_EXISTS:
                'Since Online Education Settings does not exists, you can not save online course. Please contact your system administrator!',
            REGENERATE: 'Regenerate Course Event',
            SHOW_ALL_COURSES: 'Show All',
            DELETE_ALL_EXISTING_COURSES:
                'Delete previous course events if they exist (course events, attendance records, meetings)',
            EVENT_FROM: 'Event Created From',
            EVENT_TO: 'Event Created To',
            GENERATE_COURSE_EVENT: 'Generate Course Event',
            DELETE_COURSE_EVENT: 'Delete Course Event',
            GENERATE: 'Generate',
            COURSE_OF: 'Course of',
            GROUPS: 'Groups',
            STUDENTS_SIZE: 'Number of Students',
            SHOW_ALL_STUDENTS: 'Show All Students',
            COURSE_DESCRIPTION: 'Course Description',
            AVATAR_IMAGE: 'Course Avatar Image',
            SINGLE_USER_SESSION: 'Single User Session',
            CREDIT: 'Credit',
            GRADING_PERIOD: 'Grading Period',
            COURSE_DURATION: 'Course Duration Throughout',
            GPA_SCALE_LENGTH: 'GPA Scale Length',
            ALLOW_CHANGE_TERM_GRADE: 'Allow to Change Term Grade',
            ALLOW_GRADING_AFTER_DUE_DATE: 'Grading Permission',
            ALLOW_ALL_LESSONS_GRADING: 'Allow All Courses',
            ALLOW_CHANGE_GRADING: 'Allow to Change Grading?',
            EXCLUDE_FROM_GPA: 'Exclude from GPA',
            EXCLUDE_FROM_TRANSCRIPT: 'Exclude From Transcript',
            EXCLUDE_FROM_CLASS_RANK: 'Exclude From Course Rank',
            EXCLUDE_FROM_HONOR_ROLL: 'Exclude From Honor Roll',
            EXCLUDE_FROM_REPORT_CARD: 'Exclude From Report Card',
            COPY_WITH_SYLLABUS: 'Copy With Syllabus',
            HIDE_SYLLABUS_FROM_REPRESENTATIVES: 'Hide Syllabus from Parents',
            MAX_ENROLLED_STUDENT_COUNT: 'Max Enrolled Student Count',
            MAX_APPLICATION_COUNT: 'Max Application Count',
            SELF_ENROLLMENT_STATUS: 'Show Status on Course Dashboard',
            ENROLL_AUTOMATICALLY: 'Automatically Enrollment',
            REGISTRATION_STATUS: 'Registration Status',
            EXCLUDE_OVERDUE_ASSIGNMENTS_IN_SYLLABUS_PROGRESS: 'Exclude Overdue Syllabus Progress',
            GRADE_MULTIPLIER: 'Grade Multiplier',
            GRADE_MULTIPLIER_INFO: 'For Weighted GPA calculation',
            ARCHIVED: 'Archived',
        },
        MESSAGE: {
            CONFIRM_REMOVE_STUDENT_FROM_COURSE: 'Do you want to remove all marked students from the selected course?',
            STATUS_REMOVE_STUDENT_FROM_COURSE: 'All the marked student removing from the course.',
            CONFIRM_DELETE: 'Do you want to delete all the generated course events for this period?',
            CONFIRM_DELETE_GENERATION:
                'Do you want to delete all previously generated course events and generate them again?',
            CONFIRM_GENERATION:
                'Do you want to generate Course Timetable Events? Previous generated and not published course events will be deleted!',
            CONFIRMATION_COPY: 'Are you sure to create a new course using this course?',
            SUCCESS_REGENERATED: 'Course Timetable Events successfully regenerated',
            ALERT_TEXT_BEFORE_ASSIGN: 'Course will not be added if student already has it',
            COURSE_EVENT_GENERATED: 'Course timetable events successfully generated',
            TIME_TABLE_IS_NOT_ACTIVE: 'To generate course event time table must be active',
            TIME_PERIOD_IS_NOT_ACTIVE: 'To generate course event time period must be active',
            ACADEMIC_PERIODS_NOT_FOUND: 'Academic periods not found',
            GROUP_NAME_DUPLICATED: 'Group Name "{{item}}" already exists',
            COURSE_EVENT_GENERATED_LOADING: 'Please wait while creating the course events...',
            SINGLE_USER_SESSION_DESCRIPTION:
                'Student cannot join meeting with two or more devices. *If user leaves meeting, he(she) can join that meeting only after 1 minute',
            CONFIRM_ALLOW_ALL_COURSES_GRADING:
                'Are you sure you want to allow all courses grading after grading due date for selected teacher?',
            GRADING_NOT_ENABLED: 'Grading is not enabled.',
            CONFIRM_COMPLETE_SELF_ENROLLMENT: 'Are you sure you want to complete selected registration applications?',
            CONFIRM_CANCEL_SELF_ENROLLMENT: 'Are you sure you want to cancel selected registration applications?',
            NOT_ASSIGNED_TO_CLASS: 'Course is not assigned to class',
            GRADE_DISABLED: 'Grading is disabled in this course',
            DELETE_STUDENTS: 'Are you sure to delete these selected students from this course?',
            COURSE_IMAGE_HINT: 'Photo ratio should be 3:2 (600 x 400 px)',
            UNENROLL_WARNING: 'After unenroll from course all grades and assignment submissions will be deleted.',
            TRANSFER_CONFIRMATION: 'Do you want to transfer student to another course with grades?',
            UNENROLL_WITHOUT_TRANSFER: 'No transfer, just remove from course',
            UNENROLL_TRANSFER_WITHOUT_GRADES: 'Transfer without grades',
            UNENROLL_TRANSFER_WITH_TERM_GRADES: 'Transfer only Term Grades(Assignments and Term Results)',
            UNENROLL_TITLE: 'Unenroll from Course',
            UNENROLL: 'Unenroll',
            SELECT_ENROLL_DATE: 'Select student course enrollment date',
            UNENROLL_WARNING_MESSAGE:
                'When you unenroll a student from a course, you will not have access to assignments, grades and attendance information for that course. If you want to move these information to another course, please use the course registration (Education -> Setup -> Courses).',
        },
        ERROR: {
            THE_SAME_TEACHERS: 'First Teacher and Second Teacher must be different',
            EMPTY_STUDENT: 'Course has no enrolled students yet',
            MUST_BE_SHORTER_THAN_NAME: '* Must be shorter than name',
        },
    },
    COURSE_CONTENT: {
        FIELD: {
            COURSE_CONTENT: 'Course Content',
            DESCRIPTION: 'Course Description',
            NAME: 'Name',
        },
        MESSAGE: {
            CONFIRM: {
                DELETE: 'Do you want to delete Course Content?',
            },
        },
        TITLE: {
            ADD: 'Add Course Content',
            BROWSER: 'Course Content',
            NEW: 'New Course Content',
        },
    },
    STUDENT_TRANSCRIPT: {
        TITLE: {
            COURSE_GRADE: 'Course Grade',
            POINT_AND_CREDIT: 'Point : {{point}}, Credit : {{credit}}',
        },
        FIELD: {
            GRAND_TOTAL_CREDIT: 'Total Credits/ECTS',
            GRAND_GRADE_AVERAGE: 'Grand Grade Average',
            GRAND_GPA: 'Grand GPA',
            COURSE_CODE: 'Course Code',
            COURSE_NAME: 'Course Name',
            CREDIT: 'Credits',
            CREDIT_EARNED: 'Credit Earned',
            CREDIT_ATTEMPTED: 'Credit Attempted',
            GRADE: 'Grade',
            LETTER_GRADE: 'Letter Grade',
            POINT: 'Point',
            GPA: 'GPA',
            SPA: 'SPA',
            TRADITIONAL: 'Description',
            GRADE_AVERAGE_IN_PERCENT: 'Grade Average in Percent',
            GRADE_POINT_AVERAGE: 'Grade Point Average',
            SEMESTER_AVERAGE_IN_PERCENT: 'Semester Average in Percent',
            SEMESTER_POINT_AVERAGE: 'Semester Point Average',
            WEIGHTED_GRAND_GRADE_AVERAGE: 'Weighted Grade Average',
            WEIGHTED_GRAND_GPA: 'Weighted GPA',
        },
    },
    COURSE_MODERATOR_ATTENDANCE: {
        TITLE: {
            BROWSER: 'Course Moderator Attendance',
        },
        ERROR: {
            INVALID_RANGE_VALUE: 'Invalid range value',
        },
    },
    COURSE_PLAN: {
        FIELD: {
            COURSE_PLAN: 'Course Plan',
        },
        MESSAGE: {},
        TITLE: {
            ADD: 'Add Course Plan',
            BROWSER: 'Course Plan',
            NEW: 'New Course Plan',
            EDIT: 'Course Plan',
        },
    },
    COURSE_SCHEDULE: {
        FIELD: {
            COURSE_SCHEDULE_OF: 'Course Timetable of',
            NOT_SELECTED: 'Not Selected',
            TEACHER: 'Teacher',
        },
        TITLE: {
            BROWSER: 'Course Timetable',
        },
        MESSAGE: {
            GENERATE_TIMETABLE: 'You should regenerate Timetable to see changes!',
            COURSE_EXISTS: 'This course already exists at this period',
        },
    },
    COUNTRY: {
        TITLE: {
            ADD: 'Add Country',
            BROWSER: 'Countries',
            EDIT: 'Country',
            NEW: 'New Country',
            HAS_STATE: 'State Exists',
        },
    },
    COURSE_MODERATORS: {
        FIELD: {
            ADD_MODERATOR: 'Add Teacher',
            CHANGE_MODERATOR: 'Substitute Teacher',
            REMOVE_MODERATOR: 'Remove Teacher',
            DATE_RANGE: 'Date Range',
            AVAILABLE_MODERATORS: 'Available Teacher(s)',
            CURRENT_MODERATORS: 'Current Teacher(s)',
            ONLY_FREE_MODERATORS: 'Only Available Teachers',
        },
        MESSAGE: {
            ADD_MODERATOR:
                'You can add a new teacher only if he/she is not a primary teacher or secondary teacher of selected courses!',
            REMOVE_MODERATOR: 'You can remove a teacher only if he/she is not a primary teacher of selected courses!',
            SUCCESSFULLY_ADDED: 'Teacher successfully added',
            SUCCESSFULLY_CHANGED: 'Teachers successfully changed',
            SUCCESSFULLY_REMOVED: 'Teacher successfully removed',
        },
    },
    CUSTOM_FIELD_GROUP: {
        TITLE: {
            ADD: 'Add Custom Field Group',
            BROWSER: 'Custom Field Groups',
            EDIT: 'Custom Field Group',
            NEW: 'New Custom Field Group',
        },
        FIELD: {
            COLUMN_SIZE: 'Column Size',
        },
    },
    DATABASE_FILE: {
        FIELD: {
            UPLOAD_DATE: 'Upload Date',
            SIZE_FROM: 'Size(KB) From',
            SIZE_TO: 'Size(KB) To',
        },
    },
    GRADEBOOK: {
        BUTTON: {
            GRADING_MAP: 'Grading Map',
            BULK_GRADING: 'Bulk Grading',
            TRANSFER_GRADES: 'Transfer Grades',
        },
        FIELD: {
            GRAND_TOTAL: 'Grand Total',
            SELECTED_STUDENT_GRADE: 'Selected Student Grade',
            OLD_GRADE: 'Old Grade',
            UPDATED_GRADE: 'Updated Grade',
            EVALUATE_BY_POINTS: 'Evaluate by Points',
            HIDE_REMOVED_STUDENTS: 'Hide In-Active Students',
            FROM_ASSIGNMENT: 'From Assignment',
            TO_ASSIGNMENT: 'To Assignment',
            FROM_COURSE: 'From Course',
            TO_COURSE: 'To Course',
            FROM_PERIOD: 'From Period',
            TO_PERIOD: 'To Period',
            TRANSFER_ONLY_TERM_GRADES: 'Transfer only Term Grades',
            ENABLE_TRANSFER: 'Enable Transfer',
        },
        MESSAGE: {
            CONFIRM: {
                CLEAR: 'Do you want to clear all changes?',
                DELETE_ASSIGNMENT: 'Do you want to delete custom grades?',
                DELETE_GRADE: 'Are you sure you want to delete this grade?',
                SAVE: 'You will not be able to see grades history. Do you want to save all changes?',
                REFRESH_CANCEL_CHANGES:
                    'You should save the grades that you entered, otherwise the changes will be canceled. Do you want to continue?',
                COPY_ASSIGNMENTS: 'Do you want to copy assignments?',
            },
            EMPTY: 'empty',
            ERROR: {
                GRADE_MIN_CHECK: 'Grade value you have entered cannot be less than {{param}}',
                GRADE_MAX_CHECK: 'Grade value you have entered cannot be bigger than {{param}}',
                SELECT_ASSIGNMENT: 'Please select at least one assignment',
            },
            IMPORTED_GRADE: 'The grade was transferred from another school.',
            UNENROLLED_FROM_COURSE: 'Un enrolled from course',
            RESULT_NOT_PUBLISHED:
                'This assignment results have not published yet. To see results in gradebook, please click the column header  to publish results from menu.',
            RESULT_NOT_PUBLISHED_ASSIGNMENT:
                'This assignment results have not published yet. To see results in gradebook, please publish results in assignment page.',
            REVERT: 'Revert to: ',
            SUCCESS: {
                CUSTOM_ASSIGNMENT_ADDED: 'Custom grades successfully added',
                CUSTOM_ASSIGNMENT_DELETED: 'Custom grades successfully deleted',
                CUSTOM_ASSIGNMENT_UPDATED: 'Custom grades successfully updated',
                GRADES_CHANGED: 'Grades successfully changed',
                GRADES_TRANSFERRED: 'Grades successfully transferred',
                ASSIGNMENTS_COPIED: 'Assignments copied successfully',
            },
            WARNING: {
                GRADING_NOT_ENABLED: 'In selected course grading is not enabled',
            },
            INFO: {
                ASSIGNMENT_COPY_INFO:
                    '*The due date for copied assignments will be automatically set to the start of the selected period(s) and will be assigned to all course students',
            },
        },
        TITLE: {
            BROWSER: 'Gradebook',
            CUSTOM_ASSIGNMENT: 'Custom Grades',
            DELETE_ASSIGNMENT: 'Delete Custom Grades',
            NEW_CUSTOM_ASSIGNMENT: 'New Custom Grades',
            REFRESH_CANCEL_CHANGES: 'Your changes will be canceled',
            STUDENT_GRADE: 'Student Grade',
            AVERAGE_COURSE_GRADE: 'Average Course Grade',
            MAX_COURSE_GRADE: 'Max Course Grade',
            MIN_COURSE_GRADE: 'Min Course Grade',
            SELECET_GRADE_CHART: 'Select Grade Chart',
            STUDENT_PLACE: 'Student Place in Course',
            GRADE_PLACE: 'Grade Place in Course',
            COURSE_TERM_GRADE: 'Course Term Grades',
            CHANGES_HISTORY: 'History of Changes',
            GRADE_ATTENDANCE_DATE_RANGE: 'Calculate Lesson Attendance for the following Date Range',
            ATTENDANCE_GRADING_TYPE: 'Calculate Grade by',
            MAX_POINT_HINT:
                "Set 'Max Point' for the highest possible score. Ex: Max. Point = 10, given Point = 9, Grade => 9/10 => 90%",
            TRANSFER_GRADES_FOR: 'Transfer Grades for: ',
        },
    },
    GRADE_CATEGORY: {
        TITLE: {
            BROWSER: 'Grade Templates',
            ADD: 'Add Grade Template',
            NEW: 'New Grade Template',
            EDIT: 'Grade Template - {{param}}',
            ADD_GRADE_CATEGORY: 'Add Grade Category',
            ADD_PARENT_TEMPLATE: 'Add Parent Category',
            ADD_CHILD_GRADE_CATEGORY: 'Add Child Grade Category',
            ADD_TERM_WEIGHT: 'Add final grade period',
            CHILD_GRADE_CATEGORY: 'Child Grade Category',
            GRADE_CATEGORIES_TEMPLATE: 'Grade Template',
            FINAL_GRADE_TEMPLATE: 'Final Grade Category',
            FINAL_GRADE_PERIOD: 'Final Grade Period',
            GRADE_CATEGORY: 'Period Grade Category',
            GRADE_CATEGORIES: 'List of Grade Categories',
            TERM_WEIGHT_FOR: 'Weight for Term/Period',
            TERM_WEIGHTING: 'Term Weighting',
            WEIGHT_BY_SEMESTER: 'Grade Category weight by a semester',
            WEIGHT_BY_QUARTER: 'Grade Category weight by a quarter',
            CHOOSE_TEMPLATE_TYPE: 'Choose Template Type',
        },
        FIELD: {
            GRADE_MIN: 'Minimum Grade',
            GRADE_MAX: 'Maximum Grade',
            GRADE_PASS: 'Pass Grade',
            PRECISION: 'Precision',
            AGGREGATION_METHOD: 'Aggregation Method',
            FORMULA: 'Formula',
            KEEP_ONLY_X_HIGHEST: 'Keep Only X Highest',
            DROP_THE_X_LOWEST: 'Drop The X Lowest',
            WEIGHT: 'Weight',
            AGGREGATE_ONLY_GRADED: 'Aggregate Only Graded',
            HIDE: 'Hide',
            HIDE_UNTIL: 'Hide Until',
            BLIND_MARKING: 'Blind Marking',
            PUBLIC_TEMPLATE: 'Public Template',
            TEMPLATE_NAME: 'Template Name',
            PARENT_CATEGORY_NAME: 'Parent Grade Category Name',
            ENABLE_GRADING: 'Enable Grading',
            CALCULATED_WEIGHT: 'Calculated Weight',
            AUTO_CALCULATE_WEIGHT: 'Auto Calculate Weight',
            TOTAL_WEIGHT: 'Total Weight',
            ROUNDING: 'Rounding',
            BEST_GRADE: 'Best Grade',
            CALCULATION_TYPE: 'Child Category Calculation',
            DISPLAY_IN_TERM_REPORT: 'Display in Term Report',
            TERM_REPORT_ORDER: 'Term Report Order',
            GRADING_TYPE: 'Grading Type',
        },
        MESSAGE: {
            NAME_DUPLICATED: 'Grade Category with name "{{item}}" already exists',
            FINAL_GRADE_NAME_DUPLICATED: 'Final Grade with name "{{item}} already exists',
            GRADE_CATEGORY_EMPTY: 'Please, add at least one grade category',
            MAX_GRADE_LESS_THAN_MIN_GRADE: 'Maximum Grade cannot be less than Minimum Grade',
            MAX_GRADE_LESS_THAN_PASS_GRADE: 'Maximum Grade cannot be less than Pass Grade',
            PASS_GRADE_LESS_THAN_MIN_GRADE: 'Pass Grade cannot be less than Minimum Grade',
            WEIGHT_WRONG: 'The weight is incorrect. The weight can be maximum {{item}}',
            TOTAL_WEIGHT_WRONG: 'The Total Weight of Child Categories of the {{ item}} is not 100',
            TOTAL_WEIGHT_MUST_BE_100: 'Total Weight of Child Categories always must be 100',
            TERM_WEIGHT_MUST_BE_100: 'Total Term weighting always must be equal to 100',
            TERM_WEIGHT_MUST_NOT_EXCEED_100: 'Total Term weight must not exceed 100',
            FINAL_GRADE_ORDERS_CAN_NOT_BE_REPEATED: 'Final grade order cannot repeated',
            NO_FINAL_GRADE_CATEGORY:
                'Selected grade category template does not contain Final Grade template. Please create them under the Grade category template settings.',
        },
    },
    GRADING_ALLOWANCE_AFTER_DUE_DATE: {
        FIELD: {
            ALLOWANCE_COURSES_COUNT: 'Permitted Courses Count',
            GRADING_AFTER_DUE_DATE_ALLOWANCE: 'Grading Permission',
        },
        MESSAGE: {
            COURSES_ALLOWED: 'Permitted courses: {{item}} ',
            ALLOW_GRADING_COURSES: 'You can allow grading for these courses',
            ALREADY_ALLOWED: '{{item}} has already permission for the selected academic period.',
            ALL_GRADING_ALLOWANCE: 'Grading permissions updated',
            HINT_TEACHER_SELECTION:
                'You can search teachers by name, middle name, last name, employee id number. Please select specific academic year or period and course that you want to allow grading after grading due date time for selected teacher.',
        },
    },
    GRADING_MAP: {
        FIELD: {
            ICON: 'Icon',
        },
        TITLE: {
            GRADING_MAP: 'Grading Map',
        },
    },
    GRADING_SCHEME: {
        TITLE: {
            NEW_GRADE_RANGE: 'New Grade Range',
            GRADE_RANGES: 'Grade Ranges',
            GRADE_RANGE: 'Grade Range',
            GRADING_SCHEME: 'Grading Scheme',
            NEW_GRADING_SCHEME: 'New Grading Scheme',
            ADD_GRADING_SCHEME: 'Add Grading Scheme',
            ADD_GRADE_RANGE: 'Add Grade Range',
            WEIGHT_RANGE: 'Range',
            AND: '{{item1}} and {{item2}}',
            AND_LESS: '{{item1}} and less than or equal {{item2}}',
            RANGE_NAME_EXISTS: 'Grade Range with the grade {{item}} already exists',
            WEIGHT_FROM_BIGGER_THAN_WEIGHT_TO: 'Range From cannot be bigger than Range To',
            WEIGHT_FROM_MUST_BE_BIGGER: 'Range From must be bigger than {{item}}',
            FILL_GRADE_RANGES_IN_DESCENDING:
                '* Please fill the table so that the grade ranges are in descending order, for example 90-100, 80-90 and so on.',
            POINT_MUST_BE_BIGGER: 'Point must be bigger than {{item}}',
            POINT_MUST_BE_LESS: 'Point must be less than {{item}}',
            FILL_POINT: 'Please, fill the point for the grade {{item}}',
            FILL_POINT_IN_DESCENDING:
                '* Please fill the table so that the point are in descending order, for example 4.0, 3.5, 3.0  and so on.',
        },
        FIELD: {
            GRADE: 'Grade',
            GRADE_DESCRIPTION: 'Grade Description',
            RANGE_FROM: 'Range From (Included. Ex:2)',
            RANGE_TO: 'Range To (Included. Ex:3.99)',
            SIMPLE_TEXT: 'Simple Text',
            ENABLE_POINT: 'Enable points for Credit System',
            COEFFICIENT: 'GPA Coefficient',
            DEFAULT_TERM_GRADE_NOTES: 'Default Term Grade Notes',
        },
        MESSAGE: {
            ADD_GRADE_RANGE: 'Empty grade ranges not allowed. Add grade range',
        },
    },
    GRADE_EXCUSE_TYPE: {
        TITLE: {
            GRADE_EXCUSE_TYPE: 'Grade Excuse Type',
            NEW_GRADE_EXCUSE_TYPE: 'New Grade Excuse Type',
            HIDE_COMMENT_FROM_STUDENT: 'Hide Comment from Student',
            DISABLED_TYPE_HINT: '* For disabled types you should contact with your tenant admin(s).',
        },
        FIELD: {
            AFFECT_TO_TOTAL: 'Affect to Total',
            AFFECT_TO_TOTAL_TOOLTIP: 'If enabled, there will be grade field and it will affect to total grade',
            MANUAL: 'Manual',
            SYSTEMIC: 'Systemic',
        },
    },
    MEETINGS: {
        TITLE: {
            RECORDING: 'Recording',
            MARK_RECORDINGS: 'Mark Recording as Watched',
            MARKED_RECORDINGS: 'Recording is Watched',
            REFRESH_RECORDINGS: 'Refresh Recordings',
            MEETING_RECORDINGS: 'Recordings',
            RECORDING_READY: 'Meeting Recording Ready',
            INFO: 'Meeting Information',
            ADD: 'Add Meeting',
            BROWSER: 'Meetings',
            CHANGE_TOPIC: 'Change Topic',
            COURSE_MEETING: 'Course Meeting',
            EDIT: 'Edit Meeting',
            NEW: 'New Meeting',
            JOIN: 'Join Meeting',
            JOIN_WITH_PARAM: 'Join Meeting - {{param}}',
            JOIN_SHORT: 'Join',
            JOIN_SHORT_ATTENDEE: 'Join',
            JOIN_SHORT_MODERATOR: 'Start',
            END: 'End Meeting',
            END_SHORT: 'End',
            CANCEL: 'Cancel',
            CANCEL_SHORT: 'Cancel',
            ATTENDEES: 'Attendees',
            MODERATORS: 'Moderators',
            ADD_ATTENDEES: 'Add Attendees',
            ADD_MODERATORS: 'Add Moderators',
            MEETING: 'Meeting',
            SETTINGS: 'Settings',
            ATTACHMENT: 'Attachment',
            ATTENDANCE_DURATION: 'Duration',
            DURATION: 'Duration',
            JOIN_TIME: 'Join Time',
            LEFT_TIME: 'Leave Time',
            ATTENDED: 'Attended',
            MESSAGE_TO_ATTENDEES: 'Message to Attendees',
            MESSAGE_TO_TEACHERS: 'Message to Teachers',
            ALL_ATTENDEES: 'All Attendees',
            ALL_MODERATORS: 'All Moderators',
            ALL_TEACHERS: 'All Teachers',
            START_LESSON: 'Start',
        },
        FIELD: {
            MEETING_ID: 'Meeting ID',
            STATUS: 'Status',
            STATUS_RUNNING: 'Running',
            STATUS_STOPPED: 'Stopped',
            NAME_USERNAME_OR_EMAIL: 'Name, Username or E-mail',
            START_TIME: 'Start Time',
            END_TIME: 'End Time',
            UNLIMITED_DURATION: 'Unlimited',
            GET_ATTENDANCE: 'From Prev. Lesson',
            ENABLE_ATTENDANCE: 'Enable Attendance',
            EXTRA_MEMBERS: 'Extra Members',
            URL: 'URL',
        },
        BUTTONS: {
            ADD_ROLE: 'Add Role',
            ADD_CLASS: 'Add Class',
            ADD_COURSE: 'Add Course',
            ADD_USER: 'Add Users',
            GIVE_PERMISSION_FOR_RECORDING: 'Permission for Watch Recording',
            SEND_MESSAGE: 'Message',
            DELETE_RECORDING: 'Delete Meeting Recording',
            HIDE_RECORDING: 'Hide Meeting Recording',
            SHOW_RECORDING: 'Show Meeting Recording',
        },
        MESSAGES: {
            MEETING_DURATION_CHANGED_TO_UNLIMITED: 'Meeting duration changed to unlimited time',
            MEETING_DURATION_CHANGED_TO_LIMITED: 'Meeting duration changed to fixed time',
            COURSE_MEETING_NOT_CREATED: 'Course Meeting has not been started yet',
            GET_PREVIOUS_LESSON_ATTENDANCE: 'Are you sure to get Students attendance from previous Lesson',
            ATTENDANCE_SUCCESSFULLY_GOTTEN: 'Attendance has gotten successfully',
            ATTENDANCE_NOT_FOUND:
                'There is no previous lesson attendance information for today. You need to enter attendance information manually.',
            CONFIRM_COURSE_MEETING_END: 'Are you sure you want to end this meeting?',
            CONFIRM_COURSE_MEETING_CANCEL: 'Are you sure you want to cancel this {{item}}?',
            CONFIRM_COURSE_MEETING_JOIN: 'Do you want to join meeting?',
            CONFIRM_PASSED_COURSE_MEETING_JOIN: 'The meeting has expired. Are you sure you want to join it anyway?',
            START_MEETING_WITHOUT_PRESENTATION:
                'The presentation was not uploaded.<br>To start meeting with the presentation, firstly upload it in attachments.<br><br>Do you want to start the meeting anyway?',
            RECORDING_DELETE_CONFIRM: 'Do you want to delete meeting recording of {{item}}?',
            RECORDINGS_DELETE_CONFIRM: 'Do you want to delete meeting recordings?',
            REJOIN_CONFIRM_MESSAGE: 'This meeting has been ended. Do you want to rejoin?',
            REVOKE_CANCELED_MEETING_MESSAGE: 'Do you want to publish already canceled {{item}}?',
            CHANGE_MEETING_RECORDING_WATCH_STATUS_CHANGE_TO_SHOW:
                'The meeting recordings hidden from attendees! Do you want to `show` recordings?',
            CHANGE_MEETING_RECORDING_WATCH_STATUS_CHANGE_TO_HIDE:
                'The meeting recordings can viewed by attendees! Do you want to `hide` recordings?',
            NO_RUNNING_MEETING: 'There are no running meetings to join',
            TODAY_COURSE_EVENTS: "Today's course events",
            CAN_START_MEETING: 'You can start meeting',
            SEVERAL_MEETINGS: 'There are several running meetings, select one of them to join',
            NO_MEETING: 'No meeting',
        },
    },
    CRON_JOB: {
        MESSAGE: {
            TEST_PASSED: 'Cron text is correct',
            TEST_FAILED: 'Cron text is not correct',
        },
        TITLE: {
            AND_HOUR: 'and hour',
            AND_MINUTE: 'and minute',
            AND_MONTH: 'and',
            ANY_YEAR: 'Any year',
            BROWSER: 'Scheduler',
            DAILY: 'Daily',
            DAYS_BEFORE_AND_OF_MONTH: 'day(s) before the end of the month',
            DAYS_STARTING_AT: 'day(s) starting on the',
            DAYS_STARTING_ON: 'day(s) starting on',
            EVERY: 'Every',
            EVERY_DAY: 'Every day',
            EVERY_HOUR: 'Every hour',
            EVERY_HOUR_BETWEEN: 'Every hour between hour',
            EVERY_MINUTE: 'Every minute',
            EVERY_MINUTE_BETWEEN: 'Every minute between minute',
            EVERY_MONTH: 'Every month',
            EVERY_MONTH_BETWEEN: 'Every month between',
            EVERY_YEAR_BETWEEN: 'Every year between',
            HOUR: 'hour(s)',
            HOURLY: 'Hourly',
            HOURS_STARTING_AT: 'hour(s), starting hour:',
            LAST_DAY_OF_MONTH: 'On the last day of month',
            LAST_WEEKDAY_OF_MONTH: 'On the last weekday of the month',
            MINUTE: 'min.',
            MINUTES: 'Min',
            MINUTES_STARTING_AT: 'min. starting at minute',
            MONTHLY: 'Monthly',
            MONTH_STARTING_IN: 'month(s) starting in',
            NEAREST_WEEKDAY: 'Nearest weekday (Monday and Friday)',
            OF_THE_MONTH: 'of the month',
            ON_THE: 'On the',
            ON_THE_LAST: 'On the last',
            SPECIFIC: 'Specific',
            SPECIFIC_DAY_OF_MONTH: 'Specific day of month (choose one or many)',
            SPECIFIC_DAY_OF_WEEK: 'Specific day of week (choose one or many)',
            SPECIFIC_MONTH: 'Specific month (choose one or many)',
            SPECIFIC_YEAR: 'Specific year (choose one or many)',
            WEEKLY: 'Weekly',
            YEARLY: 'Yearly',
            YEAR_STARTING_IN: 'year(s) starting in',
        },
    },
    CUSTOM_FIELD: {
        FIELD: {
            ADD_CUSTOM_FIELD: 'Add Custom Field',
            FIELD_NAME: 'Field Name',
            FIELD_TYPE: 'Field Type',
            HIDDEN: 'Hidden',
            REQUIRED: 'Required',
            REPRESENTATIVES_ADDRESS: "Parent's Address",
            REPRESENTATIVES_CITY: "Parent's City",
            REPRESENTATIVES_COUNTRY: "Parent's Country",
            REPRESENTATIVES_EMAIL: "Parent's E-mail",
            REPRESENTATIVES_FIRST_NAME: "Parent's First Name",
            REPRESENTATIVES_LAST_NAME: "Parent's Last Name",
            REPRESENTATIVES_MIDDLE_NAME: "Parent's Middle Name",
            REPRESENTATIVES_PHONE: "Parent's Phone Number",
            REPRESENTATIVE_TYPE: 'Parent Type',
            STUDENTS_CITIZENSHIP: "Student's Citizenship",
            STUDENTS_CURRENT_SCHOOL: "Student's Current School",
            STUDENTS_DATE_OF_BIRTH: "Student's Date of Birth",
            STUDENTS_FIRST_NAME: "Student's First Name",
            STUDENTS_GENDER: "Student's Gender",
            STUDENTS_LAST_NAME: "Student's Last Name",
            STUDENTS_MIDDLE_NAME: "Student's Middle Name",
            STUDENTS_NATIONALITY: "Student's Nationality",
            STUDENTS_PERSONAL_ID: "Student's Personal ID",
            STUDENTS_SOURCE_TYPE: 'Students Source Of Information',
        },
        MESSAGE: {
            KEY_DUPLICATED: 'Key Duplicated',
            LIST_EMPTY: "List of possible values can't be empty",
            ORDER_DUPLICATED: 'Order No Duplicated',
            VALUE_DUPLICATED: 'Value Duplicate',
        },
        TITLE: {
            INFO: 'Field Info',
            LIST_ELEMENTS: 'List ELements',
            NEW: 'New Custom Field',
        },
    },
    DAILY_TIMESHEET_ACTUAL: {
        MESSAGE: {
            CONFIRM: {
                APPROVE: 'Do you want to approve Daily Timesheet?',
                DELETE: 'Do you want to delete Daily Timesheet?',
                UNAPPROVE: 'Do you want to unapprove Daily Timesheet?',
            },
            SUCCESS: {
                APPROVED: 'Daily Timesheet successfully approved',
                CALCULATED: 'Daily Timesheet successfully calculated',
                CREATED: 'Daily Timesheet successfully created',
                DELETED: 'Daily Timesheet successfully deleted',
                UNAPPROVED: 'Daily Timesheet successfully unapproved',
            },
        },
    },
    DISCOUNT: {
        TITLE: {
            ADD: 'Add Discount',
            BROWSER: 'Discounts',
            DESCRIPTION: 'Description',
            EDIT: 'Discount',
            NEW: 'New Discount',
        },
    },
    DISMISSAL_ARTICLE: {
        FIELD: {
            ARTICLE: 'Reason',
        },
        TITLE: {
            ADD: 'Add Reason',
            BROWSER: 'Reasons for Leaving',
            NEW: 'New Reason',
        },
    },
    DOCUMENT_TYPE: {
        TITLE: {
            ADD: 'Add Document',
            BROWSER: 'Document Types',
            DESCRIPTION: 'Description',
            EDIT: 'Document',
            NEW: 'New Document',
            STAGE: 'Stage',
        },
    },
    EDUCATION_STANDARD: {
        TITLE: {
            ADD: 'Add Education Standard',
            BROWSER: 'Education Standards',
            NEW: 'New Education Standard',
            EDIT: 'Education Standard',
            DETAILS: 'Details',
            ENTER_COMMENT: 'Enter comment',
        },
        MESSAGE: {
            COMMENT_MAX_LENGTH: 'Comment must be less than 1000 characters',
        },
    },
    EDUCATION_STANDARD_PACKAGE: {
        TITLE: {
            ADD: 'Add Standard Package',
            BROWSER: 'Standard Packages',
            NEW: 'New Standard Package',
            EDIT: 'Standard Package',
            DETAILS: 'Details',
        },
    },
    EDUCATION_STANDARD_DETAIL: {
        TITLE: {
            FORM: 'Education Standard Details',
            FORM_WITH_PARAM: '{{param}} - Education Standard Details',
            SELECT: 'Create new one or select a standard to edit...',
            UPLOAD_TEMPLETE: 'Upload Standard Excel Template',
            DOWNLOAD_TEMPLETE: 'Download Standard Excel Template',
            STANDARD_TEMPLETE: 'Education Standard Templete',
            NEW_STANDARD_DETAIL: 'New Standard Detail',
        },
        FIELD: {
            PARENT_STANDARD: 'Parent Standard',
            TURNED_OFF: 'Turned off',
            CALCULATION_OF_PARENT: 'Parent Calculation',
            GRADING_ALLOWED: 'Grading Allowed',
        },
        MESSAGE: {
            FILE_INVALID: 'Uploaded file is not valid',
            IMPORTED_SUCCESSFULLY: 'Education Standards imported successfully',
        },
    },
    NOTIFICATION_TEMPLATE: {
        TITLE: {
            EMAIL: 'E-mail Template',
            SMS: 'SMS Template',
            HINT: 'You can choose a suitable template or fill it out yourself',
        },
    },
    EMPLOYEE: {
        FIELD: {
            ADD_SALARY_PARAMETER: 'Add Salary Parameter',
            AGREEMENT: 'Additional Agreement',
            AGREEMENT_DATE: 'Additional Agreement Date',
            AGREEMENT_NUMBER: 'Agreement Number',
            ARTICLE: 'Article',
            ATTESTATION: 'Attestation',
            ATTESTATIONS: 'Attestations',
            CERTIFICATE: 'Certificate',
            CERTIFICATES: 'Certificates',
            CONTRACT_DATE: 'Contract Date',
            CONTRACT_NUMBER: 'Contract Number',
            DIPLOMA_NUMBER: 'Diploma Number',
            DISMISSAL: 'Dismissal',
            DISMISS_DATE: 'Dismiss Date',
            EDUCATION: 'Education',
            EMPLOYMENT_CONTRACT: 'Contracts',
            EMPLOYMENT_DATE: 'Employment Date',
            EXPERIENCE: 'Experience',
            EXPERIENCE_DAY: 'days',
            EXPERIENCE_MONTH: 'months',
            EXPERIENCE_YEAR: 'years',
            GRADUATION_YEAR: 'Graduation Year',
            LOCATION: 'Place of Passage',
            ORDER_DATE: 'Order Date',
            ORDER_NUMBER: 'Order Number',
            ORGANIZATION: 'Organization',
            OUR_ORGANIZATION: 'Current Organization',
            OUR_ORGANIZATION_EXPERIENCE: 'Experience in Current Organization',
            PEDAGOGICAL_EXPERIENCE: 'Pedagogical Experience',
            QUALIFICATION: 'Qualification',
            SPECIALTY: 'Specialty',
            UNIVERSITY: 'Study Place',
            WORKING_NOW: 'To Present',
            WORK_EXPERIENCE: 'Work Experience',
            YEAR: 'Year Passing',
        },
        MESSAGE: {
            ERROR: {
                ALREADY_ONE_ACTIVE_CONTRACT:
                    'There is already exist active Employment Contract. Only one active Employment Contract can exist',
                DATE_RANGE_CONFLICTS:
                    "Date range conflicts with other Employment Contract with contract number {{number}} and it's date range is:",
                EXPIRE_DATE_BEFORE_CONTRACT_DATE: 'Expire Date cannot be earlier than Contract Date',
                UNFINISHED_SALARY_MODIFIER: 'Employee has an unfinished salary modifier, please indicate the to date.',
                UNFINISHED_WORK_EXPERIENCE: 'Employee has an unfinished work experience, please indicate the to date.',
            },
            WARNING: {
                ADD_DOCUMENT_TYPE_TO_UPLOAD:
                    "Create Document Type with Type '{{attachmentStage}}' to be able to upload attachment",
                DELETE_AGREEMENT: 'Do you want to delete Additional Agreement with agreement number "{{number}}"?',
                DELETE_CONTRACT:
                    'Do you want to delete Employment Contract with Contract Number: "{{number}}"? While you delete  Employment Contract all of it\'s Additional Agreements will be deleted.',
                DOES_NOT_HAVE_ACTIVE_CONTRACT_EMPLOYEE_STATUS_ACTIVE:
                    "Employee status is active. But employee doesn't have active contract",
                HAVE_ACTIVE_CONTRACT_EMPLOYEE_STATUS_PASSIVE:
                    'Employee status is passive but employee has an active contract',
            },
            INFO: {
                VERIFICATION_CODE_SENDED: 'Verification code sent to e-mail',
                EMPLOYEE_USERS_CREATING: 'Please wait while creating employee users',
                EMPLOYEE_DATA_IMPORT: 'Please wait while importing employees data...',
                EMPLOYEE_IMPORT_DETAIL: 'Successfully imported: {{successCount}}, Not imported: {{errorCount}}',
            },
            CONFIRM: {
                SAVE_WITH_ACTIVE_STATUS: 'Employee does not have contract. Save with ACTIVE Employee status?',
            },
        },
        TITLE: {
            ADD: 'Add Employee',
            ADD_AGREEMENT: 'Add Additional Agreement',
            ADD_ATTESTATION: 'Add Attestation',
            ADD_CERTIFICATE: 'Add Certificate',
            ADD_EDUCATION: 'Add Education',
            ADD_EMPLOYMENT_CONTRACT: 'Add Employment Contract',
            ADD_EXPERIENCE: 'Add Experience',
            ASSIGNED_SALARY_MODIFIERS: 'Salary Modifiers',
            BROWSER: 'Employees',
            EDIT_CERTIFICATE: 'Certificate',
            EXPIRY_DATE: 'Expiry Date',
            EXCEL_TEMPLATE: 'Employees Excel Template',
            GENERAL_INFO: 'General Info',
            GIVEN_BY: 'Given by',
            GIVEN_DATE: 'Date of Issue',
            GIVEN_SUBJECTS: 'Given Subjects',
            ID: 'Employee ID',
            IMPORT: 'Import Employees',
            INFO: 'Employee Information',
            NEW: 'New Employee',
            NEW_AGREEMENT: 'New Additional Agreement',
            NEW_ATTESTATION: 'New Attestation',
            NEW_CERTIFICATE: 'New Certificate',
            NEW_DISMISSAL: 'New Dismissal',
            NEW_EDUCATION: 'New Education',
            NEW_EMPLOYMENT_CONTRACT: 'New Employment Contract',
            NEW_EXPERIENCE: 'New Experience',
            UNDO: 'Undo',
            VIEW: 'View',
            REPORT_AWARDS_HINT:
                'To receive information about employee awards, you need to add an custom field to the employee with the code {{param}}',
            SELECT_EMPLOYEES: 'Select employees',
        },
    },
    EMPLOYEE_POSITION: {
        TITLE: {
            ADD: 'Add Position',
            BROWSER: 'Positions',
            NEW: 'New Position',
        },
    },
    EMPLOYEE_WORK_CALENDAR: {
        FIELD: {
            REGULAR_WORKING_HOURS: 'Regular working hours',
        },
    },
    ENTITY_FIELD: {
        TITLE: {
            BROWSER: 'Custom Fields',
            EDIT: 'Editing Custom Field - {{name}}',
            NEW: 'New Custom Field',
        },
        FIELD: {
            FIELD: 'Field',
            FIELD_TYPE: 'Field Type',
            CHILDREN: 'Child Fields',
            CHILD: 'Child Field',
            PARENT: 'Parent Field',
            CONSTANT: 'Constant List Items',
            LIST_SOURCE: 'Source of List',
        },
        MESSAGE: {
            KEY_DUPLICATED: 'Key Duplicated',
            FIELD_DUPLICATED: 'Field Duplicated',
            CODE_DUPLICATED: 'Code Duplicated',
            LIST_EMPTY: "List of Possible Values can't be empty",
            CHILDREN_EMPTY: "List of children can't be empty",
            ORDER_DUPLICATED: 'Order Number Duplicated',
            VALUE_DUPLICATED: 'Value Duplicated',
            ADD_FIELD: 'Add one more "{{item}}"',
        },
    },
    ENTITY_FIELD_SETTINGS: {
        TITLE: {
            BROWSER: 'Custom Forms',
            EDIT: 'Editing Form Field',
            NEW: 'New Form Field',
            OTHER_INFO: 'Additional Info',
            ARRAY_INFO: 'Field will be saved as array of values',
            ARRAY_VALUE: 'Zero means infinite',
            ARRAY_WARNING: 'Warning, changing this parameter will erase previous values',
            GROUPS: 'Field Groups',
            CHANGE_ORDER_UP: 'Change Order(Up)',
            CHANGE_ORDER_DOWN: 'Change Order(Down)',
        },
        FIELD: {
            SETTING: 'Field Setting',
            ENTITY_TYPE: 'Form',
            ARRAY_SIZE: 'Number of Values',
            GROUP: 'Field Group',
            MULTIPLE: 'Multiple ?',
            HINT: 'Hint',
            MAX: 'Max. Value',
            MASK: 'Mask',
            MIN: 'Min. Value',
            DEFAULT_VALUE: 'Default Value',
            OFF_LABEL: 'Off Label',
            ON_LABEL: 'On Label',
            PREFIX: 'Prefix',
            MAX_LENGTH: 'Max. Length',
            MIN_LENGTH: 'Min. Length',
            OPTIONS: 'Options',
            CHILD_FIELDS: 'Child Fields',
            RELATIONS: 'Relations',
            RELATION: 'Relation',
            MATCH: 'Match',
            OPERATOR: 'Operator',
            WHEN: 'When (Condition)',
            FULL_ACCESS_PERMISSION: 'Full Access',
            READONLY_ACCESS_PERMISSION: 'Read Only',
            HIDDEN_ACCESS_PERMISSION: 'Hidden',
            EVERYBODY_FULL_ACCESS_PERMISSION: 'Everybody full Access',
            CASCADE_FIELDS: 'Cascade Fields',
        },
        MESSAGE: {
            PARENTS_LOADING: 'Parent fields are loading',
            EXAMS_LOADING: 'Registrations are loading',
            ITEM_TYPES_LOADING: 'Item types are loading',
            ITEM_CREATE_WARNING: 'The parent field should be enabled first',
            THERE_IS_NO_ADDITONAL_INFO:
                'There is no additional information! In order to add information, you must first set up the custom field settings from parameters menu.',
        },
    },
    ENTRANCE_EXAM: {
        FIELD: {
            CHARACTERS: 'Characters',
            COPY_FROM_EXAM: 'Copy From Registration',
            EMAIL: 'E-mail',
            NOTIFY_REGISTRAR_VIA_EMAIL: 'Notify Registration via E-mail',
            NOTIFY_VIA_EMAIL: 'Notify via E-mail',
            NOTIFY_VIA_SMS: 'Notify via SMS',
            PAID: 'Paid',
            PAYMENT_INFO: 'Payment Info',
            SMS: 'SMS',
            SMS_SIZE: 'SMS Count',
            FORM_TEMPLATE: 'Registration Form',
        },
        TITLE: {
            ADD: 'Add Registration',
            BROWSER: 'Entrance Registration',
            NEW: 'New Registration',
            DOWNLOAD_EXAMINATION_SHEET: 'Download Registration Form',
        },
    },
    ENUM: {
        COURSE_BULK_OPS: {
            PRIMARY_TEACHER_ASSIGN: 'Primary Teacher Assign',
            SECONDARY_TEACHER_ASSIGN: 'Secondary Teacher Assign',
            NOTIFICATION_SETTINGS: 'Notification Settings',
            GRADING_SETTINGS: 'Grading Settings',
            HOMEROOM_ASSIGN: 'Class Assign',
            CODE_ASSIGN: 'Course Code',
            DELIVERY_METHOD_ASSIGN: 'Delivery Method',
            SUBJECT_ASSIGN: 'Subject',
            GRADE_LEVEL_ASSIGN: 'Grade Level',
            START_END_DATE_CHANGE: 'Start / End Date',
            SECTION_ASSIGN: 'Section',
            TERM_CODE_ASSIGN: 'Term Code',
            LOCATION_ASSIGN: 'Location',
        },
        ASSESSMENT_SCORE_STATUS: {
            DRAFT: 'Draft',
            APPROVED: 'Approved',
        },
        NAME_ORDER: {
            FIRST_LAST: 'Fist-Middle-Last',
            LAST_FIRST: 'Last-First-Middle',
        },
        ALERT_TYPE: {
            BIRTH_DAY: 'Birth Day',
            CUSTODY: 'Custody',
            INCIDENT: 'Discipline',
            GUARDIAN: 'Guardian',
            MEDICAL: 'Medical',
            OTHER: 'Other',
            SPECIAL_EDUCATION: 'Special Education',
        },
        AGGREGATION_METHOD_KEYS: {
            FORMULA: 'Formula',
            MEAN: 'Mean',
            MEDIAN: 'Median',
            SUM: 'Sum',
        },
        ANSWER_POSITION_ON_PRINT: {
            AFTER_QUESTION: 'After Each Question',
            END_OF_QUESTIONS: 'End of Questions',
        },
        ATTENDANCE_TYPE: {
            PRESENT: 'Present',
            TARDY: 'Tardy',
            PERMITTED: 'Permitted',
            EXCUSED: 'Excused',
            ABSENT: 'Absent',
        },
        DAILY_ATTENDANCE_TYPE: {
            PRESENT: 'Present',
            PERMITTED: 'Permitted',
            EXCUSED: 'Excused',
            ABSENT: 'Absent',
            HALF_ABSENT: '½ Absent',
        },
        ATTENDANCE_PRESENCE_TYPE: {
            PRESENT: 'Present',
            ABSENT: 'Absent',
        },
        ATTACHMENT_SUBMISSION_TYPE: {
            AUDIO: 'Audio',
            VIDEO: 'Video',
            PHOTO: 'Photo',
            IMAGE: 'Image',
            PDF: 'PDF',
            FILE: 'File',
        },
        ATTENDANCE_CHART_TYPE: {
            COURSE_WEEKLY_ATTENDANCE: 'Weekly Course Attendance',
            STUDENT_COURSE_ATTENDANCE: 'Students Course Attendance',
            STUDENT_WEEKLY_ATTENDANCE: 'Students Weekly Attendance',
            TEACHER_COURSE_WEEKLY_ATTENDANCE: "Weekly attendance of teacher's courses",
            SUBJECT_TEACHER_WEEKLY_ATTENDANCE: 'Course Teachers weekly attendance',
        },
        ATTENDANCE_TABLE_TYPE: {
            COURSE_STUDENT_PERCENTAGES: "Student's Course Percentages",
            COURSE_PERCENTAGES: 'Course Attendance Percentages',
        },
        ATTENDANCE_TYPE_SHORT: {
            PRESENT: 'Present',
            TARDY: 'Tardy',
            PERMITTED: 'Permitted',
            EXCUSED: 'Excused',
            ABSENT: 'Absent',
        },
        ATTENDANCE_BY_STUDENT_TYPE: {
            DATE_RANGE: 'Date Range',
            FULL_DAY: 'Full Day',
            PARTIAL_DAY: 'Partial Day',
            PERIOD: 'Period',
        },
        ATTENDANCE_EXCUSE_STATUS: {
            SENT: 'Sent',
            ACCEPTED: 'Accepted',
            DECLINED: 'Declined',
        },
        TEACHER_ATTENDANCE_EXCUSE_STATUS: {
            SENT: 'Incoming',
            ACCEPTED: 'Accepted',
            DECLINED: 'Declined',
        },
        ASSIGNMENT_NEW_ATTEMPT_REQUEST_STATUS: {
            SENT: 'Sent',
            ACCEPTED: 'Accepted',
            DECLINED: 'Declined',
        },
        STUDENT_ASSIGNMENT_GROUP_TYPE: {
            DEFAULT: 'Default View',
            COURSE: 'Show by Course',
            TYPE: 'Show by Type',
            DATE: 'Show by Date',
            CHART: 'Show by Chart',
        },
        STUDENT_ASSIGNMENT_GROUP_DEFAULT_TYPE: {
            OVERDUE: 'Overdue',
            UPCOMING: 'Upcoming',
            UNDATED: 'Undated',
            PAST: 'Past',
        },
        COURSE_ASSIGNMENT_STATUS: {
            COMPLETED: 'Completed',
            DRAFT: 'Draft',
            PUBLISHED: 'Published',
            RESULTS_PUBLISHED: 'Results Published',
        },
        COURSE_ASSIGNMENT_VIEW_TYPE: {
            TABLE: 'Table',
            CHART: 'Chart',
        },
        COURSE_ASSIGNMENT_SUBMISSION_SEARCH_STATUS: {
            DRAFT: 'Draft',
            ALL: 'All',
            NO_SUBMISSIONS: 'No submission',
            REVIEWED: 'Reviewed',
            SUBMITTED: 'Submitted',
            GRADED: 'Graded',
            EXCUSED: 'Excused',
        },
        COURSE_ASSIGNMENT_SUBMISSION_STATUS: {
            DRAFT: 'Draft',
            REVIEWED: 'Reviewed',
            SUBMITTED: 'Submitted',
            GRADED: 'Graded',
            MISSING: 'Missing',
            LATE: 'Late',
            EXCUSED: 'Excused',
            RUNNING: 'Running',
        },
        COURSE_ASSIGNMENT_TYPE: {
            HOMEWORK: 'Homework',
            PROJECT: 'Project',
            QUIZ: 'Quiz',
            OTHER: 'Other',
        },
        COURSE_ASSIGNMENT_ATTEMPT_TYPE: {
            LAST_ATTEMPT: 'Last Attempt',
            BEST_ATTEMPT: 'Best Attempt',
        },
        COURSE_ASSIGNMENT_SUBMISSION_TYPE: {
            ONLINE: 'Online',
            PRINT: 'Print',
        },
        COURSE_PLAN_STATUS: {
            DRAFT: 'Draft',
            PUBLISHED: 'Published',
        },
        COURSE_PLAN_TYPE: {
            LESSON: 'Lesson',
            NOTE: 'Note',
        },
        CUSTOM_PARAMETER_CATEGORY: {
            DISCIPLINE_INFRACTION: 'Discipline Infractions',
            DISTRICTS: 'Districts',
            VISIT_TYPE: 'Visit Type',
            COMPLAINT: 'Complaint',
            INTERVENTION: 'Intervention',
            DISPOSITION: 'Disposition',
            ALLERGIES: 'Allergies',
            MEDICAL_ALERTS: 'Medical Alerts',
            MEDICATION: 'Medication',
            UNIT: 'Unit',
            ROUTE: 'Route',
            REASON: 'Reason',
            ENROLL_CODES: 'Enroll Report Codes',
            INCIDENT_DURING_SCHOOL_TIME_CODES: 'During School Hours Incident Codes',
            INCIDENT_OUT_SIDE_SCHOOL_TIME_CODES: 'Outside School Hours Incident Codes',
            INCIDENT_OBJECTS: 'Incident Objects',
            INCIDENT_DURATION_HOURS: 'Incident Duration Hours',
            INCIDENT_DURATION_DAYS: 'Incident Duration Days',
            INCIDENT_DURATION_OTHER: 'Incident Duration Others',
            COUNSELOR: 'Counselors',
            PROGRAM_SERVICE_EXIT_CODE: 'Exit Reason Codes',
            PROGRAM_SERVICE_ENTRY_CODE: 'Entry Reason Codes',
            PROGRAM_SERVICE_INTENSITY: 'Program Service Intensity',
            PROGRAM_PROVIDER_TYPE: 'Program Service Provider',
            PROGRAM_SERVICE_SETUP_TYPE: 'Program Service Code Categories',
            ACADEMIC_CALENDAR_DAY: 'Academic Calendar',
            SCHOOL_ENTRY_CODE: 'School Entry Codes',
            SCHOOL_EXIT_CODE: 'School Exit Codes',
            DUAL_CREDIT_CODE: 'Dual Credit',
            TERM_CODE: 'Term Code',
            ATTENDANCE_MODALITY: 'Daily Attendance Modality',
            FINAL_GRADE_NOTE: 'Final Grade Note',
            EDUCATION_STANDARD_PACKAGE: 'Standard Package',
            ASSESSMENT_TYPE: 'Assessment Type',
            ASSESSMENT_LANGUAGE_CODE: 'Language Code',
        },
        DURATION_TYPE: {
            HOUR: 'Hour',
            DAY: 'Day',
            OTHER: 'Other',
        },
        ACADEMIC_CALENDAR_DAY_TYPE: {
            START_END_OF_TERM: 'Start/End of Term',
            PUBLIC_HOLIDAY: 'Public Holiday',
            WEEKEND: 'Weekend',
            TERM_BREAK: 'Term Break',
            WORK_DAY: 'Work Day',
        },
        COURSE_ASSIGNMENT_SUBSCRIBERS_TYPE: {
            ALL: 'All',
            GROUP: 'Group',
            STUDENT: 'Individual',
        },
        ACADEMIC_PERIOD_TYPE: {
            ACADEMIC_YEAR: 'Academic Year',
            SEMESTER: 'Semester',
            QUARTER: 'Quarter',
        },
        ACCOUNT_CATEGORY: {
            EXPENSE: 'Expense',
            GENERAL: 'General',
            INCOME: 'Income',
            INVESTMENT: 'Investment',
            SALARY: 'Salary',
        },
        ACCOUNT_STATE: {
            NEW: 'New',
            PRIOR: 'Prior',
        },
        ACCOUNT_TYPE: {
            AUXILIARY: 'Auxiliary',
            DETAIL: 'Detail',
            GROUP: 'Group',
        },
        ANNOUNCEMENT_STATUS: {
            DRAFT: 'Draft',
            PUBLISHED: 'Published',
        },
        ANSWER_TYPE: {
            NO: 'No',
            YES: 'Yes',
        },
        MEANS_OF_CONTACT: {
            PHONE_CALL: 'Phone Call',
            EMAIL: 'Email',
        },
        ANNOUNCEMENT_CONDITION: {
            VISIBLE: 'Visible',
            HIDDEN: 'Hidden',
        },
        ATTACHMENT_STAGE: {
            CERTIFICATE: 'Certificate',
            CONTRACT: 'Contract',
            DISMISSAL: 'Dismissal',
            EMPLOYMENT: 'Employment',
            EXAMINATION: 'Examination',
            STUDENT_REGISTRATION: 'Student Registration',
        },
        MEETING_ATTACHMENT_TYPE: {
            HOMEWORK: 'Homework',
            LESSON_NOTE: 'Lesson Note',
            PRESENTATION: 'Presentation (File)',
            EXTERNAL_URL: 'Presentation(URL)',
        },
        BALANCE_PROCESS_TYPE: {
            BUDGET_CLOSE: 'Budget Close',
            EXP_CLOSE: 'Expense Close',
            INC_CLOSE: 'Income Close',
            PROFIT_TRANSFER: 'Profit or Loss Transfer',
            TAX_CALCULATE: 'Tax Calculate',
            EXP_TRANSFER: 'Expense Transfer',
        },
        BALANCE_TYPE: {
            CREDIT: 'Credit',
            DEBIT: 'Debit',
        },
        BEST_GRADE: {
            MINIMUM: 'Minimum Grade',
            MAXIMUM: 'Maximum Grade',
        },
        EXAM_TYPE: {
            EXAM: 'Entrance Exam',
            REGISTRATION: 'Registration',
        },
        GRADE_CATEGORY_CALCULATION_TYPE: {
            AVERAGED: 'Averaged',
            WEIGHTED: 'Weighted',
        },
        GRADE_CATEGORY_GRADING_TYPE: {
            GRADE: 'Grade',
            ATTENDANCE: 'Attendance',
        },
        BUDGET_EXPENSE_REQUEST_STATUS: {
            APPROVED: 'Approved',
            DECLINED: 'Declined',
            IN_PROCESS: 'In Process',
            STARTED: 'Started',
            CANCELED: 'Canceled',
        },
        BUDGET_EXPENSE_RESPONSE_STATUS: {
            STARTED: 'Started',
            APPROVED: 'Approved',
            DECLINED: 'Declined',
            IN_PROCESS: 'In Process',
        },
        BUDGET_EXPENSE_TRANSFER_STATUS: {
            APPROVED: 'Approved',
            DECLINED: 'Declined',
            STARTED: 'Started',
        },
        BUDGET_GROUP_STATUS: {
            COMPLETED: 'Completed',
            PASSIVE: 'Passive',
            STARTED: 'Started',
        },
        BUDGET_PERMISSION_TYPE: {
            APPROVE: 'Approve',
            CHANGE: 'Change',
            VIEW: 'View',
        },
        BUDGET_TYPE: {
            CURRENT: 'Current',
            NEXT_YEARS: 'Next Years',
            REVISION: 'Revision',
        },
        BUDGET_VERSION_TYPE: {
            V1: 'Version 1',
            V2: 'Version 2',
            V3: 'Version 3',
            V4: 'Version 4',
            V5: 'Version 5',
        },
        CURRICULUM_ITEM_TYPE: {
            ASSIGNMENT: 'Assignment',
            QUIZ: 'Quiz',
            COURSE_EVENT: 'Lesson',
            EXTERNAL_RESOURCE: 'External Resource',
            IQERA_RESOURCE: 'IQera Content',
            ICPLAYER_RESOURCE: 'MAuthor Content',
            DOCUMENTS: 'Documents',
        },
        ICPLAYER_ITEM_TYPE: {
            QUIZ: 'Quiz',
            LESSON: 'Lesson',
        },
        CONTRACT_TEMPLATE_TYPE: {
            EMPLOYEE: 'Employee',
            STUDENT: 'Student',
        },
        COST_CENTER: {
            IMPERSONAL: 'Impersonal',
            OPERATION: 'Operation',
            PERSONAL: 'Personal',
            PROCESS: 'Process',
            PRODUCTION: 'Production',
            SERVICE: 'Service',
        },
        COST_CENTER_REQUIRED_TYPE: {
            TRUE: 'Yes',
            FALSE: 'No',
        },
        COURSES_ADMIN_FILTER_TYPE: {
            TEACHER: 'Teacher',
            STUDENT: 'Student',
        },
        COURSE_SCHEDULE_FILTER_TYPE: {
            TEACHER: 'Teacher',
            CLAZZ: 'Class',
            COURSE: 'Course',
            STUDENT: 'Student',
            SUBJECT: 'Subject',
            LOCATION: 'Location',
        },
        CURRENCY_TYPE: {
            EUR: 'EUR',
            KZT: 'KZT',
            USD: 'USD',
            TRY: 'TRY',
            PKR: 'PKR',
            KGS: 'KGS',
            TZS: 'TZS',
            GBP: 'GBP',
        },
        CURVE_TYPES: {
            ABSOLUTE: 'Absolute',
            PERCENT: 'Percent (Bell Curve)',
        },
        CUSTOM_FIELD_TYPE: {
            BOOLEAN: 'Logical',
            CURRENCY: 'Currency',
            DATE: 'Date',
            DECIMAL: 'Number',
            INTEGER: 'Integer',
            LIST: 'List of Value',
            STRING: 'Text',
            TEXTAREA: 'Memo Field',
            ADDRESS: 'Address',
        },
        COURSE_TYPE: {
            ONLINE: 'Online',
            OFFLINE: 'Offline',
        },
        COURSE_DELIVERY_METHOD: {
            ONLINE: 'Online Learning',
            FACE: 'Face-to-Face',
            BLENDED: 'Blended Learning',
            DISTANCE: 'Distance Learning',
        },
        CHOICE_NUMBERING: {
            ABC_LOWER_CASE: 'a, b, c, ...',
            ABC_UPPER_CASE: 'A, B, C, ...',
            NUMBER: '1, 2, 3',
        },
        DISMISSAL_USER_TYPE: {
            STUDENT: 'Student',
            EMPLOYEE: 'Employee',
        },
        DISCOUNT: {
            AMOUNT: 'Amount',
            PERCENT: 'Percent',
        },
        DOCUMENT_TYPE: {
            BIRTH_CERTIFICATE: 'Birth Certificate',
            PASSPORT: 'Passport',
            PERSONAL_ID: 'Personal ID',
        },
        GROUP_TYPE: {
            STUDENT: 'Student',
            EMPLOYEE: 'Employee',
            REPRESENTATIVE: 'Parent',
        },
        EDUCATION_REPORTS: {
            TERM_REPORT_CARD: 'Term report card',
            PROGRAM_COMPLETION_REPORT: 'Program Completion Report',
            DISMISSAL_ENTRY_REPORT: 'Students movement',
            PROTOCOLS_OF_COUNCILS: 'Protocols of pedagogical and scientific-methodical councils',
            WORKING_CURRICULUM_REPORT: 'Working Course Plan',
            ALPHABETICAL_BOOK_OF_STUDENTS: 'Alphabetical record book of students',
            TEACHERS_LIST_REPORT: 'The book of accounting for the personnel of teachers',
            ANALYSIS_BY_GRADE_CATEGORY_REPORT: 'Analysis of the results of the summary assessment',
            CLASS_GRADEBOOK_REPORT: 'Class Gradebook Report',
            SHORT_TERM_LESSON_PLAN: 'Short Term Lesson Plan',
            TEACHER_WORKLOAD: 'Teacher Workload',
            STUDENT_REPORT_CARDS: 'Book of student report cards count',
            STUDENT_INFO_REPORT: 'Information about the students of the school',
            SUBJECT_MIDTERM_PLAN: 'Medium-term (calendar-thematic) plan for subjects',
            SOCIAL_PASSPORT_OF_SCHOOL: 'Social passport of the school',
            BOOK_OF_REGISTRATION_OF_ORDERS: 'Book of registration of orders',
            CLASS_TEACHER_WORK_PLAN: 'Class teacher work plan',
            MENTORING_PLAN_REPORT: 'Mentoring Plan',
            PLAN_OF_EDUCATIONAL_EVENTS: 'Plan of Educational Events',
            PLAN_OF_EDUCATIONAL_WORK: 'Plan of educational work',
            ATTESTAT_ISSUANCE_1_9_GRADES:
                'Book of registration and issuance of certificates of completion of basic secondary school',
            ATTESTAT_ISSUANCE_1_12_GRADES:
                'Book of registration and issuance of certificates of completion of general secondary education',
            SOCIAL_TEACHERS_WORK_PLAN: 'Social teacher’s work plan',
            BOOK_OT_THE_ACHIEVEMENTS: 'Book of accounting for the issuance of commendable sheets',
            SCHOOL_DEVELOPMENT_PROGRAM: 'School Development Program',
            INTRASCHOOL_CONTROL_PLAN: 'Intraschool control plan',
            EXAM_PROTOCOL_REPORT:
                'Examination protocol for the course of study at the level of basic secondary, general secondary education',
            REPLACED_LESSONS_LOG: 'Replaced lessons log',
        },
        EMPLOYEE_CONTRACT_TYPE: {
            AGREEMENT: 'Additional Agreement',
            CONTRACT: 'Employment Contract',
        },
        EMPLOYEE_QUALIFICATION: {
            ASPIRANT: 'ASPIRANT',
            BACHELOR: 'Bachelor',
            DOCTOR: 'Doctor of Science',
            MASTER: 'Master',
            PHD: 'Ph.D',
            PROFESSOR: 'Professor',
            SECONDARY: 'Secondary Technical',
        },
        EMPLOYEE_STATUS: {
            ACTIVE: 'Active',
            PASSIVE: 'Passive',
        },
        EMPLOYEE_TYPE: {
            DD_ACADEMIC_AFFAIRS: 'Deputy Director of Academic Affairs',
            DD_ADAPTIVE_STUDY: 'Deputy Director of Adaptive Study',
            DD_EDUCATION: 'Deputy Director of Education',
            DD_EDUCATIONAL_AND_INDUSTRIAL_WORK: 'Deputy Director for Educational and Industrial Work',
            LIBRARIAN: 'Librarian',
            METHODOLOGIST: 'Methodologist',
            OTHER: 'Other',
            PRINCIPAL: 'Principal',
            REGISTRAR: 'Registrar',
            SUPERVISOR: 'Supervisor',
            TEACHER: 'Teacher',
            NURSE: 'Nurse',
            DOCTOR: 'Doctor',
            COUNSELOR: 'Counselor',
            OPERATION_MANAGER: 'Operation Manager',
            DEAN: 'Dean',
            SUPERINTENDENT: 'Superintendent',
            DEMO_ACCOUNT: 'Demo Account',
            INCIDENT_MANAGER: 'Incident Manager',
            BEHAVIORAL_SPECIALIST: 'Behavioral Specialist',
            SOCIAL_WORKER: 'Social/Pupil Personnel Worker',
            SECRETARIAL: 'Secretarial/Clerical Staff',
            IT: 'IT/Technology Staff',
        },
        ENROLL_TYPE: {
            CLASS_ASSIGNMENT: 'Class Assignment',
            CLASS_TRANSFER: 'Class Transfer',
            ENTRY: 'Entered',
            GRADUATED: 'Graduated',
            LEFT: 'Left',
            SCHOOL_TRANSFER: 'School Transfer',
        },
        ENTITY_FIELD_TYPE: {
            AUTOCOMPLETE: 'Autocomplete',
            CHECKBOX: 'Checkbox',
            RADIOGROUP: 'Radio Group',
            TAG: 'Tag',
            BOOLEAN: 'Logical',
            CURRENCY: 'Currency',
            DATE: 'Date',
            DECIMAL: 'Number',
            INTEGER: 'Integer',
            LIST: 'List of Value',
            STRING: 'Text',
            TEXTAREA: 'Memo Field',
            ADDRESS: 'Address',
            COMPOSITE: 'Composite',
            SWITCH: 'Switch Toggle',
            PHONE: 'Phone',
            TIME: 'Time',
        },
        ENTITY_LIST_SOURCE: {
            CUSTOM_PARAMETER: 'Custom Parameter',
            COUNTRY: 'Countries',
            STATE: 'States',
        },
        ENTITY_FIELD_MATHER: {
            DISABLED: 'Disabled',
            ENABLED: ' Enabled',
            REQUIRED: 'Required',
            OPTIONAL: 'Optional',
            VISIBLE: 'Visible',
            HIDDEN: 'Hidden',
        },
        ENTITY_FIELD_OPERATOR: {
            AND: 'And',
            OR: 'Or',
        },
        ENTITY_FIELD_ENTITY_TYPE: {
            EXAM: 'Registration',
            ITEM: 'Item',
            EMPLOYEE: 'Employee',
            STUDENT: 'Student',
            SCHOOL_LOG: 'School Log',
        },
        ENTITY_TYPE: {
            EMPLOYEE: 'Employee',
            LOCATION: 'Location',
            STUDENT: 'Student',
        },
        ENTRY_TYPE: {
            EXAM: 'Registration',
            OTHER: 'Other',
            OTHER_SCHOOL: 'Other School',
            TRANSFER: 'School Transferred',
        },
        EVENT_STATUS: {
            PUBLISHED: 'Published',
            ENDED: 'Ended',
            CREATED: 'Created',
            STARTED: 'Started',
            CANCELLED: 'Cancelled',
        },
        EVENT_TYPE: {
            COURSE: 'Course',
            CUSTOM: 'Simple Event',
            MEETING: 'Meeting',
        },
        EXAM_REGISTRATION: {
            NOT_SENT: 'Not Sent',
            SENT: 'Sent',
        },
        EXAM_RESULT_TYPE: {
            FAIL: 'Failed',
            NONE: 'Unknown',
            PASS: 'Passed',
            RESERVE: 'Reserve',
        },
        FIELD_TYPE: {
            CUSTOM: 'Custom Field',
            DEFAULT: 'Default Field',
        },
        FORMULA: {
            DEFAULT: 'Default',
            GROVY: 'Grovy',
            JAVA_SCRIPT: 'Javascript',
        },
        GENDER_TYPE: {
            FEMALE: 'Female',
            MALE: 'Male',
            X: 'Nonbinary',
        },
        GRADE_CHART_TYPE: {
            AVERAGE_COURSE_GRADE: 'Average Course Grade',
            STUDENT_GRADE_RANKING: 'Student Grade Ranking',
        },
        GRADE_RANGE_TYPE: {
            PASS: 'Pass',
            FAIL: 'Fail',
        },
        HEALTH_TEST: {
            PASS: 'Positive',
            FAIL: 'Negative',
        },
        GRADE_SCHEME_TYPE: {
            RANGE: 'Range',
            POINT: 'Point',
        },
        GRADE_ROUNDING: {
            UP: 'Up',
            DOWN: 'Down',
        },
        ITEM_PAYMENT_STATUS: {
            NOT_PAID: 'Not Paid',
            PAID: 'Paid',
        },
        ITEM_STATUS: {
            CANCELED: 'Canceled',
            DRAFT: 'Draft',
            GIVEN: 'Given',
            LOST: 'Lost',
            RETURNED: 'Returned',
        },
        JOB_STATE: {
            BLOCKED: 'Blocked',
            COMPLETE: 'Completed',
            ERROR: 'Error',
            NONE: 'None',
            PAUSED: 'Paused',
            RUNNING: 'Running',
            SCHEDULED: 'Scheduled',
        },
        LANGUAGE_TYPE: {
            'en-us': 'English(US)',
            en: 'English',
            kk: 'Kazakh',
            ru: 'Russian',
            de: 'German',
            tr: 'Turkish',
            fr: 'French',
        },
        LOCATION_TYPE: {
            CLASS: 'Classroom',
            LABORATORY: 'Laboratory',
            OTHER: 'Other',
        },
        MEASUREMENT_UNIT: {
            KIT: 'Kit',
            PACKAGE: 'Package',
            PIECE: 'Piece',
        },
        MEETING_STATUS_TYPE: {
            CREATED: 'Planned',
            PUBLISHED: 'Published',
            STARTED: 'Started',
            ENDED: 'Ended',
            CANCELLED: 'Cancelled',
        },
        MEETING_STATUS_TYPE_SHORT: {
            CREATED: 'P',
            PUBLISHED: 'P',
            STARTED: 'S',
            ENDED: 'E',
            CANCELLED: 'C',
        },
        MEETING_ATTENDEE_TYPE: {
            VIEWER: 'Attendee',
            MODERATOR: 'Moderator',
        },
        MODIFIER_TYPE: {
            ADDITION: 'Addition',
            BASE_SALARY_MODIFIER: 'Base Salary Modifier',
            EMPLOYEE_TAX: 'Employee Tax',
            EMPLOYER_TAX: 'Employer Tax',
            SUBTRACTION: 'Subtraction',
            TAX_MODIFIER: 'Tax Modifier',
        },
        MODIFIER_VARIABLE_TYPE: {
            DECIMAL: 'Decimal',
            INTEGER: 'Integer',
            LIST: 'List',
        },
        MONTH: {
            APR: 'April',
            AUG: 'August',
            DEC: 'December',
            FEB: 'February',
            JAN: 'January',
            JUL: 'July',
            JUN: 'June',
            MAR: 'March',
            MAY: 'May',
            NOV: 'November',
            OCT: 'October',
            SEP: 'September',
        },
        MONTH_DEBT_TYPE: {
            CANCEL: 'Cancel',
            DEBT_TRANSFER: 'Debt Transfer',
            INSTALLMENT: 'Installment',
            PREPAID_INSTALLMENT: 'Pre-Paid Installment',
            TRANSFER: 'Transfer',
        },
        MONTH_REVENUE_TYPE: {
            CANCEL: 'Cancel',
            DEBT_TRANSFER: 'Debt Transfer',
            INSTALLMENT: 'Installment',
            PAYMENT: 'Payment',
            PREPAID_INSTALLMENT: 'Prepaid Installment',
            REFUND: 'Refund',
            TRANSFER: 'Transfer',
        },
        MEETING_PROVIDER: {
            BBB: 'BigBlueButton(Default)',
            GOOGLE: 'Google Meet',
        },
        MULTIPLE_CHOICE_QUESTION_TYPE: {
            SINGLE_ANSWER: 'Single Answer',
            MULTIPLE_ANSWER: 'Multiple Answer',
        },
        QUESTION_INTENT_TYPE: {
            QUIZ: 'Quiz',
            SURVEY: 'Survey',
        },
        NOTIFICATION_TYPE: {
            EXAM_RESULT: 'Registration Result',
            STUDENT_PAYMENT_TIME: 'Student Payment Time',
            EXAM_INFO: 'Registration Info',
            UPCOMING_PAYMENT_DEADLINE: 'Upcoming Payment Deadline',
            COURSE_ATTENDANCE_NOTIFICATION: 'Course Attendance Notification',
            DAILY_ATTENDANCE_NOTIFICATION: 'Daily Attendance Notification',
            SNOW_DAY_NOTIFICATION: 'Snow Day School Closure',
            TEACHER_ATTENDANCE_NOTIFICATION: 'Teacher Attendance Notification',
        },
        NUMBER: {
            '1ST': '1st',
            '2ND': '2nd',
            '3RD': '3rd',
            '4TH': '4th',
            '5TH': '5th',
        },
        MESSAGING_PANEL_TYPE: {
            ANNOUNCEMENT: 'Announcements',
            USER_MESSAGES: 'Messages',
        },
        PAYMENT_SOURCE_TYPE: {
            BANK: 'Bank',
            CASH: 'Cash',
            CHEQUE: 'Cheque',
            POS: 'POS',
            ONLINE: 'Online',
        },
        PAYMENT_STATUS: {
            APPLIED: 'Applied',
            DRAFT: 'Draft',
        },
        PERMISSION: {
            DELETE: 'Delete',
            EDIT: 'Edit',
            VIEW: 'View',
        },
        PRE_REGISTRATION_STATUS: {
            APPROVED: 'Approved',
            COMPLETED: 'Completed',
            CONVERTED: 'Converted',
            DRAFT: 'Draft',
            FAILED: 'Failed',
            PASSED: 'Passed',
            REGISTERED: 'Registered',
        },
        PRE_REGISTRATION_EMAIL_STATUS: {
            NOT_SENT: 'Not Sent',
            SENDING: 'Sending',
            SENT: 'Sent',
        },
        PRE_REGISTRATION_SMS_STATUS: {
            NOT_SENT: 'Not Sent',
            SENDING: 'Sending',
            SENT: 'Sent',
        },
        QUARTER_TYPE: {
            QUARTER_1: '1st Quarter',
            QUARTER_2: '2nd Quarter',
            QUARTER_3: '3rd Quarter',
            QUARTER_4: '4th Quarter',
        },
        QUIZ_PAGINATION_TYPE: {
            ONE_BY_ONE: 'Every Question on new page',
            ALL_QUESTIONS: 'All Questions on one page',
            SEVERAL_QUESTIONS: 'Custom pagination',
        },
        REPRESENTATIVE_TYPE: {
            FATHER: 'Father',
            GUARDIAN: 'Guardian',
            MOTHER: 'Mother',
            CONTACT1: 'Contact-1',
            CONTACT2: 'Contact-2',
            CONTACT3: 'Contact-3',
            SELF: 'Self',
        },
        RESIDENT_TYPE: {
            FOREIGNER: 'Foreigner',
            LOCAL: 'Local',
        },
        ROLE_TYPE: {
            ROLE_ADMIN: 'Admin',
            ROLE_USER: 'User',
            ROLE_MANAGER: 'Manager',
            ROLE_STUDENT: 'Student',
            ROLE_TEACHER: 'Teacher',
            ROLE_SYSTEM: 'System',
            ROLE_TENANT_ADMIN: 'Tenant Admin',
            ROLE_EVERYONE: 'Everyone',
            ROLE_PARENT: 'Parent',
        },
        SALARY_CALCULATION_TYPE: {
            GROSS: 'Gross',
            NET: 'Net',
        },
        SCHOOL_LOG_INVOLVED_ENTITY_TYPE: {
            STUDENT: 'Student',
            EMPLOYEE: 'Employee',
        },
        SCHOOL_LOG_NOTIFICATION_SUBSCRIBER_TYPE: {
            DEAN: 'Dean',
            PARENT: 'Parent',
            HOMEROOM_TEACHER: 'Class Teacher',
            SUPERINTENDENT: 'Superintendent',
            PRINCIPAL: 'Principal',
            COUNSELOR: 'Counselor',
            NURSE: 'Nurse',
        },
        SCHOOL_LOG_POINT_TYPE: {
            POSITIVE: 'Positive',
            NEGATIVE: 'Negative',
        },
        SELF_ENROLLMENT_REGISTRATION_STATUS: {
            CREATED: 'Created',
            COMPLETED: 'Completed',
            CANCELED: 'Canceled',
        },
        SELF_ENROLLMENT_STATUS: {
            REGISTERED: 'Registered',
            APPROVED: 'Approved',
            REJECTED: 'Rejected',
        },
        SEMESTER_TYPE: {
            SEMESTER_1: '1st Semester',
            SEMESTER_2: '2nd Semester',
        },
        SEVERITY_TYPE: {
            LOW: 'Low',
            MINOR: 'Minor',
            SIGNIFICANT: 'Significant',
            CRITICAL: 'Critical',
        },
        SCHOOL_BALANCE_CHART_VIEW_TYPE: {
            BALANCE: 'Balance',
            CURRENT_DEBT: 'Current Debt',
            TOTAL_DEBT: 'Total Debt',
            TOTAL_DISCOUNT: 'Total Discount',
            TOTAL_PAID: 'Total Paid',
        },
        SCHOOL_CONSTANT_TYPE: {
            COMPANY_GUID: 'Company GUID',
            FOLDER: 'Folder',
            IP_ADDRESS: 'IP Address',
            ORGANIZATION: 'Organization',
            PASSWORD: 'Password',
            USERNAME: 'Username',
            BBB_BASE_URL: 'Online Learning Address(Url)',
            BBB_SHARED_SECRET: 'Online Learning Secret Code',
            WIRIS_LICENSE: 'WIRIS License',
            CERTIFICATE_TEMPLATE: 'Certificate Template',
            STUDENT_INFO_COUNSELOR_FIELD: 'Student Info Counselor Field',
            SPECIAL_ED_FIELD: 'Special Ed. Field',
            STUDENT_PROGRESS_CARD_TEMPLATE: 'Student Progress Card Template',
            SCHOOL_ID: 'School ID',
            DISTRICT_ID: 'District ID',
            STUDENT_COMMUNITY_HOURS_LOG_TYPE: 'Community Hours: Log Type',
            STUDENT_COMMUNITY_HOURS_FIELD: 'Community Hours: Field',
            STUDENT_ACTIVITIES_LOG_TYPE: 'Student Activities: Log Type',
            STUDENT_AWARDS_LOG_TYPE: 'Student Awards: Log Type',
            STUDENT_HONORS_LOG_TYPE: 'Student Honors: Log Type',
            ACT_CEEB_CODE: 'ACT/CEEB Code',
        },
        SOLANA_PARAMETER_TYPE: {
            STUDENT_PIN: 'Student PIN',
            ELIGIBILITY: 'Eligibility',
        },
        SOURCE_OF_INFORMATION_TYPE: {
            MAGAZINE: 'Magazine',
            MAILING_LIST: 'Mailing List',
            OTHER: 'Other',
            SOCIAL_NETWORKS: 'Social Networks',
            THIRD_PARTY_RECOMMENDATION: 'Third Party Recommendation',
            TV: 'TV',
        },
        SSML_VOICE_GENDER: {
            FEMALE: 'Female',
            MALE: 'Male',
            NEUTRAL: 'Neutral',
            SSML_VOICE_GENDER_UNSPECIFIED: 'Unspecified',
        },
        STATUS: {
            APPROVED: 'Approved',
            CREATED: 'Created',
        },
        STUDENT_FEE_STATUS: {
            APPROVED: 'Approved',
            COMPLETED: 'Completed',
            CREATED: 'Created',
            PROCESSING: 'Processing',
            CANCELLED: 'Cancelled',
        },
        STUDENT_PAYMENT_REPORT_VIEW_TYPE: {
            ONLY_DEBTORS: 'Only Debtors(Total)',
            ONLY_CURRENT_DEBTORS: 'Only Debtors(Not Paid)',
        },
        STUDENT_STATUS: {
            ACTIVE: 'Active',
            GRADUATED: 'Graduated',
            PASSIVE: 'Inactive',
            PRE_REGISTRATION: 'Pre Registration',
            TRANSFERRED: 'Transferred Out',
            SUSPENDED: 'Suspended',
        },
        SUBJECT_CATEGORY_ENUM: {
            TECHNICAL: 'Technical',
            HUMANITARIAN: 'Humanitarian',
        },
        SUBSCRIBER_TYPE: {
            USER: 'User',
            ROLE: 'Role',
            CLASS: 'Class',
            COURSE: 'Course',
            GROUP: 'Group',
        },
        SYLLABUS_CONTENT_ITEM_TYPE: {
            TEXT: 'Add Text',
            HINT: 'Add Hint',
            VIDEO: 'Add Video',
            YOUTUBE: 'Add Youtube',
            IMAGE: 'Add Image',
            QUESTION: 'Add Question',
            SECTION: 'Add Section',
            AUDIO: 'Add Audio',
            ATTACHMENT: 'Attachment',
        },
        TIMESHEET_SEARCH_STATUS: {
            APPROVED: 'Approved',
            CREATED: 'Created',
            NEW: 'New',
        },
        TIMESLOT_CONSTRAINT_TYPE: {
            TEACHERS: 'Teachers',
            COURSES: 'Courses',
            CLASSES: 'Classes',
            ROOMS: 'Locations',
        },
        TIMETABLE_FILTER_TYPE: {
            CLASSES: 'Classes',
            ROOMS: 'Locations',
            TEACHERS: 'Teachers',
        },
        TIME_FORMAT_TYPE: {
            HOUR24: '24-Hour Format',
            HOUR12: '12-Hour Format',
        },
        TRIAL_STATUS: {
            PROCESSING: 'Processing',
            COMPLETED: 'Completed',
        },
        TRASNFER_HOLIDAY_TYPE: {
            LEAVE: 'Leave',
            TRANSFER: 'Transfer',
            DELETE: 'Delete',
        },
        CURRICULUM_TYPE: {
            PARENT: 'Parent',
            CHILD: 'Child',
        },
        USER_MESSAGE_TYPE: {
            INFO: 'Info',
            SUCCESS: 'Success',
            ERROR: 'Error',
            WARNING: 'Warning',
        },
        VALUE_TYPE: {
            FIXED_VALUE: 'Fixed Value',
            FORMULA: 'Formula',
        },
        WEEK_DAY: {
            FRIDAY: 'Fr',
            MONDAY: 'Mo',
            SATURDAY: 'Sa',
            SUNDAY: 'Su',
            THURSDAY: 'Th',
            TUESDAY: 'Tu',
            WEDNESDAY: 'We',
        },
        WEEK_DAY_FULL: {
            FRIDAY: 'Friday',
            MONDAY: 'Monday',
            SATURDAY: 'Saturday',
            SUNDAY: 'Sunday',
            THURSDAY: 'Thursday',
            TUESDAY: 'Tuesday',
            WEDNESDAY: 'Wednesday',
        },
        IMPORTED_DATA_TYPE: {
            STUDENT: 'Student',
            EMPLOYEE: 'Employee',
            BUDGET_ACCOUNT: 'Budget Account',
        },
        INCIDENT_ENTITY_TYPE: {
            STUDENT: 'Student',
            EMPLOYEE: 'Employee',
            PARENT: 'Parent/Guardian',
            OTHER: 'Other',
        },
        INCIDENT_STATUS: {
            DRAFT: 'Open',
            PUBLISHED: 'Pending',
            RESOLVED: 'Resolved',
        },
        GRADE_CATEGORY_TEMPLATE_TYPE: {
            GRADE_CATEGORY: 'Grade Category',
            FINAL_GRADE: 'Final Grade',
        },
        QUESTION_STATUS: {
            DRAFT: 'Draft',
            PUBLISHED: 'Published',
        },
        QUESTION_DIFFICULTY_LEVEL: {
            EASY: 'Easy',
            MEDIUM: 'Medium',
            HARD: 'Hard',
        },
        QUESTION_TYPE: {
            TRUE_FALSE_CHOICE: 'True/False Choice',
            YES_NO_CHOICE: 'Yes/No Choice',
            MULTIPLE_CHOICE: 'Multiple Choice',
            MULTIPLE_QUESTION: 'Multiple Question',
            SHORT_ANSWER: 'Short Answer',
            ESSAY: 'Essay',
            MATCHING: 'Matching',
            DRAG_AND_DROP_INTO_TEXT: 'Drag and Drop Into Text',
            FILL_IN_THE_BLANK: 'Fill in The Blank',
            SELECT_ONE: 'Select One Option',
            DOCUMENT_UPLOAD: 'Document Upload',
            RANKING: 'Ranking',
        },
        RATING_FILTER: {
            EQUAL_TO: 'Equal To',
            GREATER_THAN: 'Greater Than',
            GREATER_THAN_OR_EQUAL: 'Greater Than or Equal',
            LESS_THAN: 'Less Than',
            LESS_THAN_OR_EQUAL: 'Less Than or Equal',
            BETWEEN: 'Between',
        },
        SPEECH_LANGUAGE: {
            en_GB: 'English (UK)',
            en_US: 'English (US)',
            ru_RU: 'Russian (Russia)',
            tr_TR: 'Turkish (Turkey)',
            fr_FR: 'French (France)',
            de_DE: 'German (Germany)',
        },
        STUDENT_ATTENDANCE_TYPE: {
            TODAY_PRESENT: 'Today in School',
            TODAY_ABSENT: 'Today Absent',
        },
        STATISTIC_TYPE: {
            QUIZ: 'By Quiz',
            BY_QUESTIONS: 'By Question',
        },
        ORDER_TYPE: {
            EMPLOYEE: 'Employee',
            STUDENT: 'Student',
            GENERAL: 'General',
        },
        COURSE_SELECT_TYPE: {
            CURRENT_COURSE: 'Current Course',
            SELECT_COURSES: 'Select Courses',
            ALL_COURSES: 'All Courses',
        },
        ATTENDANCE_GRADING_TYPE: {
            MAX_POINT: 'Total Lessons as Max Point',
            WEIGHT: 'Percentage',
        },
        STUDENT_PERMISSION_TYPE: {
            STUDENT_PARENT_INFO: 'Parent Info',
            STUDENT_MEDICAL_INFO: 'Medical Info',
            STUDENT_SOCIAL_INFO: 'Social Info',
            STUDENT_ETHNICITY_INFO: 'Ethnicity Info',
            STUDENT_LOGISTICS_INFO: 'Logictics',
            STUDENT_ADDITIONAL_INFO: 'Additional Info',
            STUDENT_GRADING_INFO: 'Gradings',
            STUDENT_ATTENDANCE_INFO: 'Attendances',
            STUDENT_CONTACT_INFO: 'Contact Info',
            STUDENT_SIBLINGS_INFO: 'Siblings Info',
            STUDENT_ATTACHMENTS: 'Attachments',
            STUDENT_ENROLLMENTS: 'Enrollments',
            STUDENT_ACHIEVEMENTS: 'Achievements',
            STUDENT_DISCOUNTS: 'Discounts',
            STUDENT_COURSES: 'Enrolled Courses',
            STUDENT_DOCUMENTS: 'Official Documents Info',
            STUDENT_COURSE_SCHEDULE: 'Timetable',
            STUDENT_COURSE_SNAPSHOT: 'Performance',
            STUDENT_INCIDENT_INFO: 'Student Incident',
        },
        TEACHER_PERMISSION_TYPE: {
            TEACHER_BASIC_INFO: 'Basic Info',
            TEACHER_CONTACT_INFO: 'Contact Info',
            TEACHER_GIVEN_SUBJECT: 'Given Subjects',
            TEACHER_DOCUMENTS: 'Documents',
            TEACHER_EXPERIENCES: 'Experiences',
        },
        GRADING_PERMISSION_TYPE: {
            ALL_GRADINGS: 'All Gradings',
            SUBJECT_GRADINGS: 'Just Subject Gradings',
            OWN_CLASS_GRADING: 'Own Class Gradings',
        },
        ATTENDANCE_PERMISSION_TYPE: {
            ALL_ATTENDANCE: 'All Attendances',
            SUBJECT_ATTENDANCE: 'Just Subject Attendances',
            OWN_CLASS_ATTENDANCE: 'Own Class Attendances',
        },
        OPERATOR_TYPE: {
            EQUALS: 'Equals',
            DOES_NOT_EQUAL: 'Does not equal',
            GRATER_THAN: 'Greater than',
            GRATER_THAN_OR_EQUAL_TO: 'Greater than or equal to',
            LESS_THAN: 'Less than',
            LESS_THAN_OR_EQUAL_TO: 'Less than or equal to',
            CONTAINS: 'Contains',
            DOES_NOT_CONTAIN: 'Does not contain',
            CONTAINS_CATEGORY: 'Contains',
            BEFORE: 'Before',
            AFTER: 'After',
            BEFORE_INCLUDING: 'Before (including)',
            AFTER_INCLUDING: 'After (including)',
            IS_EMPTY: 'is Empty',
        },
        TIME_TABLE_TYPE: {
            TRADITIONAL: 'Traditional',
            AB: 'A/B',
        },
        AB_DAYS_COUNT: {
            A: 'A',
            AB: 'A, B',
            ABC: 'A, B, C',
            ABCD: 'A, B, C, D',
            ABCDE: 'A, B, C, D, E',
        },
        INCIDENT_TIME_FRAME: {
            DURING_SCHOOL_TIME: 'During School Hours',
            OUT_SIDE_SCHOOL_TIME: 'Outside School Hours',
        },
        INCIDENT_STATISTIC_TYPE: {
            ACTION: 'Action',
            BEHAVIOR: 'Behavior',
            INCIDENT_TYPE: 'Incident Type',
            CUSTOM: 'Custom',
        },
        STUDENT_MEDICAL_ATTACHMENT_TYPE: {
            IMMUNIZATION: 'Immunization',
            OTHER: 'Other',
        },
        MEDICATION_TAKING_FREQUENCY: {
            ONCE_A_DAY: 'Once a day',
            TWICE_A_DAY: 'Twice a day',
            THREE_TIMES_A_DAY: 'Three times a day',
            FOUR_TIMES_A_DAY: 'Four times a day',
            AS_NEEDED: 'As needed',
        },
        MEDICATION_INVENTORY_ACTION_TYPE: {
            RECEIVED: 'Received',
            ADMINISTERED: 'Administered',
            WASTED: 'Wasted',
            DAMAGED: 'Damaged',
            LOST: 'Lost',
            RETURNED: 'Returned',
            EXPIRED: 'Expired',
        },
        MEDICATION_LOG_TYPE: {
            ADMINISTERED: 'Administred',
            REFUSED: 'Refused',
            ABSENT: 'Absent',
            NO_MEDICATION: 'No Medication',
        },
        STATE_REPORT_GROUP: {
            ATTENDANCE: 'Attendance',
            ASSESSMENT: 'Assessment',
            COURSE: 'Course',
            SPECIAL_EDUCATION: 'Special Education',
            STAFF: 'Staff',
            STUDENT: 'Student',
            STUDENT_PROGRAM: 'Student Program Participation ',
        },
        STATE_REPORT_TEMPLATES: {
            STUDENT_RESTRAINT_EVENT: 'Student Restraint Events',
            ASSESSMENT_ACC_MOD_FACT: 'Assessment Acc Mod Fact',
            ASSESSMENT_RESPONSE: 'Assessment Response',
            ASSESSMENT_SESSION_FACT: 'Assessment Session Fact',
            ASSESSMENT_FACT: 'Assessment Fact',
            ATTENDANCE_CODES: 'Attendance Codes',
            COURSE: 'Course',
            COURSE_INSTRUCTOR_ASSIGNMENT: 'Course Instructor Assignment',
            DAY_CALENDAR: 'Day Calendar',
            LOCATION_MARKING_PERIOD: 'Location Marking Period',
            MARKING_PERIOD_CODE: 'Marking Period Code',
            PARTNER_PROJECT_FACT: 'Programs Partner Fact',
            PROGRAMS_FACT: 'Programs Fact',
            SCHOOL_ENTRY_EXIT: 'School Entry Exit',
            SPECIAL_EDUCATION_EVENTS: 'Special Education Events',
            SPECIAL_EDUCATION_SNAPSHOT: 'Special Education Snapshot',
            STAFF_ASSIGNMENT: 'Staff Assignment',
            STAFF_ATTENDANCE: 'Staff Attendance',
            STAFF_EVALUATION_RATING: 'Staff Evaluation Rating',
            STAFF_SNAPSHOT: 'Staff Snapshot',
            STAFF_TENURE_SNAPSHOT: 'Staff Tenure',
            STUDENT_CLASS_ENTRY_EXIT: 'Student Class Entry Exit',
            STUDENT_CLASS_GRADE_DETAIL: 'Student Class Grade Detail',
            STUDENT_CREDIT_GPA: 'Student Credit GPA',
            STUDENT_DAILY_ATTENDANCE: 'Student Daily Attendance',
            STUDENT_DIGITAL_RESOURCES: 'Student Digital Resources',
            STUDENT_LITE: 'Student Lite',
        },
        STATE_FIELD_FORMAT: {
            ALPHANUMERIC: 'Alphanumeric',
            NUMERIC: 'Numeric',
            DATE: 'Date',
        },
        TEMPLATE_TYPE: {
            CONTRACT: 'Contract',
            DISCIPLINE_LETTER: 'Discipline letter',
            REGISTRATION: 'Registration',
            SCHOOL_LOG: 'School Log',
        },
        STANDARD_CALC_STARTEGY: {
            AVERAGE_SCORE: 'Average Score of Child Standards',
            HIGHEST_SCORE: 'Highest Score of Child Standards',
            TURN_OFF: 'Turned Off',
        },
        ASSESSMENT_TEACHER_ACCESS: {
            NO_ACCESS: 'No Access',
            VIEW_ONLY: 'View Only',
            MODIFY: 'Modify',
            CREATE: 'Create',
            FULL_ACCESS: 'Full Access',
        },
        ASSESSMENT_FINAL_SCORE_CHOICE: {
            LAST: 'Last Score',
            MAX: 'Maximum Score',
        },
        GRADING_TYPE: {
            STANDARD_BASED: 'Standard Based',
            TRADITIONAL: 'Traditional',
        },
        STANDARD_CALCULATION_TYPE: {
            MOST_RECENT: 'Most recent',
            MEAN: 'Mean',
        },
    },
    STATE_REPORT: {
        TITLE: {
            BROWSER: 'State Report Fields',
            REPORT: 'Report Name',
            FIELD_NAME: 'Field Name',
            KEY_FIELD: 'Key Field',
            PURPOSE: 'Purpose',
            INSTRUCTION: 'Instruction',
            FORMAT: 'Format',
            DATA_SOURCE: 'Data Source',
            FILL_SPACE_WITH: 'Fill Spaces With',
            SHOW_ONLY_ENABLED_FIELDS: 'Show Only Enabled Fields',
        },
    },
    STATE_REPORTS: {
        TITLE: {
            BROWSER: 'State Reports',
        },
    },
    EXAM_REGISTRATION: {
        FIELD: {
            APPROVEMENT_TEXT: 'I confirm that the above information is correct',
            CHOOSE_EXAM: 'Choose Registration',
            CHOOSE_LANGUAGE: 'Choose Language',
            CURRENT_GRADE: 'Current Grade Level',
            EXAM_DATE_RANGE: 'Registration Date Range',
            EXAM_INFO: 'Registration Info',
            EXAM_PLACE: 'Exam Place',
            EXAM_SELECTION: 'Registration Selection',
            EXAM_TIME: 'Exam Time',
            GRADE_LEVEL_OF_REGISTRATION: 'Grade Level of Registration',
            HOW_HEAR_ABOUT_US: 'How did you hear about us?',
            IS_DORMITORY_NEEDED: 'Would you like to stay in a dormitory?',
            LANGUAGE_SELECTION: 'Language Selection',
            NEED_DORMITORY: 'Plans to live in the hostel',
            PREV_SCHOOL: 'Previous School',
            PRE_REGISTRATIONS: 'Pre-registrations',
            REGISTRATION_ID: 'Registration ID',
            SOURCE_OF_INFORMATION: 'Source Of Information',
            STUDENT: 'student(s)',
            TO_STUDENT: 'Send to Student',
            TO_REPRESENTATIVE: 'Send to representatives contacts',
            SEND_EXAMINATION_SLIP: 'Send Registration Form',
        },
        MESSAGE: {
            CANT_DEL_REG_STUDENT: 'You cannot delete registered student!',
            CONFIRM: {
                APPROVE: 'All selected registration applications will be approved. Are you sure?',
                CANCEL: 'Do you want to cancel this registration form?',
                CANCEL_CONFIRM_MESSAGE:
                    'Are you sure you want to delete the exam place, date and time of selected students, and change the status to “Approved”?',
                DATE_WILL_BE_SENT: 'The date and place of the exam will be sent to you soon.',
                DATE_WILL_BE_SENT_AFTER_PAYMENT:
                    'Once the registration has been completed, the time and location of the exam will be send to you via e-mail.',
                DELETE: 'All selected registration applications (Draft) will be deleted. Are you sure?',
                EMAIL_CONFIRM_MESSAGE:
                    'Are you sure you want to send an e-mail to these students including exam place, date and time?',
                EXPORT: 'Do you want to export pre-registered students as a excel file?',
                MARK_AS_FAILED: 'Are you sure to mark as "Failed" chosen students?',
                MARK_AS_PASSED: 'Are you sure to mark as "Passed" chosen students?',
                MARK_AS_RESERVE: 'Are you sure to mark as "Reserve" chosen students?',
                REGISTRATION_FINISHED: 'Registration successfully completed',
                SUBMIT: 'Do you want to submit this registration form?',
                TO_FINISH_REGISTRATION: 'To Finish Registration',
                UN_APPROVE:
                    'All selected registration applications (Approved) will be REGISTERED (Un-Approve). Are you sure?',
            },
            EMAIL_DUPLICATED: 'E-mail is already exists',
            EMAIL_DOES_NOT_EXISTS: 'There is no e-mail address of Registrar. Write at least one e-mail address',
            REG_DATE_EXAM_EXPIRED: 'The registration date for this exam has expired! Choose another exam',
            REG_DATE_NOT_STARTED: 'The date of registration of this exam has not started yet! Choose another exam',
            REQ_ATT_UPLOADED: 'Required attachments must be uploaded!',
            SUCCESS: {
                COMPLETED: 'Pre-registrations successfully completed',
                FAILED: 'Chosen students "Failed" entrance examination',
                PASSED: 'Chosen students "Passed" entrance examination',
                RESERVED: 'Chosen students were taken to "Reserve"',
                SENT: "Pre-registration's e-mails successfully sent",
            },
            USE_AS_DATE_TO: 'Use <b>{{value}}</b> as Date to',
            USE_AS_DEBT: "Use <b>{{value}}</b> as Student's  debt",
            USE_AS_NET_DEBT: "Use <b>{{value}}</b> as Student's debt(Not Paid) ",
            USE_AS_REG_NUMBER: 'Use <b>{{value}}</b> as Registration Number',
            USE_AS_TEACHER_FULLNAME: "Use <b>{{value}}</b> as Teacher's fullname",
            USE_AS_COURSES: 'Use <b>{{value}}</b> as courses',
            USE_AS_STUDENT_FULLNAME: "Use <b>{{value}}</b> as Student's fullname",
            USE_AS_STUDENT_FIRST_NAME: "Use <b>{{value}}</b> as Student's First Name",
            USE_AS_STUDENT_MIDDLE_NAME: "Use <b>{{value}}</b> as Student's Middle Name",
            USE_AS_STUDENT_LAST_NAME: "Use <b>{{value}}</b> as Student's Last Name",
            USE_AS_STUDENT_PARENT: "Use <b>{{value}}</b> as Parent's fullname",
            USE_AS_PARENT_FIRST_NAME: "Use <b>{{value}}</b> as Parent's First Name",
            USE_AS_PARENT_MIDDLE_NAME: "Use <b>{{value}}</b> as Parent's Middle Name",
            USE_AS_PARENT_LAST_NAME: "Use <b>{{value}}</b> as Parent's Last Name",
            USE_AS_TOTAL_FEE: "Use <b>{{value}}</b> as Student's debt",
            USE_AS_TOTAL_PAID: "Use <b>{{value}}</b> as Student's total paid",
            USE_AS_EXAM_DATE: 'Use <b>{{value}}</b> as Registration Date',
            USE_AS_EXAM_TIME: 'Use <b>{{value}}</b> as Registration Time',
            USE_AS_EXAM_PLACE: 'Use <b>{{value}}</b> as Registration Place',
            USE_AS_EXAM_NAME: 'Use <b>{{value}}</b> as Registration Name',
            USE_AS_FULLNAME: 'Use <b>{{value}}</b> as Fullname',
            USE_AS_CLASS: 'Use <b>{{value}}</b> as Class',
            USE_AS_DIRECTOR_NAME: "Use {{value}} as Director's Fullname",
            USE_AS_POSITION: 'Use <b>{{value}}</b> as Position',
            USE_AS_TRANSFERRING_CLASS: 'Use <b>{{value}}</b> as Transferring Class',
            PARENTS_FULLNAME: "Parent's fullname",
            REGISTRATION_NUMBER: 'Registration Number',
            FULLNAME: 'Full name',
            CLASS: 'Class',
            DIRECTOR_NAME: "Director's Fullname",
            POSITION: 'Position',
            TRANSFERRING_CLASS: 'Transferring Class',
            USE_AS_CURRENT_DATE: 'Use <b>{{value}}</b> Current Date',
            USE_AS_PERIOD_TIME: 'Use <b>{{value}}</b> as Period time; e.g. 10:00',
            USE_AS_COURSE_NAME: 'Use <b>{{value}}</b> as Course name; e.g. Math 8A',
            USE_AS_PERIOD_COURSE_NAME:
                'Use <b>{{value}}</b> as Period with Course name; e.g. 10:00 Math 8A, 11:00 Physics 8A',
            ONE_OR_MORE_PERIOD_OR_COURSE_NAME: 'If more than 1 period or course, shows all separated by comma',
        },
        TITLE: {
            APPROVEMENT: 'Registration Approvement',
            BROWSER: 'Registration Form',
            COMPLETE: 'Registration Complete',
            CONTACT_1: 'Contact-1 (*)',
            CONTACT_2: 'Contact-2 (*)',
            NEW_PRE_REGISTRATION: 'New Pre-registration',
            NEW_PRE_REGISTRATIONS: 'New Pre-registrations',
            PRE_REGISTRATION: 'Pre-registration',
            PRE_REGISTRATION_WITH_PARAM: 'Pre-registration - {{param}}',
            REPRESENTATIVE_INFO: 'Parent Info',
            RESULT: 'Registration Result',
            SET_EXAM_INFO: 'Registration Info',
            AGREEMENT: 'Agreement',
        },
    },
    EXPERIENCE_BASED_SALARY: {
        TITLE: {
            BROWSER: 'Experience Based Salaries',
        },
    },
    FEE_TYPES: {
        TITLE: {
            ADD: 'Add Fee Type',
            BROWSER: 'Fee Types',
            CHOOSE: 'Choose Fee Type',
            NEW: 'New Fee Type',
        },
    },
    GENERAL: {
        BUTTON: {
            ACTIVATE: 'Activate',
            ADD: 'Add',
            ADD_COURSE: 'Add Course',
            ADD_ATTACHMENT: 'Add Document',
            ADD_AND_NEW: 'Add & New',
            ADD_AND_CLOSE: 'Add & Close',
            ADD_CONTACT: 'Add Contact',
            ADD_REPRESENTATIVE: 'Add Parent',
            ADD_SHORT: 'Add',
            APPLY: 'Apply',
            APPLY_AND_NEW: 'Apply & New',
            APPLY_SHORT: 'Apply',
            APPROVE: 'Approve',
            SAVE_APPROVE: 'Save & Approve',
            ACCEPT: 'Accept',
            DECLINE: 'Decline',
            APPROVE_AND_NEW: 'Apply & New',
            ATTACH_FILE: 'Attach File',
            AUDIO: 'Audio',
            BLOCK: 'Block',
            BACK: 'Back',
            CALCULATE: 'Calculate',
            CANCEL: 'Cancel',
            CANCEL_COMPLETE: 'Cancel',
            CHANGE: 'Change',
            REPLACE: 'Replace',
            CHANGE_DISCOUNTS: 'Change Discounts',
            CHANGE_PASSWORD: 'Change Password',
            CHECK: 'Check',
            CLEAR: 'Clear',
            CLEAR_ALL: 'Clear All',
            CLOSE: 'Close',
            COMPLETE: 'Complete',
            COPY_FROM: 'Copy From',
            COPY: 'Copy',
            COPY_FROM_ARCHIVE: 'Copy From Archive',
            COLLAPSE: 'Collapse',
            COLLAPSE_ALL: 'Collapse all',
            EXPAND_ALL: 'Expand all',
            CREATE_USER_ACCOUNT: 'Create Account',
            BULK_ENROLL: 'Bulk Enroll',
            BULK_ASSIGN: 'Bulk Assign',
            GIVE_BULK_PERMISSION: 'Give Bulk Permission',
            REMOVE_BULK_PERMISSION: 'Remove Bulk Permission',
            ADJUST_TO_FIFTY: 'Adjust Grades',
            CREATE_FOLDER: 'Create Folder',
            DELETE: 'Delete',
            DELETE_FILE: 'Delete File',
            DETAILS: 'Details',
            DISMISS: 'Dismiss',
            DOWNLOAD: 'Download',
            DOWNLOAD_FILE: 'Download File',
            EDIT: 'Edit',
            EDIT_AND_NEW: 'Edit & New',
            ENROLL: 'Enroll',
            EXCEL: 'Excel',
            EXCEL_EXPORT: 'Excel Export',
            EXCEL_UPLOAD: 'Import from Excel',
            CSV_UPLOAD: 'Import from CSV',
            CSV_TEMPLATE_DOWNLOAD: 'Download CSV Template',
            EXCEL_TEMPLATE_DOWNLOAD: 'Excel Template for Import',
            EXPAND: 'Expand',
            EXPORT: 'Export',
            FINISH: 'Finish',
            GENERATE: 'Generate',
            GENERATE_PDF: 'Generate PDF',
            IMPORT: 'Import',
            IMPORT_ACTUAL: 'Import Actual (from Accounting)',
            IMPORT_FROM_CAMPUS: 'Import from SIS',
            IMPORT_STUDENT: 'Import Student',
            IMPORT_FROM_TENANT: 'Import from Tenant',
            MANAGE_GROUPS: 'Manage Groups',
            MARK_AS_COMPLETED: 'Mark as "Completed"',
            MARK_AS_FAILED: 'Mark as "Failed"',
            MARK_AS_PASSED: 'Mark as "Passed"',
            MARK_AS_RESERVE: 'Mark as "Reserve"',
            MARK_AS_READ: 'Mark as "Read"',
            MARK_ALL_AS_READ: 'Mark all as "Read"',
            MARK_PAGE_AS_READ: 'Mark all on page as "Read"',
            NEW: 'New',
            NEXT: 'Next',
            NO: 'No',
            PAUSE: 'Pause',
            PDF_EXPORT: 'Pdf Export',
            PLAY: 'Play',
            PREVIOUS: 'Previous',
            PRINT: 'Print',
            PRINT_SETTINGS: 'Print Settings',
            REFRESH: 'Refresh',
            REGISTER: 'Register',
            REJECT: 'Reject',
            REJOIN: 'Rejoin',
            REMOVE: 'Remove',
            RENAME: 'Rename',
            REPORT: 'Report',
            SAVE: 'Save',
            SAVE_AND_NEW: 'Save & New',
            SAVE_AND_CLOSE: 'Save & Close',
            SAVE_AND_FINISH: 'Save & Finish',
            SAVE_AS_DRAFT: 'Save as Draft',
            SAVE_ENROLLMENT: 'Save Enrollment',
            SEARCH: 'Search',
            SELECT: 'Select',
            SEND: 'Send',
            SEND_EMAIL: 'Send E-mail',
            SEND_SMS: 'Send SMS',
            SEND_NOTIFICATION: 'Send Notification',
            SHARE: 'Share',
            SNAPSHOT: 'Snapshot',
            TEST: 'Test',
            TO_IMPORT: 'Import',
            TODAY: 'Today',
            TRANSFER: 'Transfer',
            UN_APPLY: 'Un Apply',
            UNAPPROVE: 'Unapprove',
            UN_REGISTER: 'Un-Register',
            UPDATE: 'Update',
            UPDATE_A_DRAFT: 'Update a Draft',
            UPLOAD: 'Upload',
            UPLOAD_ACTUAL: 'Upload Actual (from Excel)',
            UPLOAD_FILE: 'Upload File',
            VIEW: 'View',
            YES: 'Yes',
            REVERT: 'Revert',
            RESTORE: 'Restore',
            LISTEN: 'Listen',
            HOME: 'Home',
            REGENERATE: 'Regenerate',
            CALCULATE_ATTENDANCE: 'Calculate from Attandance',
            VALIDATE: 'Validate',
            SEND_FILES: 'Send Files',
            DOWNLOAD_FILES: 'Download Files',
            LOGS: 'Logs',
        },
        FIELD: {
            ALERT: 'Alert',
            AVAILABILITY: 'Availability',
            ACADEMIC_PERIOD: 'Academic Period',
            ACADEMIC_YEAR: 'Academic Period',
            ACADEMIC: 'Academic',
            ACTIVE: 'Active',
            ACTUAL_FEE: 'Actual Fees',
            ACTUAL_PAYMENT: 'Payments',
            ADDRESS: 'Address',
            ADDRESS_INFO: 'Address',
            ADD_TO_GROUP: 'Add to Group',
            ALL: 'All',
            ALLERGY: 'Allergy',
            ADD: 'Add',
            ADD_EVENT: 'Add Event',
            AMOUNT: 'Amount',
            ANSWER_POSITION_ON_PRINT: 'Answer Position',
            ARRAY: 'Array',
            ATTACHMENTS: 'Attachments',
            ATTENDEE_COUNT: 'Attendee Count',
            ASSIGNED_TO: 'Assigned To',
            ATTENDANCE: 'Attendance',
            ATTENDANCE_MODALITY: 'Provided Education Mode',
            AVERAGES: 'Average',
            MIN_ATTENDANCE: 'Min.Attendance',
            BACK_TO_DASHBOARD: 'Go Back to Dashboard',
            BALANCE_TYPE: 'Balance Type',
            BANK: 'Bank',
            BANK_ACCOUNT: 'Bank Account',
            BANK_INFO: 'Bank Information',
            BARCODE: 'Barcode',
            BASIC_INFO: 'Basic Info',
            BUDGET: 'Budget',
            BUDGET_ACCOUNT: 'Budget Account',
            BUDGET_ACCOUNT_WITH_PARAM: 'Budget Account - {{param}}',
            BUDGET_COPY: 'Budget Copy',
            BUDGET_GROUP: 'Budget Group',
            BUDGET_PROJECT: 'Budget Project',
            BUDGET_TEMPLATE: 'Budget {{item}} Template',
            BUSINESS_TIME_START: 'Event Start Time',
            BUSINESS_TIME_END: 'Event End Time',
            CALCULATE_SALARY: 'Calculate Salary',
            CANCELLED: 'Cancelled',
            CAPACITY: 'Capacity',
            CASH: 'Cash',
            CATEGORY: 'Category',
            SUB_CATEGORY: 'Subcategory',
            CATEGORY_TYPE: 'Category Type',
            CHEQUE: 'Cheque',
            CHATS: 'Chats',
            CHILD_TYPE: 'Content Type',
            PRIVATE_CHAT: 'Private Chat',
            CALENDAR_SETTINGS: 'Schedule Settings',
            CITIZENSHIP: 'Citizenship',
            CITY: 'City',
            CLASS: 'Class',
            CLASS_SHORT: 'Class',
            CLASSES: 'Classes',
            CLASS_TEACHER: 'Class Teacher',
            CLOSE: 'Close',
            CLOSING_ACCOUNT_CODE: 'Closing Account Code',
            CODE: 'Code',
            COLUMN_SIZE: 'Column Size',
            COLUMN_COUNT: 'Column Count',
            COMMENT: 'Comment',
            CONNECTIONS: 'Connected Applications',
            CONTACT: 'Contact',
            CONTACTS: 'Contacts',
            CONTACT_AND_ADDRESS: 'Contact & Address',
            CONTACT_INFO: 'Contact Info',
            CONTACT_INFO_EDIT: 'Contact Info',
            CONTACT_INFO_NEW: 'New Contact Info',
            COST_CENTER: 'Cost Center',
            COUNTRY: 'Country',
            COURSES: 'Courses',
            COURSE_ASSIGNMENT: 'Course Assignment',
            COURSE: 'Course',
            COURSE_EVENT_LENGTH: 'Course Event Create for Week(s)',
            COURSE_EVENT_BEFORE_CREATE: 'Course Event Create before (Day(s))',
            CURRENCY: 'Currency',
            CURRENCY_FORMAT: 'Currency Format',
            CURRENT_CLASS: 'Current Class',
            CURRENT_DEBT: 'Current Debt',
            CURRICULUM: 'Curriculum',
            CUT_OFF: 'Cut Off',
            PAY_PAYPAL: 'Pay With PayPal',
            CUSTOM_FIELD_GROUP: 'Custom Field Group',
            DATE: 'Date',
            TIME: 'Time',
            DATE_CHANGED: 'Date Changed',
            DATE_CREATED: 'Date Created',
            DATE_OF_BIRTH: 'Date of Birth',
            DATE_FROM: 'Date From',
            DATE_FORMAT: 'Date Format',
            DATE_TO: 'Date To',
            DATE_RANGE: 'Date Range',
            DECIMAL_FORMAT: 'Decimal Format',
            DEFAULT_LANGUAGE: 'Default Language',
            DEFAULT_THEME: 'Default Theme',
            COURSE_DELIVERY_METHOD: 'Delivery Method',
            PURPLE_THEME: 'Purple Theme',
            GREEN_THEME: 'Green Theme',
            DARK_PURPLE_THEME: 'Dark Purple Theme',
            INDIGO_THEME: 'Indigo',
            DATA_LANGUAGE: 'Data Language',
            DEFAULT_PRESENTATION: 'Default Presentation File',
            DELETED: 'Deleted',
            DESCRIPTION: 'Description',
            DISCOUNT: 'Discount',
            DISCOUNTS: 'Discounts',
            DISCOUNT_AMOUNT: 'Discount Amount',
            DISEASE: 'Disease',
            DISTRICT: 'District',
            DOCUMENT: 'Document',
            DOCUMENT_INFO: 'Document',
            DOCUMENT_NUMBER: 'Document Number',
            DOCUMENT_TYPE: 'Document Type',
            DONE: 'Done',
            DUE_DATE: 'Due Date',
            EMAIL: 'E-mail',
            EMAIL_TEST: 'Test E-mail',
            EMAIL_STATUS: 'E-mail Status',
            EMPLOYEE: 'Employee',
            EMPLOYEE_ID: 'Employee ID',
            EMPLOYEE_POSITION: 'Employee Position',
            EMPLOYEE_TYPE: 'Employee Type',
            EMPLOYEE_WITH_PARAM: 'Employee - {{param}}',
            ENABLED: 'Enabled',
            END_DATE: 'End Date',
            END_TIME: 'End Time',
            END_YEAR: 'End Year',
            ENROLL_DATE: 'Date of Enroll',
            ENTRANCE_EXAM: 'Registration',
            ERROR: 'Error',
            EXAM: 'Registration',
            EXAMPLE: 'Ex:',
            EXAM_DATE: 'Exam Date',
            REGISTRATION_DATE: 'Registration Date',
            EXAM_DATE_RANGE: 'Registration Date Range',
            EXAM_WITH_PARAM: 'Registration - {{param}}',
            EXPIRE_DATE: 'Date of Expire',
            EXTERNAL_RESOURCE_VIEW: 'External Resource View',
            FEE: 'Fee',
            FEES: 'Fees',
            FEE_AMOUNT: 'Fee Amount',
            FEE_TYPE: 'Fee Type',
            FIELD: 'Field',
            FIELDS: 'Fields',
            FILE_NAME: 'File Name',
            FILE_PATH: 'Path',
            FILE_SIZE: 'Number of Documents',
            FILTER: 'Filter',
            FIRST_NAME: 'First Name',
            FIRST_REPRESENTATIVE_NAME: '1st Parent Name',
            FIRST_REPRESENTATIVE_EMAIL: '1st Parent E-mail',
            FORMULA: 'Formula',
            FORMULA_APR: 'Formula (April)',
            FORMULA_AUG: 'Formula (August)',
            FORMULA_DEC: 'Formula (December)',
            FORMULA_FEB: 'Formula (February)',
            FORMULA_JAN: 'Formula (January)',
            FORMULA_JUL: 'Formula (July)',
            FORMULA_JUN: 'Formula (Jun)',
            FORMULA_MAR: 'Formula (March)',
            FORMULA_MAY: 'Formula (May)',
            FORMULA_NOV: 'Formula (November)',
            FORMULA_OCT: 'Formula (October)',
            FORMULA_SEP: 'Formula (September)',
            FORMULA_TYPE: 'Formula Type',
            FORMULA_VARIABLE: 'Formula Variable',
            FROM: 'From',
            FROM_VALID: 'Valid From',
            FULL_NAME: 'Full Name',
            GENDER: 'Gender',
            GENERATE_CARD: 'ID Card',
            GIVEN_DATE: 'Given Date',
            GRADE_LEVEL: 'Grade Level',
            GRAND_TOTAL_DISCOUNT: 'GRAND TOTAL(Discount)',
            GRAND_TOTAL_FEE: 'GRAND TOTAL(Fee)',
            GRADING_DUE_DATE: 'Grading Due',
            HOURS_REQUIRED: 'Hours Required',
            HIDE_SYLLABUS: 'Hide Syllabus',
            HIDE_ON_VIEW_MODE: 'Hide on View Mode',
            HINT: 'Hint',
            ID_CARD_BACKGROUND_IMAGE: 'ID Card Background Image',
            IMPORT_PERIOD: 'Period for Import',
            INCOME_PLAN: 'Income Plan',
            INCOME_PLAN_WITH_PARAM: 'Income Plan - {{param}}',
            INFORMATION: 'Information',
            INTEGRATION_CODE: 'Integration Code',
            INTEGRATION_CODES: 'Integration Codes',
            INTERVAL_MONTH: 'Interval Month',
            INT_CODE: 'Int. Code',
            IN_PROGRESS: 'In Progress',
            IMAGE: 'Image',
            ITEM: 'Item',
            ITEM_WITH_PARAM: 'Item - {{param}}',
            JOB_TITLE: 'Job',
            KEY: 'Key',
            LANGUAGE: 'Language',
            LAST_NAME: 'Last Name',
            LAST_LOGGIN_TIME: 'Last Login Time',
            LESSONS_PER_WEEK: 'Lessons per Week',
            MAXIMIZE: 'Maximize',
            MEASUREMENT_UNIT: 'Measurement Unit',
            MEDICAL: 'Medical',
            MEETING: 'Meeting',
            MEETING_PROVIDER: 'Provider',
            MESSAGE: 'Message',
            MIDDLE_NAME: 'Middle Name',
            MINIMIZE: 'Minimize',
            MOBILE_PHONE: 'Mobile',
            MODIFIER_TYPE: 'Modifier Type',
            MODIFIER_VARIABLE_TYPE: 'Modifier Variable Type',
            MONTH: 'Month',
            MONTH_EVENTS: 'Monthly',
            MY_DRIVE: 'My Drive',
            MY_EVENTS: 'My Events',
            MULTIPLIER: 'Multiplier',
            NA: 'Not Assigned',
            NAME: 'Name',
            NAME_OR_CODE: 'Name or Code',
            NAME_ORDER: 'Name Order',
            NATIONALITY: 'Nationality',
            NET_AMOUNT: 'Net Amount',
            NET_DEBT: 'Net Debt',
            NEXT_GRADE: 'Next Grade',
            NEW_CHAT_MESSAGES: 'New Chat Message',
            INCOMING_MESSAGES: 'Incoming Messages',
            ONLINE_USERS: 'Online Users',
            NO: 'No',
            NONE: 'None',
            NONWORKING_DAYS: 'Non Working Days',
            NOTE: 'Note',
            NOTES: 'Notes',
            NOTIFICATION: 'Notification',
            NOTIFICATION_WITH_PARAM: 'Notification - {{param}}',
            NOT_ENROLLED: 'Not enrolled',
            NUMERO: '#',
            NUM_OF_LESSONS: 'Number of Lessons',
            NUM_OF_VERSIONS: 'Number of Versions',
            ORDER: 'Order',
            OTHER_INFO: 'Additional Info',
            OWNER: 'Owner',
            PAGE_NOT_FOUND: 'Sorry! But we could not find the page you are looking for',
            PAGE_PERMISSION_ERROR: "Sorry! You don't have any permission to access this resource: {{url}}",
            PARENT_ACCOUNT_CODE: 'Parent Account Code',
            PARENT_CONTACT: "Parent's Contact",
            PARENT_PHONE_NUMBER: "Parent's Phone",
            PANEL: 'Panel',
            PASSWORD_CURRENT: 'Current Password',
            PASSWORD_NEW: 'New Password',
            PASSWORD_RETRY_NEW: 'New Password (Retry)',
            PAYER_INFO: 'Payer Info',
            PAYMENT_CALENDAR: 'Payment Plan',
            PAYMENT_COUNT: 'Payment Count',
            PERCENTAGE: 'Percentage',
            PERIOD: 'Period',
            PERIODS: 'Periods',
            PERMISSION: 'Permission',
            PERSONAL_ID: 'Personal ID',
            PHONE: 'Phone',
            PHOTO: 'Photo',
            PLEASE_SELECT_ITEM: 'Please Select an Item',
            POS: 'Pos',
            POSITION: 'Position',
            POSTAL_CODE: 'Postal Code',
            POINT: 'Max.Point',
            ROLE: 'Role',
            PREPAID_AMOUNT: 'Prepaid Amount',
            PREPAID_DATE: 'Prepaid Date',
            PREV_BUDGET: 'Previous Budget',
            PRIORITY: 'Priority',
            PRODUCT_IMAGE_URL: 'Product Image Link',
            PROFILE_PHOTO: 'Profile Photo',
            PROXY: 'Proxy Server',
            PROGRESS: 'Progress (%)',
            QUANTITY: 'Quantity',
            QUARTER: 'Quarter',
            QUESTION_HEIGHT: 'Question Height(px)',
            RATE: 'Rate',
            RANK: 'Rank #',
            RECENT_EVENTS: 'Recent Events',
            REGISTERED: 'Registered',
            REG_DATE: 'Reg.Date',
            REG_DATE_RANGE: 'Registration Date Range',
            REG_END: 'Reg.End',
            REG_INFO: 'Registration Info',
            REG_START: 'Reg.Start',
            REPRESENTATIVE_TYPE: 'Parent',
            REPRESENTATIVES: 'Parents',
            REPRESENTATIVE_INFO: 'Parent Info',
            REPRESENTATIVE_CONTACT: 'Can receive notification',
            EMERGENCY_CONTACT: 'Emergency contact',
            LIVE_WITH_STUDENT: 'Live with student',
            PICKUP_STUDENT: 'Pick up student',
            AM_TRANSPORTATION: 'AM Transportation',
            PM_TRANSPORTATION: 'PM Transportation',
            TRIP_APPROVAL: 'Trip approval',
            COURSE_APPROVAL: 'Course request approval',
            HAS_CUSTODY_OF_STUDENT: 'Has custody of student',
            NO_CONTACT_ALLOWED: 'No contact allowed',
            FIRST_CONTACT: 'First contact',
            INDICATORS: 'Indicators',
            REQUIRED: 'Required',
            RESIDENT_TYPE: 'Resident',
            PLACE_OF_BIRTH: 'Place of Birth',
            RESULT: 'Result',
            ROOM_NUMBER: 'Room Number',
            ROW_INDEX: 'No.',
            ROW_SIZE: 'Row Size',
            ROW_NUMBER: 'Row Number',
            PERFORMANCE: 'Performance',
            REPORT_SETTINGS: 'Report Settings',
            SALARY_CALCULATION_TYPE: 'Calculation Type',
            SALARY_CONSTANT: 'Salary Parameter',
            SALARY_CURRENCY: 'Salary Currency',
            SALARY_MODIFIER: 'Salary Modifiers',
            SALARY_MODIFIER_WITH_PARAM: 'Salary Modifier - {{param}}',
            SALARY_PLAN: 'Salary Plan',
            SALARY_PLAN_WITH_PARAM: 'Salary Plan - {{param}}',
            SALARY_TYPE: 'Salary Type',
            SALARY_WITH_PARAM: 'Salary Parameter - {{param}}',
            SCHOOL: 'School',
            SCHOOL_CLASS: 'School Class',
            SCHOOL_CLASSES: 'School Classes',
            SCHOOL_DEPARTMENT: 'Department',
            SCHOOL_DEPARTMENT_CONSTANT: 'Department Parameters',
            SCHOOL_DEPARTMENT_SECTION: 'Section',
            SCHOOL_LOCATION: 'Location',
            SCHOOL_WITH_PARAM: 'School - {{param}}',
            SCORE: 'Score',
            SECONDARY_PERSON: 'Secondary Person',
            SECOND_REPRESENTATIVE_NAME: '2nd Parent Name',
            SECOND_REPRESENTATIVE_EMAIL: '2nd Parent E-mail',
            SELECTED: 'Selected',
            SEMESTER: 'Semester',
            SEND_ACTIVATION_LINK: 'Send Activation Link',
            RESET_PASSWORD: 'Reset Password',
            SHARE: 'Share',
            SHORTNAME: 'Short Name',
            SHOW: 'Show',
            SHOW_FIRST: 'Show on First Page',
            SHOW_SYLLABUS: 'Show Syllabus',
            SHOW_FINAL: 'Show Final',
            SHOW_AVERAGE: 'Show Average',
            SIMPLE_TEXT: 'Simple Text',
            SPACE_BETWEEN_QUESTIONS: 'Space Between Question(px)',
            SHOW_WEIGHT: 'Show Weight',
            SIZE: 'Size',
            SKIP_EMPTY_PERIODS: 'Skip Empty Periods',
            STANDARDS: 'Standards',
            START_DATE: 'Start Date',
            START_TIME: 'Start Time',
            START_YEAR: 'Start Year',
            STATE: 'State',
            STATUS: 'Status',
            STREET: 'Street',
            STUDENT: 'Student',
            STUDENTS: 'Students',
            STUDENT_COUNT: 'Student Count',
            STUDENT_SCHEDULE: 'Timetable',
            STUDENT_ALERT: 'Student Alert',
            STUDENT_FEE_DETAIL_HEADER: 'Fee/Balance Detail',
            STUDENT_GROUP: 'Student Group',
            STUDENT_ID: 'Student ID',
            STUDENT_ID_SHORT: 'S.ID',
            STUDENT_INFORMATION: 'Student Information',
            STUDENT_OR_PERSONAL_ID: 'Student ID / Personal ID',
            STUDENT_PAYMENT: 'Student Payment',
            STUDENT_PAYMENTS: 'Student Payments',
            STUDENT_WITH_PARAM: 'Student - {{param}}',
            SUBJECT: 'Subject',
            SUBJECT_CATEGORY: 'Subject Category',
            SUMMARY: 'Summary',
            STYLE: 'Style',
            TEACHER: 'Teacher',
            TEACHER_MESSAGE: 'Teacher Message',
            TEST: 'Test',
            TENANT: 'Tenant',
            TIME_SHEET_MULTIPLIER: 'Timesheet Notation Keys',
            TIME_SLOT_MIN: 'Calendar Time Slot Start',
            TIME_SLOT_MAX: 'Calendar Time Slot End',
            TITLE: 'Title',
            TO: 'To',
            TODAY_EVENTS: 'Daily',
            TOPIC: 'Topic',
            TOTAL: 'Total',
            TOTAL_AMOUNT: 'Total Amount',
            TOTAL_DISCOUNT: 'Total Discount',
            TOTAL_DISCOUNT_AMOUNT: 'Total Discount',
            TOTAL_TIME_MINUTES: 'Total Time (Minutes)',
            ONLINE_TIME_MINUTES: 'Online Time (Minutes)',
            OFFLINE_TIME_MINUTE: 'Offline Time (Minutes)',
            TOTAL_FEE_AMOUNT: 'Total Fee',
            TRANSLATION: 'Translation',
            TWOFA: 'Activate Two Factor Authentication(with E-Mail)',
            TYPE: 'Type',
            TIME_FORMAT: 'Time Format',
            UNKNOWN: 'Unknown',
            UPLOAD_PHOTO: 'Upload a Photo',
            UPLOAD_PHOTOS: 'Upload Photos',
            USERS: 'Users (Fullname, Username or E-mail)',
            USE_CAMERA: 'Use Camera',
            VACCINE: 'Vaccine',
            VALUE: 'Value',
            VARIABLE: 'Variable',
            VERSION: 'Version',
            VIDEO: 'Video',
            YOUTUBE: 'YouTube',
            WEEK: 'Week',
            WEEK_EVENTS: 'Weekly',
            WEEKLY_COURSE_PLAN: 'Weekly Course Plan',
            WITHOUT_DISCOUNT: 'Without Discount',
            WORKING_PLACE: 'Working Place',
            WORK_CALENDAR: 'Work Calendar',
            WORK_CALENDAR_WITH_PARAM: 'Work Calendar - {{param}}',
            YEAR: 'Year',
            YES: 'Yes',
            DISCUSSION: 'Discussion',
            RECORD_A_MESSAGE: 'Record a Message',
            FILES: 'Files',
            ACADEMIC_CALENDAR: 'Academic Calendar',
            POINTS: 'Points',
            GRADE_POINT: 'Point',
            GPA_POINT: 'GPA Point',
            GROUPED: 'Grouped',
            TEACHER_NAME: 'Teacher Name',
            USER_BLOCK: 'Block User',
            USER_ACTIVATE: 'Activate User',
            TRUE: 'True',
            FALSE: 'False',
            HAS_CONTENT: 'Has Content',
            OTHERS: 'Others',
            VIDEO_CALL: 'Video Call',
            CAMERA_ENABLED: 'Camera Enabled',
            AUDIO_ENABLED: 'Audio Enabled',
            DOES_NOT_EXISTS: 'Does Not Exists',
            CHARGE_REQUEST_DATETIME: 'Request time',
            GENERATED_TIME: 'Generated Time',
            VOICE: 'Voice',
            PASSING_POINT: 'Passing Point',
            STATE_CODE: 'State Code',
            SELECT_NOTE: 'Select Comment',
            ENTITY_TYPE: 'Entity Type',
            GRADING_TYPE: 'Grading Type',
            GRADE: 'Grade',
            OUT_OF: 'Out of',
        },
        MESSAGE: {
            CONFIRM: {
                APPROVE: 'Do you want to approve: {{item}}?',
                APPROVE_WITHOUT_PARAM: 'Do you want to approve?',
                CLEAR: 'Do you want to clear: {{item}}?',
                COPY_WITHOUT_PARAM: 'Do you want to copy budget data? All previous data will be lost!',
                DELETE: 'Do you want to delete: {{item}}?',
                DELETE_WITHOUT_PARAM: 'Do you want to delete?',
                REMOVE: 'Do you want to remove {{item}}?',
                REMOVE_WITHOUT_PARAM: 'Do you want to remove?',
                SESSION_TIMEOUT: 'Session Timeout!',
                SESSION_TIMEOUT_QUESTION: 'Your session will expire soon. Would you like to extend it?',
                UNAPPROVE: 'Do you want to unapprove: {{item}}?',
                UNAPPROVE_WITHOUT_PARAM: 'Do you want to unapprove?',
                UNDO: 'Do you want to undo dismissal: {{item}}?',
                COPY: 'Do you want to data copy to: {{item}}? All previous data will be lost!',
                REVERT: 'Do you want to revert this request?',
                TERMINATE: 'Do you want to terminate: {{item}}?',
                INCOMING_CALL: '{{from}} is calling you. Do you accept the call?',
            },
            ERROR: {
                RECORD_ERROR: 'Cannot record a message, make sure that you have mic in your device',
                ADD_FEES: 'Please add Fees!',
                CALCULATE_PAYMENT_CALENDAR: 'Please calculate payment calendar!',
                CONTACT_INFO: '{{item}} must have at least one representative info!',
                FILL_CONTACT_INFO: 'Fill all required fields of representative info with name {{item}}',
                CURRENCY_TYPE_NOT_FOUND:
                    'Currency Type not found. You should define in school settings default Currency!',
                DATE_RANGE_CONFLICTS: 'Date range conflicts with',
                DELETE_ALL_QUARTERS: 'First delete all quarters of this semester!',
                DELETE_ALL_SEMESTERS: 'First delete all semesters of this academic period!',
                EMPLOYEE_EXISTS_WITH_EMPLOYEE_POSITION:
                    "You can't delete this position. It is an employee with this position!",
                FORMULA_BLANK: 'Formula is blank. Fill formula',
                FORM_INVALID: 'The data you have entered is invalid! Please check your information and try again',
                FROM_DATE_BEFORE_TO_DATE: '"From Date" must be before "To Date"!',
                GATEWAY_TIMEOUT: 'We`re currently experiencing some technical issues. Please try again later!',
                GIVEN_DATE_BEFORE_EXPIRE_DATE: '"Given Date" must be before "Expire Date"!',
                INVALID_EMPLOYEE_INFO: 'Invalid Employee Info!',
                INVALID_END_DATE: 'Invalid End Date!',
                INVALID_FROM_DATE: 'Invalid From Date!',
                INVALID_INFO: '{{item}} info is not valid!',
                INVALID_PAYER_INFO: 'Payer info is not valid!',
                INVALID_START_DATE: 'Invalid Start Date!',
                INVALID_STUDENT_INFO: 'Student info is not valid',
                INVALID_TO_DATE: 'Invalid To Date!',
                KEY_MUST_NOT_BE_EMPTY: 'Key cannot be empty!',
                MAIL_FORM_INVALID:
                    'Mail Settings you have entered is invalid !Please check your information and try again',
                NOT_BLANK: 'This field cannot be left blank!',
                NOT_DUPLICATE: 'This field cannot be duplicate!',
                NOT_CONTAINS_SPACE: 'This field cannot contains space(s)!',
                MIN_LENGTH: 'This field should contain at least {{size}} characters',
                MAX_LENGTH: 'This field should contain maximum {{size}} characters',
                MIN_MAX_LENGTH: 'This field should contain minimum {{min}} maximum {{max}} characters',
                MIN_VALUE: 'This value should be equal to or above {{value}}',
                MAX_VALUE: 'This value should be equal to or below {{value}}',
                MIN_MAX_VALUE: 'This value should be above {{min}} and below {{max}} ',
                ONLY_ALPHABET: 'This field should contain only alphabetical characters',
                ONLY_NUMERIC: 'This field should contain only numerical characters',
                EMAIL: 'E-mail format is invalid',
                PATTERN: 'The format is invalid! Example : {{pattern}}',
                REQUIRED: 'This field is required!',
                IMPORTED: '{{item}} was not imported',
                MUST_NOT_BE_EMPTY: '{{item}} cannot be empty',
                ENUM_NOT_RECOGNIZED: '{{item}} not recognized',
                PAGE_NOT_FOUND: 'Page "{{item}}" not found',
                PAGE_PERMISSION_ERROR: "Sorry you don't have any permission to access this resource: {{url}}",
                PAYMENT_INFO_FORM_INVALID:
                    'Payment Info you have entered is invalid !Please check your information and try again',
                POSITION_RATE_BIGGER_ZERO: 'Position rate should be bigger than 0',
                POSSIBLE_DATE_RANGE_CONFLICT: 'Possible date range conflict with',
                SALARY_CONSTANT_KEY:
                    'Only "0-9, a-z, A-Z, _" are allowed and the first character should\'t start from "0-9"!',
                SAME_DATE: 'Payment Calendar has same date!',
                SELECT_ACADEMIC_YEAR: 'Please select Academic Period',
                SELECT_COURSE: 'Please select a course',
                NOT_EMPTY_LIST: 'Selection list cannot be empty',
                DATE_IS_IN_THE_FUTURE: 'Your entered date cannot be grater max date',
                NOT_VALID_DATE: 'Date format is invalid',
                SELECT_STUDENT: 'Please select Student',
                SMS_FORM_INVALID:
                    'SMS Settings you have entered is invalid! Please check your information and try again',
                PAYPAL_FORM_INVALID:
                    'PayPal Settings you have entered is invalid! Please check your information and try again',
                GRADE_FORM_INVALID:
                    'Grade Settings you have entered is invalid! Please check your information and try again',
                SOMETHING_WENT_WRONG: 'Something Went Wrong',
                START_DATE_BEFORE_END_DATE: 'Start Year must be before End Year!',
                START_TIME_BEFORE_END_TIME: 'Start Time must be before End Time!',
                START_YEAR_BEFORE_END_YEAR: 'Start Date must be before End Date!',
                TOTAL_RATE: 'Total Rate of Positions should not exceed {{item}}!',
                VALUE_MUST_NOT_BE_EMPTY: 'Value cannot be empty!',
                THERE_IS_NO_INTERNET_CONNECTION: 'There is no internet connection',
                COULD_NOT_GENERATED: 'Could not generated any report.',
                ADD_AT_LEAST_ONE: 'Please add at least one {{item}}',
                CAN_NOT_DELETE_GROUP: 'You cannot delete this group because you did not create it',
                VIDEO_PLAYER_ERROR:
                    'The video file cannot be played when various video error codes occur, please report this issue to your system administrator(s)',
                HAS_NO_PERMISSION:
                    'You do not have sufficient permissions for this operation or data processing by another user.',
                THERE_IS_NO_EMPLOYEE_ACCOUNT: 'There is no employee which assigned to your user account.',
                THERE_IS_NO_STUDENT_ACCOUNT:
                    'There is no student which assigned to your user account. Please select one from your settings',
                THERE_IS_NO_ENROLLED_COURSES: 'There are no courses assigned to you.',
                TEST_CONNECTION_FAILED: 'Test connection failed',
            },
            INFO: {
                ACTIVATION_LINK_SEND: 'Activation e-mail has been send successfully',
                PASSWORD_RESET_SEND: 'Password reset e-mail has been send successfully',
                ACADEMIC_PERIOD_IS_EMPTY:
                    'There is no active academic period for his school. Please enter new or select from list one then set active',
                NO_DATA_TO_SHOW: 'There is no data to display',
                EMAIL_SENDING: 'E-mail is sending',
                SMS_SENDING: 'SMS is sending',
                TABLE_SELECTION_COUNT: 'Selected Records :',
                DATA_IMPORTING: 'Please wait while importing your data.',
                IMPORT_DETAIL: 'Successfully imported: {{successCount}}, Not imported: {{errorCount}}',
                IMPORT_SUCCESS: 'Successfully imported: {{successCount}}',
                WELCOME_COURSES: 'Welcome, {{name}} !',
                USER_HAS_ROLE: 'The user to be selected must have the following role(s):',
                WELCOME_YOU_HAVE:
                    'You have {{messageCount}} message(s), {{assigmentCount}} assignment(s) and {{announcementCount}} announcement(s) !',
                WELCOME_TEACHER_YOU_HAVE:
                    'You have {{messageCount}} message(s) and {{announcementCount}} announcement(s) !',
                VIEWING_AS: 'You are viewing as {{name}}',
                WRITE_VALID_EMAIL: 'To create an account write the valid e-mail address',
                CLICK_TO_COPY: 'Click to copy',
                NO_COURSE_EVENT_TODAY: 'No course event today',
                COURSE_EVENT_TODAY_LOADING: 'Today course events loading ...',
                TYPING: 'typing',
                PLEASE_WAIT_PROCESSING: 'Please wait while your request is processing',
                DEFAULT_VALUE: 'Default value is {{value}}',
            },
            SUCCESS: {
                ADDED: '{{item}} was successfully added',
                ADDED_WITHOUT_PARAM: 'Successfully added!',
                APPROVED: '{{item}} successfully approved',
                APPROVED_PLURAL: '{{item}} successfully approved',
                APPROVED_PLURAL_WITHOUT_PARAM: 'Successfully approved',
                ASSIGNED: '{{item}} successfully assigned',
                CANCELED: '{{item}} was successfully canceled',
                CONTENT_COPIED: 'Content copied',
                COPIED: '{{item}} successfully copied',
                CREATED: '{{item}} successfully created',
                DELETED: '{{item}} successfully deleted',
                DELETED_PLURAL: '{{items}} successfully deleted',
                DELETED_PLURAL_WITHOUT_PARAM: 'Successfully deleted',
                GENERATED: 'Successfully generated',
                PARTLY_GENERATED: 'Successfully generated {{generated}} out of {{total}}',
                EMAIL_SENT: 'E-mail sent successfully',
                IMPORTED: '{{item}} was successfully imported',
                MERGED: '{{item}} successfully merged',
                MESSAGE_SENT: 'Message sent successfully',
                PAUSED: '{{item}} successfully paused',
                REGISTERED: '{{item}} successfully registered',
                REMOVED: 'Successfully removed!',
                SAVED: '{{item}} successfully saved',
                SAVED_PLURAL: '{{item}} successfully saved',
                STARTED: '{{item}} successfully started',
                STATUS_CHANGED: 'Status successfully changed',
                SENT: '{{item}} successfully sent',
                STOPPED: '{{item}} successfully stopped',
                UNAPPROVED: '{{item}} successfully unapproved',
                UNAPPROVED_PLURAL: '{{item}} successfully unapproved',
                UNAPPROVED_PLURAL_WITHOUT_PARAM: 'Successfully unapproved',
                UN_REGISTERED: '{{item}} successfully un-registered',
                UPDATED: '{{item}} successfully updated',
                UPLOADED: '{{item}} successfully uploaded',
                REVERTED: 'Request successfully reverted!',
                HIDDEN: '{{item}} successfully hidden',
                UNHIDDEN: '{{item}} successfully unhidden',
                TERMINATED: '{{item}} successfully terminated',
                APPLIED: '{{item}} successfully applied',
                REQUESTED: 'Your request has been taken successfully.',
                TEST_CONNECTION_SUCCESS: 'Test connection successful',
            },
            WARNING: {
                AT_LEAST_ONE_USER: 'Please select at least one user',
                DISCOUNT_BIGGER_THAN_FEE:
                    'Discount amount is bigger than Fee amount. For these reason total amount is 0!',
                POPUP_BLOKER_ENABLED: 'Pop-up Blocker is enabled! Please add this site to your exception list.',
                GOOGLE_ACCOUNT_NOT_FOUND: 'No user information found to be associated with your Google account.',
                SCHOOL_NOT_ASSIGNED: 'User not assigned to any school. Please contact your system administrator!',
                SESSION_EXPIRED: 'Session expired!',
                SWITCH_TO_WEB: 'For comfortably, switch to web mode',
                SAFARI_VIDEO_PLAY:
                    'We recommend to video playback or online sessions Chrome on your Android and Safari on your IPad or IPhone. If you cannot see the video or getting error please try again with another browser',
            },
        },
        MONTH: {
            APR: 'April',
            AUG: 'August',
            DEC: 'December',
            FEB: 'February',
            JAN: 'January',
            JUL: 'July',
            JUN: 'June',
            MAR: 'March',
            MAY: 'May',
            NOV: 'November',
            OCT: 'October',
            SEP: 'September',
        },
        SHORT_WEEK_DAY_NAMES: {
            FR: 'Fr',
            MO: 'Mo',
            SA: 'Sa',
            SU: 'Su',
            TH: 'Th',
            TU: 'Tu',
            WE: 'We',
        },
        STATUS: {
            ACTIVE: 'Active',
            INACTIVE: 'Inactive',
        },
        TITLE: {
            AVAILABLE_USERS: 'Available Users',
            CONFIRM_DIALOG: 'Confirm',
            DETAILS: 'Details',
            IMPORT: 'Pick Period for Import',
            INFO: 'Info',
            MESSAGE: 'Message',
            NEW: 'Add {{item}}',
            PARTICIPANTS: 'Participants',
            POSTAL_CODE: 'Postal Code',
            RECIPIENTS: 'Recipients',
            SCHOOL_USERS: 'School Users',
            SELECT_ALL: 'Select All',
            SETTINGS: 'Settings',
            SHOW_ALL: 'Show All',
            TEACHERS: 'Teachers',
            WRITE_A_COMMENT: 'Write a Comment...',
            WRITE_A_REPLY: 'Write a Reply...',
            VIEW_REPLIES: 'View Replies ({{item}})',
            HIDE_REPLIES: 'Hide Replies',
            IN_PROGRESS_GRADE: 'In Progress Grade',
            AS_OF: 'As of {{date}}',
            OF_FINAL_GRADE: '{{percent}}% of Final Grade',
            OF_FINAL_GRADE_WITHOUT_PARAM: '% of Final Grade',
            CATEGORY_TOTALS: 'Category Totals',
            D: 'd',
            H: 'h',
            M: 'm',
            S: 's',
            UPLOAD_PICTURE: 'Upload Picture',
            TAKE_PICTURE: 'Take Picture',
            PROFILE_SETTINGS: 'Profile Settings',
            SHARE_WITH: 'Share with',
            PARAMETERS: 'Parameters',
            EDIT_PARAMETER: 'Edit Parameter',
            ADD_PARAMETER: 'Add Parameter',
        },
        WEEKDAYS: {
            FRIDAY: 'Friday',
            MONDAY: 'Monday',
            SATURDAY: 'Saturday',
            SUNDAY: 'Sunday',
            THURSDAY: 'Thursday',
            TUESDAY: 'Tuesday',
            WEDNESDAY: 'Wednesday',
        },
    },
    GRADE_LEVELS: {
        TITLE: {
            ADD: 'Add Grade Level',
            BROWSER: 'Grade Levels',
            NEW: 'New Grade Level',
            EVERYBODY_FULL_ACCESS: 'Everybody can access',
            MAX_APPLICATION_COUNT: 'Max Application Count',
            MAX_APPLICATION_COUNT_HINT:
                'Students cannot apply for more than the maximum application count allowed.("0" - unlimited)',
        },
    },
    GRADING_RUBRIC: {
        TITLE: {
            ADD: 'Add Rubric',
            BROWSER: 'Rubrics',
            DESCRIPTION: 'Description',
            EDIT: 'Rubric',
            NEW: 'New Rubric',
            CRITERIA: 'Criteria',
            RATINGS: 'Ratings',
            ADD_CRITERIA: 'Add Criteria',
            ADD_RATING: 'Add Rating',
            NEW_CRITERIA: 'New Criteria',
            NEW_RATING: 'New Rating',
            RATING: 'Rating',
            FULL_MARKS: 'Full Marks',
            NO_MARKS: 'No Marks',
            DESCRIPTION_OF_CRITERION: 'Description of Criterion',
            USE_RUBRIC: 'Use rubric',
            RUBRIC_HINT: "A rubric is used to describe the criteria by which students' assignments are graded",
        },
        MESSAGE: {
            CRITERIA_EXISTS: 'Criteria with this name already exist.',
            MAX_POINT_OUT_OF_RANGE: 'The value of points cannot exceed the maximum value',
        },
    },
    CLASSES: {
        TITLE: {
            BROWSER: 'Classes',
            ADD: 'Add Class',
            EDIT: 'Class',
            NEW: 'New Class',
            NEW_GROUP: 'New Group',
            IMPORT_CLASSES: 'Import Classes from Excel Sheet',
            TEMPLATE_FILENAME: 'classes-excel-template',
        },
        FIELD: {
            DIVISION: 'Division',
            DIVISIONS: 'Divisions',
            ADD_DIVISION: 'Add a Division',
            REMOVAL_WARNING:
                'If you remove a group, all the corresponding data (courses, lessons, etc.) will be deleted',
            CHIP_LABEL_NOTE: "Write new group's name then press ',' or 'Enter'",
            NEW_GROUP_PLACEHOLDER: 'New Group...',
            GROUPS: 'Groups',
        },
        MESSAGE: {
            ERROR: {
                GROUPS_DUPLICATED: 'There found duplicate group names.',
                GROUP_DUPLICATED_WITH_NAME: 'There is already a group with the name "{{item}}"',
            },
            WARNING: {
                NO_CLASSES_TO_IMPORT: 'There were not found any new classes to import',
            },
        },
    },
    INCIDENT: {
        FIELD: {
            FINANCIAL_IMPACT: 'Financial Impact',
            REPORTED_BY: 'Reported By',
            DETAILED_DESCRIPTION: 'Detailed Description',
            PRIVATE_DESCRIPTION: 'Private Description',
            SEVERITY_TYPE: 'Severity',
            ANYONE_INJURED: 'Was Anyone Injured?',
            PROPERTY_DAMAGED: 'Was Property Damaged?',
            POLICE_CALLED: 'Were Police Called?',
            POLICE_REPORT_NO: 'Police Report No',
            RESPONDING_OFFICER: 'Responding Officer',
            OFFENDERS: 'Offenders',
            VICTIMS: 'Victims',
            REPORTERS: 'Reporters',
            MAX_POINT: 'Maximum Incident Point',
            CRITICAL_POINT: 'Critical Incident Point',
            POINT: 'Point',
            CURRENT_POINT: 'Current Point',
            TOTAL_POINT: 'Total Point',
            INCIDENT_POINT: 'Incident Point',
            ENABLE_INCIDENT_POINT: 'Enable Incident Point',
            MAXIMUM: 'Maximum',
            CRITICAL: 'Critical',
            YOUR_POINT: 'Your Point',
            ACTION_CODE: 'Action Code',
            ACTION_COMMENT: 'Action Comment',
            ACTION_DATE_RANGE: 'Action Date Range',
            ACTION_DETAIL: 'Action Description',
            ACTION_RESOLUTION_DATE: 'Resolution Date',
            ACTION_ASSIGNED_DURATION: 'Assigned Duration',
            ACTION_DURATION_TYPE: 'Duration Type',
            ACTION_ACTUAL_DURATION: 'Actual Duration',
            ACTION_DURATION_NOTE: 'Duration Comment',
            ACTION_CHANGE_NOTE: 'Change Comment',
            ACTION_ATTENDANCE: 'Attendance',
            TIME_FRAME: 'Time Frame',
            TIME_FRAME_CODE: 'Time Frame Code',
            DURATION_REQUIRED: 'Duration Required',
        },
        BUTTON: {
            RESOLVE: 'Resolved',
            UNRESOLVE: 'Unresolved',
        },
        TITLE: {
            ADD: 'Add Incident',
            BROWSER: 'Incident',
            EDIT: 'Incident',
            NEW: 'New Incident',
            REPORTERS: 'Reporters',
            VICTIMS: 'Victims',
            OFFENDERS: 'Offenders',
            WITNESSES: 'Witnesses',
            POLICE: 'Police Officer',
            STATISTIC_ELEMENT: 'Statistic Source',
            NEW_INCIDENTS: 'New Incidents',
            INCIDENT_ALERT: 'Incident Alert',
            CUSTODY_ALERT: 'Custody Alert',
            GUARDIAN_ALERT: 'Guardian Alert',
            BIRTH_DAY_ALERT: 'Birthday',
            ATTENDANCE_ACTION: 'Attendance Action',
            DISCIPLINE: 'Discipline',
            TOTAL_DURATION: 'Total Duration',
            TOTAL_ACTION: 'Total Action',
            TOTAL_BEHAVIOR: 'Total Behavior',
            SHOW_DEPARTMENT_DETAILS: 'Show Details',
        },
        MESSAGE: {
            OFFENDERS_EMPTY: 'Please, add at least one offender',
            REPORTERS_EMPTY: 'Please, add at least one reporter',
            OFFENDERS_BEHAVIOR_EMPTY: 'Please, add at least one offender behavior',
            INCIDENT_MANAGER_CAN_VISIT: 'Only School Admin and Incident Manager can use this page',
            CONFIRMATION_PUBLISH: 'Are you sure to publish the incident?',
            CONFIRMATION_UNPUBLISH: 'Are you sure to unpublish the incident?',
            CONFIRMATION_RESOLVE: 'Are you sure to resolve the incident?',
            CONFIRMATION_UNRESOLVE: 'Are you sure to unresolve the incident?',
            SUCCESSFULLY_RESOLVED: '{{item}} successfully resolved',
            SUCCESSFULLY_UNRESOLVED: '{{item}} successfully unresolved',
            POINT_RANGE_ERROR: 'Incident point must be between {{min}} and {{max}}',
            CRITICAL_POINT_BIGGER_THAN_MAX: 'Incident Critical point must be lower or equal to the max point',
        },
        DISCIPLINE_LETTER: {
            EDIT_TEMPLATE: 'Edit Template',
            TEMPLATES: 'Templates',
            CANCEL_EDITING: 'Cancel Editing',
            SEND_AS_EMAIL: 'Send as Email',
            DISCIPLINE_LETTER: 'Discipline letter',
            EDITING_TEMPLATE: 'Editing Template',
            ENTER_EMAIL_MESSAGE: 'Enter Email Message',
            SEND_TO_PARENT: 'Send To Parent',
            SEND_TO_STUDENT: 'Send To Student',
            EMAIL_SUBJECT: 'Email Subject',
            EMAIL_MESSAGE: 'Email Message',
            SHOW_EDITOR: 'Open Editor',
            EMAIL_SUCCESSFULLY_SENT: 'Email Successfully Sent',
        },
    },
    INCIDENT_LOCATION: {
        TITLE: {
            ADD: 'Add Incident Location',
            BROWSER: 'Incident Locations',
            DESCRIPTION: 'Incident Location',
            EDIT: 'Incident Location',
            NEW: 'New Incident Location',
        },
    },
    INCIDENT_TYPE: {
        TITLE: {
            ADD: 'Add Incident Type',
            BROWSER: 'Incident Types',
            DESCRIPTION: 'Incident Type',
            EDIT: 'Incident Type',
            NEW: 'New Incident Type',
            MIN_POINT: 'Min Point',
            MAX_POINT: 'Max Point',
            ACADEMIC_BASED: 'Reset at each Academic Period',
            NOTIFY_WITH_MESSAGE: 'Notify via Message',
            NOTIFY_WITH_EMAIL: 'Notify via E-Mail',
        },
        MESSAGE: {
            MAX_POINT_MUST_BE_BIGGER: 'Max Point must be equal or bigger than Min Point',
        },
    },
    INCIDENT_BEHAVIOR: {
        TITLE: {
            ADD: 'Add Behavior',
            BROWSER: 'Behaviors',
            EDIT: 'Behavior',
            NEW: 'New Behavior',
            STATE_REPORTABLE: 'State Reportable',
            POLICE_REPORTABLE: 'Police Reportable',
            ALLOW_COMMENT: 'Allow Comment',
            REPORT_CODE: 'Report Code',
            POLICY_DESCRIPTION: 'Policy Description',
            ACADEMIC_BASED: 'Reset at each Academic Period',
            SEVERETY: 'Severity',
            PRIMARY_BEHAVIOR: 'Primary Behavior',
            ALLEGATION: 'Allegation',
        },
        MESSAGE: {
            NO_BEHAVIORS: 'There is no behaviors',
        },
    },
    INCIDENT_ACTION: {
        TITLE: {
            ADD: 'Add Action',
            BROWSER: 'Actions',
            EDIT: 'Action',
            NEW: 'New Action',
            STATE_REPORTABLE: 'State Reportable',
            POLICE_REPORTABLE: 'Police Reportable',
            ALLOW_COMMENT: 'Allow Comment',
            REPORT_CODE: 'Report Code',
            POLICY_DESCRIPTION: 'Policy Description',
            ACADEMIC_BASED: 'Reset at each Academic Period',
            SEVERETY: 'Severity',
            ATTENDANCE_ALLOWED: 'Allow Attendance from Action',
            ATTENDANCE_CODE: 'Attendance Code',
            DATE_RANGE: 'Action Date Range',
            ACTION_TAKEN_DETAIL: 'Action Detail',
            RESOLUTION_DATE: 'Resolution Date',
            ASSIGNED_DURATION: 'Assigned Duration',
            ACTUAL_DURATION: 'Actual Duration',
            DURATION_NOTES: 'Duration Notes',
            ACTION_CHANGE_REASON: 'Action Change Reason',
            ACTION_CHANGE_CODE: 'Action Change Code',
            INCIDENT_LETTER: 'Incident Letter',
        },
        MESSAGE: {
            NO_ACTIONS: 'There is no actions',
            ATTENDANCE_ENABLED: 'Attendance entry enabled for this action',
        },
    },
    INCIDENT_OBJECT: {
        TITLE: {
            ADD: 'Add Object',
            BROWSER: 'Objects',
            EDIT: 'Object',
            NEW: 'New Object',
            QUANTITY: 'Quantity',
        },
        MESSAGE: {
            NO_OBJECTS: 'There is no objects',
        },
    },
    INCIDENT_ENTITY: {
        TITLE: {
            EDIT: 'Incident Entity',
            NEW: 'New Incident Entity',
        },
    },
    INCOME_PLAN: {
        MESSAGE: {
            ERROR: {
                AT_LEAST_ONE_DETAIL: 'At least one detail should be added!',
                BIGGER: 'Fee Student Count should be bigger than Discount Student Count!',
                INVALID_INCOME_PLAN_INFO: 'Invalid Income Plan Info!',
                SAVE_FIRST: 'To Delete Income Plan you need to Save it first!',
            },
        },
        TITLE: {
            ADD: 'Add Income Plan',
            BROWSER: 'Income Plans',
            BUDGET: 'Budget',
            BUDGET_GROUP: 'Budget Group',
            FEE_PLAN: 'Fee Plan',
            INCOME_PLAN_DETAIL: 'Income Plan Details',
            INCOME_PLAN_INFO: 'Income Plan Info',
            NEW: 'New Income Plan',
            NEW_FEE_PLAN: 'Add Fee Plan',
            NEW_PERIOD_DISCOUNT: 'Add Period Discount',
            TOTAL_AMOUNT_AFTER_DISCOUNT: 'NET Amount',
        },
    },
    IRREGULAR_WORK_PLAN: {
        FIELD: {
            HOURS: 'Hours',
            MULTIPLIER_TYPE: 'Type',
        },
        MESSAGE: {
            CONFIRM: {
                DELETE: 'Do you want to delete timesheet?',
            },
            SUCCESS: {
                CALCULATED: 'Timesheet successfully calculated',
                CREATED: 'Timesheet successfully saved',
                DELETED: 'Timesheet successfully deleted',
            },
        },
        NAV_TITLE: 'Irregular Work Scheduling',
        TITLE: {
            ATTENDANCE: 'Attendance',
        },
    },
    ITEM: {
        FIELD: {
            ITEM: 'Item',
            NEW: 'New Item',
            PRICE: 'Price',
            SERIAL_NUMBER: 'Serial Number',
        },
        TITLE: {
            ADD: 'Add Item',
            BROWSER: 'Items',
        },
    },
    ITEM_CATEGORY: {
        FIELD: {
            ITEM_CATEGORY: 'Item Category',
            NEW_ITEM_CATEGORY: 'New Item Category',
            ROLES: 'User Type',
        },
        TITLE: {
            ADD: 'Add Category',
            BROWSER: 'Item Categories',
        },
    },
    ITEM_TRANSACTION: {
        BUTTON: {
            GIVE: 'Give',
            GIVEN: 'Given',
            HISTORY: 'History',
            LOST: 'Lost',
            NOT_PAID: 'Not Paid',
            PAID: 'Paid',
            RETURNED: 'Returned',
        },
        FIELD: {
            CHANGED_BY: 'Changed By',
            COST: 'Cost',
            DATE: 'Date',
            FROM_STATUS: 'From',
            GIVEN_DATE: 'Given Date',
            GIVEN_QUANTITY: 'Given Quantity',
            ID: 'ID',
            ITEM_NAME: 'Name',
            NOTE: 'Note',
            PAYMENT_STATUS: 'Payment Status',
            PERSON_TYPE: 'Person Type',
            PROPERTIES: 'Custom Fields',
            RECIPIENT: 'Recipient',
            RETURN_DATE: 'Return Date',
            RETURN_QUANTITY: 'Return Quantity',
            SERIAL_NUMBER: 'Serial Number',
            STATUS: 'Status',
            TO_STATUS: 'To',
            TRANSACTION_DETAILS: 'Transaction Details',
        },
        MESSAGE: {
            BULK_DELETE: '{{amount}} Item Transactions',
            ITEM: 'Item Transaction',
            ITEM_RETURNED: 'Item successfully returned',
            EMPTY: '{{param}} empty in',
            PAYMENT_STATUS_CHANGED: 'Payment Status successfully changed',
            TRANSACTION_DETAILS_EMPTY: 'Transaction details empty',
        },
        TITLE: {
            ADD: 'Add Item Transaction',
            BROWSER: 'Item Management',
            FORM: 'Item Management',
            ITEM_HISTORY: 'Item History - {{param}}',
            ITEM_TRANSACTION: 'Item Transaction',
            NEW: 'New Item Transaction',
            PERSON_INFO: 'Person Info',
        },
    },
    ITEM_TYPE: {
        FIELD: {
            CUSTOM_FIELD_NAME: 'Custom Field Name',
            DEFAULT_PRICE: 'Default Price',
            ITEM_TYPE: 'Item Type',
            ITEM_TYPE_WITH_PARAM: 'Item Type  - {{param}}',
            ORDER_NO: 'Order No',
            PAYABLE: 'Payable',
            RETURNABLE: 'Returnable',
            SERIAL_NUMBER_EXISTS: 'Serial Number Exists',
            VALUE_TYPE: 'Value Type',
        },
        MESSAGE: {
            ERROR: {
                CUSTOM_FIELD_DUPLICATED: 'Custom Field "{{item}}" already exists',
                LIST_KEY_DUPLICATED: 'List of Value with key "{{item}}" already exists',
                ORDER_NO_EXISTS: 'Custom Field with order number "{{item}}" already exists',
            },
        },
        TITLE: {
            ADD: 'Add Item Type',
            ADD_CUSTOM_FIELD: 'Add Custom Field',
            BROWSER: 'Item Types',
            CUSTOM_FIELD: 'Custom Field',
            NEW_CONSTANT: 'New Parameter',
            NEW_CUSTOM_FIELD: 'New Custom Field',
            NEW_ITEM_TYPE: 'New Item Type',
        },
    },
    INVOLVEMENT_ITEM: {
        TITLE: {
            ADD: 'Add Involved Item',
            BROWSER: 'Involved Items',
            EDIT: ' Involved Item',
            NEW: 'New Involved Item',
        },
    },
    JOB_MANAGEMENT: {
        FIELD: {
            JOB: 'Scheduler',
            LAST_RUN_TIME: 'Last Run Time',
            NEXT_RUN_TIME: 'Next Run Time',
        },
        TITLE: {
            BROWSER: 'Schedulers Management',
        },
    },
    BBB_SERVER: {
        TITLE: {
            DIALOG: 'BBB Server',
        },
    },
    LOGIN: {
        FORGET_PASSWORD: 'Forgot Password?',
        LOGIN: 'LOGIN',
        LOGIN_WITH_FACEBOOK: 'Log in with Facebook',
        LOGIN_WITH_GOOGLE: 'Log in with Google',
        LOGIN_WITH_MICROSOFT: 'Log in with Microsoft',
        MESSAGE: {
            ERROR: {
                EMAIL_NOT_VALID: 'Please enter a valid e-mail address',
                EMAIL_REQUIRED: 'E-mail is required',
                INVALID_PASSWORD: 'Username or password is not valid!',
                PASSWORD_REQUIRED: 'Password is required',
            },
            LOGIN: 'Login to Campus',
        },
        PASSWORD: 'Password',
        REMEMBER_ME: 'Remember Me',
        SEND_VERIFICATION_CODE: 'Resend Code',
        OR_CONTINUE_WITH: 'Or continue with',
        USERNAME: 'Username',
        VERIFICATION_CODE: 'Verification Code',
        VERIFY_CODE: 'Verify',
        OR: 'or',
        CODE_SENDED: 'Please check your e-mail to verify your account',
        CODE_RE_SENDED: 'Verification code resent. Please check your e-mail to verify your account',
        TOO_MANY:
            'Too many verifications failed. The user locked by system administration. Please try again 10 min later',
        CODE_INVALID: 'Verification code you have entered is invalid! Please check your information and try again',
    },
    NATIONALITIES: {
        TITLE: {
            ADD: 'Add Nationality',
            BROWSER: 'Nationalities',
            NEW: 'New Nationality',
        },
    },
    NAV: {
        ALLOW_GRADING_AFTER_DUE_DATE: {
            TITLE: 'Grading Permission',
        },
        COUNSELOR_ASSIGN: {
            TITLE: 'Counselor Assign',
        },
        GRADING_ADJUSTMENT: {
            TITLE: 'Grading Adjustment',
        },
        STUDENT_RANKING: {
            TITLE: 'Student Ranking',
        },
        ASSESSMENT_SETUP: {
            TITLE: 'Assessment Setup',
        },
        ASSESSMENT_SCORES: {
            TITLE: 'Assessment Scores',
        },
        ANALYTICS: {
            TITLE: 'Analytics',
        },
        ATTENDANCE_CHARTS: {
            TITLE: 'Attendance Charts',
        },
        ATTENDANCE_PERCENTAGES: {
            TITLE: 'Attendance Percentages',
        },
        DATASESE_FILES: {
            TITLE: 'Database Files',
        },
        QUESTION_BANK: {
            TITLE: 'Question Bank',
            QUESTIONS: 'Questions',
        },
        ACADEMIC_CALENDAR: {
            TITLE: 'Academic Calendar',
        },
        ANNOUNCEMENTS: {
            TITLE: 'Announcements',
        },
        APPROVE_PRE_REGISTRATION: {
            BADGE: '5',
            TITLE: 'Registration Approvement',
        },
        ATTESTATION: {
            TITLE: 'Attestations',
        },
        ATTENDANCE_BY_STUDENT: {
            TITLE: 'Attendance By Class(Manager)',
        },

        ATTENDANCE_BY_DATE: {
            TITLE: 'Attendance By Date',
        },
        ATTENDANCE_BY_COURSE: {
            TITLE: 'Attendance By Course(Teacher)',
        },
        ATTENDANCE_EXCUSE_TEACHER: {
            TITLE: 'Attendance Excuses (Teacher)',
        },
        ATTENDANCE_EXCUSE_PARENT: {
            TITLE: 'Attendance Excuses (Parents)',
        },
        DAILY_ATTENDANCE: {
            TITLE: 'Daily Attendance',
        },
        ASSIGNMENT_TEACHER: {
            TITLE: 'Teacher Assignment',
        },
        BANK_ACCOUNTS: {
            TITLE: 'Bank Accounts',
        },
        BBB_SERVERS: {
            TITLE: 'BBB Servers',
        },
        BUDGET: {
            TITLE: 'Budget',
        },
        BUDGETS: {
            TITLE: 'Budgets',
        },
        BUDGET_ACCOUNTS: {
            TITLE: 'Budget Accounts',
        },
        BUDGET_BALANCE: {
            TITLE: 'Budget Balance',
        },
        BUDGET_BALANCE_ACTUAL: {
            TITLE: 'Plan  Actual Report',
        },
        BUDGET_BALANCE_CHART: {
            TITLE: 'Budget Balance Chart',
        },
        BUDGET_CLOSE_ACCOUNTS: {
            TITLE: 'Closing Accounts',
        },
        BUDGET_EXCEL_REPORT: {
            TITLE: 'Budget Reports',
        },
        BUDGET_EXCEL_TEMPLATE: {
            TITLE: 'Excel Template',
        },
        BUDGET_EXPENSE_REQUEST_CHAIN: {
            TITLE: 'Expense Request',
        },
        BUDGET_EXPENSE_TRANSFER: {
            TITLE: 'Expense Transfer',
        },
        BUDGET_INBOX_REQUESTS: {
            TITLE: 'Inbox',
        },
        BUDGET_GROUPS: {
            TITLE: 'Budget Groups',
        },
        BUDGET_MY_REQUESTS: {
            TITLE: 'My Requests',
        },
        BUDGET_OUTBOX_REQUESTS: {
            TITLE: 'Outbox',
        },
        BUDGET_PROJECTS: {
            TITLE: 'Budget Projects',
        },
        BUDGET_REQUESTS: {
            TITLE: 'Budget Requests',
        },
        CALENDAR_EVENT: {
            TITLE: 'Calendar',
        },
        CITIES: {
            TITLE: 'Cities',
        },
        CITIZENSHIPS: {
            TITLE: 'Citizenships',
        },
        COMPLETE_PRE_REGISTRATION: {
            BADGE: '5',
            TITLE: 'Registration Complete',
        },
        COST_CENTER: {
            TITLE: 'Cost Centers',
        },
        COUNTRIES: {
            TITLE: 'Countries',
        },
        COURSES_ADMIN: {
            TITLE: 'Courses Report',
        },
        COURSE_CONTENT: {
            TITLE: 'Course Content',
        },
        CUSTOM_FIELD_GROUP: {
            TITLE: 'Custom Field Group',
        },
        COURSES: {
            TITLE: 'Courses',
        },
        COURSE_ATTENDANCE: {
            TITLE: 'Course Attendance Report',
        },
        STUDENT_ATTENDANCE_REPORT: {
            TITLE: 'Student Attendance Report',
        },
        MOBILE_STUDENT_ATTENDANCE_REPORT: {
            TITLE: 'Mobile Student Attendance Report',
        },
        CLASS_ATTENDANCE: {
            TITLE: 'Class Attendance Report',
        },
        DAILY_ATTENDANCE_REPORT: {
            TITLE: 'Daily Attendance Report',
        },
        COURSE_TEACHER_ATTENDANCE: {
            TITLE: 'Teacher Attendance Report',
        },
        CLASS_GRADE_REPORT: {
            TITLE: 'Class Grades',
        },
        GRADE_LEVEL_BASED_GRADE_REPORT: {
            TITLE: 'Grade Level Scores',
        },
        CONTRACT_TEMPLATES: {
            TITLE: 'Templates',
        },
        COURSE_ASSIGNMENTS: {
            TITLE: 'Course Assignments',
        },
        COURSE_ENROLLMENT: {
            TITLE: 'Course Enrollment',
        },
        GRADEBOOK: {
            TITLE: 'Gradebook',
        },
        COURSE_MODERATOR_ATTENDANCE: {
            TITLE: 'Moderator Attendance',
        },
        COURSE_MODERATORS: {
            TITLE: 'Substitute Teacher',
        },
        COURSE_SCHEDULE: {
            TITLE: 'Course Timetable',
        },
        STUDENT_SCHEDULE: {
            TITLE: 'Student Timetable',
        },
        ATTENDANCE: {
            TITLE: 'Attendance',
        },
        GRADING: {
            TITLE: 'Grading',
        },
        GROUPS: {
            TITLE: 'Student Groups',
        },
        GRADING_RUBRIC: {
            TITLE: 'Rubric',
        },
        FINANCE: {
            TITLE: 'Finance',
        },
        COURSE_TERM_GRADE: {
            TITLE: 'Course Term Grades',
        },
        DAILY_TIMESHEET_ACTUAL: {
            TITLE: 'Daily Timesheet',
        },
        DAILY_TIMESHEET_PLAN: {
            TITLE: 'Daily Timesheet Plan',
        },
        ONLINE_PAYMENT: {
            TITLE: 'Online Payment',
        },
        DASHBOARD: 'Dashboard',
        DISCOUNTS: {
            BADGE: '5',
            TITLE: 'Discounts',
        },
        DISMISSAL_ARTICLE: {
            TITLE: 'Reasons for Leaving',
        },
        EMPLOYEE: {
            BADGE: '5',
            INFO_TITLE: 'Employees',
            SALARY: 'Salary',
            SALARY_TITLE: 'Salary Parameters',
            SALARY_TITLE_ADMIN: 'Salary Parameters (Admin)',
            TITLE: 'Employees',
            IMPORT_CREATE_ACCOUNT: 'Data Import & Accounts',
        },
        EMPLOYEE_POSITION: {
            TITLE: 'Positions',
        },
        EDUCATION: {
            TITLE: 'Education',
        },
        EDUCATION_SETUP: {
            TITLE: 'Setup',
        },
        EDUCATION_REPORTS: {
            TITLE: 'Education Reports',
        },
        EDUCATION_REPORT_TEACHER: {
            TITLE: 'Teacher',
        },
        EDUCATION_REPORTS_CLASS_TEACHER: {
            TITLE: 'Class Teacher',
        },
        EDUCATION_REPORTS_SOCIAL_TEACHER: {
            TITLE: 'Social Teacher',
        },
        EDUCATION_REPORTS_ADMIN: {
            TITLE: 'Admin',
        },
        EDUCATION_ATTENDANCE: {
            TITLE: 'Attendance',
        },
        EDUCATION_VIDEO_CONFERENCE: {
            TITLE: 'Video Conference',
        },
        EDUCATION_STANDARD: {
            TITLE: 'Education Standard',
        },
        EDUCATION_STANDARD_PACKAGE: {
            TITLE: 'Standard Package',
        },
        MEETINGS: {
            TITLE: 'Video Meetings',
        },
        MEETING_RECORDINGS_ADMIN: {
            TITLE: 'Recordings (Admin)',
        },
        EXAMS: {
            BADGE: '7',
            TITLE: 'Registration',
        },
        EXAM_SETUP: {
            TITLE: 'Setup',
        },
        FIELDS: {
            TITLE: 'Custom Fields',
        },
        FIELD_SETTINGS: {
            TITLE: 'Custom Forms',
        },
        FEE_TYPES: {
            BADGE: '5',
            TITLE: 'Fees',
        },
        STUDENT_FINANCE: {
            TITLE: 'My Finance',
        },
        GRADE_LEVELS: {
            BADGE: '5',
            TITLE: 'Grade Levels',
        },
        GRADE_CATEGORIES_TEMPLATE: {
            TITLE: 'Grade Templates',
        },
        GRADING_SCHEME: {
            TITLE: 'Grading Scheme',
        },
        GRADE_EXCUSE_TYPES: {
            TITLE: 'Grade Excuse Types',
        },
        HR: {
            BADGE: '5',
            TITLE: 'Human Resources',
        },
        HR_SETUP: {
            TITLE: 'Setup',
        },
        IMPORT_GRADES: {
            TITLE: 'Import Grades',
        },
        INBOX: {
            TITLE: 'Inbox',
        },
        INCIDENTS: {
            TITLE: 'Incidents',
        },
        INCIDENT_LOCATION: {
            TITLE: 'Incident Location',
        },
        INCIDENT_TYPE: {
            TITLE: 'Incident Type',
        },
        INCIDENT_ACTION: {
            TITLE: 'Actions',
        },
        INCIDENT_BEHAVIOR: {
            TITLE: 'Behaviors',
        },
        INCIDENT_PARAMETERS: {
            TITLE: 'Parameters',
        },
        INCIDENT_SETUP: {
            TITLE: 'Setup',
        },
        INCOME_PLAN: {
            TITLE: 'Income Plans',
        },
        IRREGULAR_WORK_SCHEDULING: {
            TITLE: 'Irregular Work Scheduling',
        },
        ITEM: {
            TITLE: 'Inventory',
        },
        ITEM_CATEGORY: {
            TITLE: 'Item Categories',
        },
        ITEM_MANAGEMENT: {
            TITLE: 'Item Management',
        },
        ITEM_SETUP: {
            TITLE: 'Setup',
        },
        ITEM_TRANSACTION: {
            TITLE: 'Item Transaction',
        },
        ITEM_TYPE: {
            TITLE: 'Item Types',
        },
        INVOLVEMENT_ITEM: {
            TITLE: 'Involved Items',
        },
        JOBS_MANAGEMENT: {
            TITLE: 'Schedulers Management',
        },
        NATIONALITY: {
            TITLE: 'Nationalities',
        },
        NOTIFICATIONS: {
            TITLE: 'Notifications',
        },
        USER_MESSAGES: {
            TITLE: 'Messages',
            NEW: 'Send Message',
        },
        MESSAGING: {
            TITLE: 'Messaging',
        },
        MY_COURSES: {
            TITLE: 'My Courses',
        },
        MORE: {
            TITLE: 'More ...',
        },
        MY_ASSIGNMENTS: {
            TITLE: 'My Assignments',
        },
        ONLINE_ATTENDANCE: {
            TITLE: 'Online Attendance',
        },
        ORDERS: {
            TITLE: 'Order',
        },
        CUSTOM_PARAMETERS: {
            TITLE: 'Custom Parameters',
        },
        ATTENDANCE_CODE: {
            TITLE: 'Attendance Codes',
        },
        CLEVER_SETTING: {
            TITLE: 'Clever Settings',
        },
        CLASSLINK_SETTING: {
            TITLE: 'ClassLink Settings',
        },
        DATA_PERMISSION: {
            TITLE: 'Data Permission',
        },
        OUTBOX: {
            TITLE: 'Outbox',
        },
        PARAMETERS: {
            TITLE: 'Parameters',
        },
        PASS_PRE_REGISTRATION: {
            BADGE: '5',
            TITLE: 'Registration Result',
        },
        PAYMENT_BALANCE_CHART: {
            TITLE: 'Payment Balance Chart',
        },
        POSITIONS: {
            TITLE: 'Positions',
        },
        POSITION_CATEGORY: {
            TITLE: 'Position Categories',
        },
        POSITION_SALARY: {
            TITLE: 'Position Salary',
        },
        PRE_REGISTRATION_INFO: {
            TITLE: 'Registration - 1',
        },
        MY_PAGE: {
            TITLE: 'My Page',
        },
        REPORTS: {
            TITLE: 'Reports',
        },
        REPORT_CARD: {
            TITLE: 'Report Card',
            HEADER: 'Report Title',
            CREATE_REPORT: 'Create Report',
            SEND_EMAIL: 'Sent via E-Mail',
            CLICK_DETAIL: 'Click to see the log history',
            SIGNATURE_FILE_SELECT: 'Add Signature',
            SHOW_GRADING_DISABLED_COURSES: 'Courses Without Grades',
            SHOW_ASSESSMENT_SCORES: 'Testing Information',
            MESSAGE: {
                NOT_GENERATED: 'Report card is not generated yet',
                REPORT_TITLE_HINT: 'If you do not enter, the default title will be used.',
            },
            AUTHORITY_BLOCK: 'Authority Title',
            SIGNATURE_BLOCK: 'Enable Signature Section',
            AUTHORITY_TITLE: 'Title',
        },
        REPORT_CARD_GENERATION: {
            TITLE: 'Report Card Generation',
        },
        REPORT_CARD_GENERATION_ACADEMIC_YEAR: {
            TITLE: 'Academic Year Report Card Generation',
        },
        REPORT_CARD_GENERATION_TERM: {
            TITLE: 'Term Report Card Generation',
        },
        REPORT_CARD_DISPLAY_ACADEMIC_YEAR: {
            TITLE: 'Academic Year Report Cards',
        },
        REPORT_CARD_DISPLAY_TERMS: {
            TITLE: 'Terms Report Cards',
        },
        REPORT_CARDS: {
            TITLE: 'Report Cards',
        },
        SALARY_CONSTANTS: {
            TITLE: 'Salary Parameters',
        },
        SALARY: {
            TITLE: 'Salary',
        },
        SALARY_MODIFIER: {
            TITLE: 'Salary Modifiers',
        },
        SALARY_PARAMETER: {
            TITLE: 'Salary Parameter',
        },
        SALARY_PLAN: {
            TITLE: 'Salary Plans',
        },
        SALARY_TYPE: {
            TITLE: 'Salary Types',
        },
        SCHOOLS: {
            BADGE: '7',
            TITLE: 'Schools (Admin)',
        },
        SCHOOLS_BALANCE_REPORT: {
            TITLE: 'Schools Balance Report',
        },
        SCHOOL_ACTIVE: {
            TITLE: 'School (Active)',
        },
        SCHOOL_BALANCE_CHART: {
            TITLE: 'School Balance Chart',
        },
        SCHOOL_CLASSES: {
            BADGE: '5',
            TITLE: 'Classes',
        },
        SCHOOL_DEPARTMENT: {
            TITLE: 'Departments',
        },
        SCHOOL_DOCUMENTS: {
            BADGE: '5',
            TITLE: 'Document Types',
        },
        SCHOOL_LOCATION: {
            TITLE: 'Locations',
        },
        SCHOOL_LOGS: {
            TITLE: 'School Logs',
        },
        SCHOOL_LOG_TOTAL_POINTS: {
            TITLE: 'Total Points',
        },
        SCHOOL_LOG_TYPE: {
            TITLE: 'School Log Types',
        },
        SCHOOL_LOG_POINT: {
            TITLE: 'Points',
        },
        STUDENT_TRANSCRIPT: {
            TITLE: 'Student Transcripts',
            BY_SUBJECT: {
                TITLE: 'Transcript By Subject',
            },
            GPA_CALCULATION_TYPES: 'GPA Calculation Type',
            TRANSCRIPT_TYPES: 'Transcript Type',
            GPA_CALCULATION_TYPE: {
                RECALCULATE_GPA: 'Recalculate',
                USE_PRECALCULATED_GPA: 'Use Precalculated',
            },
        },
        SCHOOL_SETUP: {
            BADGE: '7',
            TITLE: 'School Setup',
        },
        SCORM_EXPORTER: {
            TITLE: 'Scorm Exporter',
        },
        SELF_ENROLLMENT: {
            TITLE: 'Self Enrollment',
        },
        SETUP: {
            TITLE: 'Setup',
        },
        STATES: {
            TITLE: 'States',
        },
        STATISTICAL_BOARD: {
            TITLE: 'Statistical Board',
        },
        INCIDENTS_STATISTICS: {
            TITLE: 'Statistics',
        },
        INCIDENT_PROFILE_REPORT: {
            TITLE: 'Profile Report',
        },
        STUDENTS: {
            BADGE: '5',
            TITLE: 'Students',
            ADMIN: 'Students (Admin)',
        },
        STUDENT_PROGRAM: {
            TITLE: 'Student Program',
        },
        STUDENT_PROGRAM_SETTINGS: {
            TITLE: 'Settings',
        },
        STUDENT_PROGRAM_SERVICE: {
            TITLE: 'Program Service',
        },
        STUDENT_PROGRAM_REPORT_AND_IMPORT: {
            TITLE: 'Report & Import',
        },
        STUDENT_ALERT: {
            TITLE: 'Alerts',
        },
        STUDENT_ATTENDANCE: {
            TITLE: 'Student Attendance',
        },
        STUDENT_POINTS: {
            TITLE: 'Student Points',
        },
        STUDENT_EXAMS: {
            TITLE: 'Registrations',
        },
        STUDENT_FEES: {
            BADGE: '5',
            TITLE: 'Fees',
        },
        STUDENT_GRADES: {
            TITLE: 'Student Grades',
        },
        STUDENT_INFO: {
            BADGE: '5',
            TITLE: 'Student',
        },
        STUDENT_REPRESENTATIVE_LIST: {
            TITLE: 'Parents',
        },
        STUDENT_PAYMENTS: {
            BADGE: '5',
            TITLE: 'Payments',
        },
        STUDENT_PAYMENT_REPORTS: {
            TITLE: 'Payment Report',
        },
        STUDENT_PAYMENT_TURN_OVER_REPORT: {
            TITLE: 'Payment Turn Over Report',
        },
        STUDENT_TRANSFER: {
            TITLE: 'Class Enrollment',
        },
        SUBJECTS: {
            BADGE: '5',
            TITLE: 'Subjects',
        },
        SUBJECT_CATEGORIES: {
            BADGE: '5',
            TITLE: 'Subject Categories',
        },
        SURVEYS: {
            TITLE: 'Surveys',
            MY_SURVEYS: 'My Surveys',
        },
        SYLLABUS: {
            TITLE: 'Syllabus',
        },
        TEACHER_PAGE: {
            TITLE: 'Teacher Page',
        },
        TIME_PERIODS: {
            TITLE: 'Time Periods',
        },
        TIME_TABLE: {
            TITLE: 'Timetables',
        },
        TIMETABLE_REPORTS: {
            TITLE: 'Timetable Report',
        },
        TIME_SHEET_MONTHLY: {
            TITLE: 'Monthly Hourly Timesheet',
        },
        TIME_SHEET_MULTIPLIER: {
            TITLE: 'Notation Keys',
        },
        TRANSCRIPT: {
            TITLE: 'Transcript',
        },
        TRASH: {
            TITLE: 'Trash',
        },
        TIMETABLE_STUDENT_CONFLICTS: {
            TITLE: 'Student Conflicts',
        },
        TIMETABLE_TEACHER_CONFLICTS: {
            TITLE: 'Teacher Conflicts',
        },
        USERS: {
            BADGE: '5',
            TITLE: 'Users',
        },
        WORK_CALENDAR: {
            TITLE: 'Work Calendar',
        },
        CLASS_STUDENTS: {
            TITLE: 'Accounts & ID Card',
        },
        SMS_REPORTS: {
            TITLE: 'SMS Report',
        },
        IMPORTED_STUDENTS: {
            TITLE: 'Imported Students',
        },
        IMPORTED_EMPLOYEES: {
            TITLE: 'Imported Employees',
        },
        IMPORTED_USERS: {
            TITLE: 'Imported Users',
        },
        IMPORTED_BUDGET_ACCOUNTS: {
            TITLE: 'Imported Accounts',
        },
        TIMETABLE_PROJECTS: {
            TITLE: 'Projects',
        },
        TIMETABLE_TEACHERS: {
            TITLE: 'Teachers',
        },
        TIMETABLE_ROOMS: {
            TITLE: 'Locations',
        },
        TIMETABLE_CLASSES: {
            TITLE: 'Classes',
        },
        TIMETABLE_COURSES: {
            TITLE: 'Courses',
        },
        TIMETABLE_CONSTRAINTS: {
            TITLE: 'Constraints',
        },
        TIMETABLE_TRIALS: {
            TITLE: 'Trials',
        },
        TIMETABLE_PANEL: {
            TITLE: 'Panel',
        },
        WORKING_TIME_SHEET: {
            TITLE: 'Working Timesheet',
        },
        GRADE_CHARTS: {
            TITLE: 'Grade Charts',
        },
        CERTIFICATE: {
            TITLE: 'Certificate',
        },
        CERTIFICATE_TYPE: {
            TITLE: 'Certificate Type',
        },
        CERTIFY: {
            TITLE: 'Certify',
        },
        STUDENT_CERTIFICATES: {
            TITLE: 'Student Certificates',
        },
        MY_STUDENT_CERTIFICATES: {
            TITLE: 'My Certificates',
        },
        GROUPS_ALL: {
            TITLE: 'Groups',
        },
        ADVANCED_SEARCH: {
            TITLE: 'Advanced Search',
        },
        HEALTH_MANAGEMENT: {
            TITLE: 'Health Management',
        },
        MEDICAL_PROFILE: {
            TITLE: 'Student Health',
        },
        MASTER_SCHEDULE: {
            TITLE: 'Master Timetable',
        },
        STATE_REPORTS: {
            TITLE: 'State Reports',
            FIELDS: 'Report Fields',
        },
        TIMETABLER: {
            TITLE: 'Timetabler',
        },
        BULK_IMPORT_GRADES: {
            TITLE: 'Bulk Import Grades',
        },
        GPA_CALCULATION: {
            TITLE: 'GPA Calculation',
        },
        FRONTLINE_SETTING: {
            TITLE: 'Frontline Setting',
        },
        SOLANA_SETTING: {
            TITLE: 'Solana Settings',
        },
    },
    NOTIFICATION: {
        FIELD: {
            DAYS_BEFORE: 'Days Before',
            EMAIL: 'E-mail',
            NOTIFICATION: 'Notification',
            NOTIFY_VIA_EMAIL: 'Notify via E-mail',
            NOTIFY_VIA_SMS: 'Notify via SMS',
            NOTIFY_VIA_CALL: 'Notify via Voice Call',
            SMS: 'SMS',
            SMS_SIZE: 'SMS Count',
            SUBJECT: 'Subject',
            FROM: 'From',
            TO: 'To',
            TEXT: 'Text',
            CALL: 'Voice Call',
        },
        MESSAGE: {
            FILL_EMAIL_CONTENT: 'Fill E-mail Text!',
            NOTIFY: 'Notify',
            SEND_IN_PROGRESS: 'Notification is sending',
            NOTIFY_TEACHERS_ABOUT_SUBMISSION: 'Notify teachers about student submission',
            NOTIFY_STUDENTS_ABOUT_REVIEW_TO_SUBMISSION: 'Notify students when the teacher reviews student submission',
            NOTIFY_STUDENTS_ABOUT_DUE_DATE: 'Notify students about due date of assignment',
            NOTIFY_WHEN_SUBMITTED: 'Notify moderators about survey submission',
            NOTIFY_USERS_WHEN_SURVEY_PUBLISHED: 'Notify users when survey is published',
        },
        TITLE: {
            ADD: 'Add Notification',
            BROWSER: 'Notifications',
            NEW: 'New Notification',
            COURSE_NOTIFICATIONS: 'Course Notifications',
            CONNECTED_APPS: 'Apps connected to your Campus Account',
            MEETING_NOTIFICATIONS: 'Meeting Notifications',
            SURVEY_NOTIFICATIONS: 'Survey Motifications',
            CUSTOM_COURSE_ADDED: 'Extra Lesson Added',
            COURSE_ASSIGNMENT_ADDED: 'Assignment Published',
            SURVEY_PUBLISHED: 'New Survey Published',
            SURVEY_SUBMISSION: 'New Answer Submission for Survey',
            NEW_SUBMISSION: 'New Submission by Students',
            EXTRA_ATTEMPT: 'Extra Attempt to Assignments',
            RECORDING_READY: 'Recording Ready',
            MEETING_UPDATE: 'Course Meeting Changes',
            MEETING_START: 'Course Meeting Started',
            INTERNAL_NOTIFICATION: 'Internal Message',
            EMAIL_NOTIFICATION: 'Via E-mail',
            SMS_NOTIFICATION: 'Via SMS',
            SELF_ENROLLMENT_APPLIED: 'Self Enrollment Applied',
            RESPONDENTS: 'Respondents',
            CHAT_SOUND: 'Chat Sound',
        },
    },
    SOCIAL_PASSPORT: {
        TITLE: {
            FAMILY_CATEGORY: 'Social categories',
            COMPLETE_FAMILIES: 'Complete families',
            INCOMPLETE_FAMILIES: 'Incomplete families',
            NO_MOTHER: 'No mother',
            NO_FATHER: 'No father',
            LARGE_FAMILIES: 'Large families',
            LOW_INCOME: 'Low-income',
            ORPHANS: 'Orphans, children left without parental care',
            CHILDREN_WITH_DISABILITIES: 'Children with disabilities, children with special educational needs',
            STUDENT_WITHOUT_CITIZENS: 'Stateless students',
            STUDENT_CITIZENS_ANOTHER_COUNTRY: 'Students who are citizens of another state',
            REGISTERED_JUVENILE_DEPARTMENT: 'Registered with the juvenile department',
            REGISTERED_INTER_SCHOOL: 'It is registered with intraschool control',
            EDUCATION_OF_PARENT: 'Education of parents or other legal guardians of the student',
            HIGHER_EDUCATION: 'Higher, postgraduate',
            TECHNICAL_EDUCATION: 'Technical and professional',
            SECONDARY_EDUCATION: 'Secondary',
        },
    },
    QUIZ_STATISTICS: {
        TITLE: {
            INDEX: 'Index',
            TYPE: 'Type',
            ANSWERED_COUNT: 'Number of Answer',
            MARKED_COUNT: 'Number of Marked',
            VIEWED_COUNT: 'Number of Viewed',
            AVERAGE_POINT: 'Average Grade',
            OCCURANCE: 'Frequency',
            RAW_DESCRIPTION: 'Question Text',
            NUMBER_OF_STUDENT: 'Number of Student',
            NUMBER_OF_SUBMITTED_QUIZ: 'Number of Submitted Quiz',
            NUMBER_OF_GRADED_QUIZ: 'Number of Graded Quiz',
            NUMBER_OF_DIFFERENT_QUESTION: 'Number of Different Question',
            AVERAGE_TIME: 'Average Time',
            TOTAL_ANSWERED_QUESTION: 'Answered Question',
            TOTAL_UNANSWERED_QUESTION: 'Unanswered Question',
            TOTAL_VIEWED_QUESTION: 'Viewed Question',
            TOTAL_CORRECT_ANSWER: 'Correct Answer',
            TOTAL_PARTIALLY_CORRECT_ANSWER: 'Partially Correct answer',
            TOTAL_INCORRECT_ANSWER: 'Incorrect Answer',
            TOTAL_MARKED_QUESTION: 'Total Marked Question',
            TOTAL_NEED_TOBE_EVALUATE: 'Total need to be evaluate',
            QUIZ_STATISTIC: 'Quiz Statistics',
            QUIZ_STATISTIC_BY_QUESTION: 'Statistics by Question',
            GRADES: 'Grades',
            ITEM: 'Item',
            VALUE: 'Value',
        },
    },
    COURSE_ASSIGNMENT: {
        BUTTON: {
            ADD_ASSIGNMENT: 'Add Assignment',
            ADD_COMMENT: 'Add Comment',
            GO_TO_ASSIGNMENT: 'Go to Assignment',
            EXTRA_ATTEMPT: 'Extra Attempt',
            GET_DEFAULT_GROUPS: 'Get Defaults',
            GIVE: 'Give',
            PUBLISH_RESULTS: 'Publish Results',
            PREVIEW_QUIZ_MODE: 'Quiz Mode',
            PREVIEW_PRINT_MODE: 'Print Mode',
            RANDOMLY_ASSIGN: 'Randomly Assign',
            SAVE_AND_PUBLISH: 'Save & Publish',
            SUBMISSIONS: 'Submissions',
            VIEWS: 'Views',
            UNPUBLISH_RESULTS: 'Unpublish Results',
            LOCK_SUBMISSIONS: 'Lock Assignment',
            UNLOCK_SUBMISSIONS: 'Unlock Assignment',
            HIDE_GRADES: 'Hide Grades',
            SHOW_GRADES: 'Show Grades',
            MARK_ASSIGNMENT: 'Mark it',
            GOOGLE_CLASSROOM: 'Google Classroom',
        },
        FIELD: {
            AUDIO_DESCRIPTION: 'Audio Description',
            TEXT_DESCRIPTION: 'Text Description',
            AVAILABLE_FROM: 'Available from',
            DUE_DATE: 'Due Date',
            CUT_OFF_DATE: 'Cut Off Date',
            DISCUSSION_ENABLED: 'Discussion Enabled',
            REVIEW_SETTINGS: 'Review Settings',
            NOTIFICATION_SETTINGS: 'Notification Settings',
            DISCUSSION_SETTINGS: 'Discussion Settings',
            LOCKED_DATE: 'Locked Dates',
            LOCKED_FROM_DATE: 'Locked from Date',
            LOCKED_UNTIL_DATE: 'Locked Until Date',
            ASSIGNMENT_STATUS: 'Assignment Status',
            TARGET_COURSE: 'Target Course',
            TILL_DATE: 'Till Date',
            TILL_NEXT_LESSON: 'Till Next Lesson',
            SUBMISSION_TYPE: 'Submission Type',
            GROUP_NUMBERS: 'Number of Groups',
            GROUP_NAME: 'Group Name',
            NOT_ASSIGNED_STUDENTS: 'Not Assigned Students',
            SUBMITTED_GROUPS: 'Submitted Groups',
            QUIZ_OPEN_DATE: 'Quiz Open Date:',
            QUIZ_CLOSE_DATE: 'Quiz Close Date:',
            DURATION_IN_MINUTES: 'Duration (min):',
            DURATION: 'Duration (min)',
            DATE_TILL: 'Date Till',
            TIME_TILL: 'Time Till',
            EXTRA_ATTEMPT_DURATION: 'Extra Attempt Duration (min)',
            ATTEMPT_TYPE: 'Attempt Type',
            EXTRA_ATTMPT_DATE_TILL: 'Extra Attempt Date Till:',
            TOTAL_POINT: 'Total Point',
            NOT_REVIEWED: 'Not Reviewed',
            FEEDBACK: 'Feedback About Result',
            MINUTES: 'minutes',
            STARTED: 'Started',
            NOT_STARTED: 'Not Started',
            GROUP_BY: 'Group By',
            ATTACHMENT_TYPE: 'Attachment Type',
            REVIEWER: 'Reviewer',
            LAST_ATTEMPT: 'Last Attempt',
            OUT_OF_POINT: 'Out of {{point}} Points',
            ATTEMPT_TIME: 'Time for this Attempt',
            FINISHED: 'Finished',
            EXIST_ASSGINMENTS: 'Existing Assignments',
        },
        MESSAGE: {
            COMPLETE_SUCCESS: 'Course assignment successfully completed',
            CONFIRMATION_COMPLETE: 'Are you sure to complete the assignment?',
            CONFIRMATION_PUBLISH: 'Are you sure to save and publish the assignment?',
            CONFIRMATION_PUBLISH_RESULTS: 'Are you sure to publish assignment results?',
            CONFIRMATION_UNPUBLISH: 'Are you sure to unpublish the assignment?',
            CONFIRMATION_UNPUBLISH_RESULTS: 'Are you sure to unpublish assignment results?',
            FILL_ALL_REQUIRED_FIELDS: 'Please, fill all required fields',
            PUBLISH_SUCCESS: 'Course assignment successfully saved and published',
            PUBLISH_RESULTS_SUCCESS: 'Course assignment results successfully published',
            UNPUBLISH_SUCCESS: 'Course assignment successfully unpublished',
            UNPUBLISH_RESULTS_SUCCESS: 'Course assignment results successfully unpublished',
            SELECT_SUBSCRIBERS: 'Please, select assigned students or groups',
            FILL_GRADE_SETTINGS: 'Please, fill all required fields of Grade Settings',
            EXTRA_ATTEMPT_SUCCESS: 'Extra attempts successfully given',
            CAN_ONLY_VIEW: 'Assignment is temporarily locked. Now you can only view',
            ASSIGNMENT_LOCKED: 'Assignment is locked',
            GRADING_DUE_DATE_PASSED: '{{date}} was the last day of grading on this period.',
            EXTRA_ATTEMPT_COUNT: 'In all {{count}} extra attempt(s) given, ',
            LAST_EXTRA_ATTEMPT_DUE: 'left 1 attempt, submit due {{due}}',
            ALL_ATTEMPTS_USED: 'all were used',
            ASSIGNMENT_COPIED: 'The assignment successfully copied and opening it now',
            TEXT_AND_FILE_SUBMISSION_NOT_ENABLED:
                'You have to allow text or file submission, or select PRINT as the submission type',
            ADD_NOT_ASSIGNED_TO_FIRST_GROUP: 'Add all not assigned students to first group',
            ADD_OR_CHANGE_GROUPS: 'Add/Change Groups',
            DONT_FORGET_SET_SETTINGS: 'Do not forget to set Assignment settings',
            FILL_DUE_DATE_SETTINGS: 'Please, fill out the due date field',
            FILL_AVAILABILITY_SETTINGS: 'Please, fill out the enabled availability settings',
            SELECT_COURSE: 'Please, select course',
            MULTIPLE_CHOOSE_LIMIT: 'You can choose only {{item}} options',
            USER_HAS_NOT_ACCESS: 'Only the teachers of the course can update assignments. Now you can only view.',
            CREATE_NEW_NO_TEACHER_ERROR: 'Only teachers can create a new assignment.',
            QUIZ_STARTED: 'Quiz Started',
            ANSWER_ALL_REQUIRED_QUESTIONS:
                'To complete the exam, answer all the questions that must be answered. The following questions were not answered: {{item}}',
            TEACHER_COMMENTS_WARNING: 'This message will be send all the students that took this assignment',
            SUBMISSIONS_LOCKED: 'The assignment have been locked successfully.',
            SUBMISSIONS_UNLOCKED: 'The assignment have been unlocked successfully.',
            LOCKED_INFO: 'The assignment have been locked by the teacher.',
            HIDE_GRADES_TOOLTIP: 'Students will not be able to see the grades. You can always change this setting.',
            SHOW_GRADES_TOOLTIP:
                'Students will be able to see the grades after you graded. You can always change this setting.',
            HIDE_GRADES_MESSAGE: 'Grades have been made hidden successfully.',
            SHOW_GRADES_MESSAGE: 'Grades have been made visible successfully.',
            SUBMISSIONS_LOCK_CONFIRM: 'Are you sure you want to lock the submissions of assignment: {{item}}',
            SUBMISSIONS_UNLOCK_CONFIRM: 'Are you sure you want to unlock the submissions of assignment: {{item}}',
            SAVE_GRADING_BEFORE_PUBLISH: 'You must save the gradings you entered before publishing the gradings.',
            FEEDBACK_ABOUT_QUIZ: 'Write feedback about quiz result to student',
            MINUTES_LEFT: '{{duration}} min. left!',
            NEW_ATTEMPT_REQUEST_DECLINED: 'New attempt request has been declined successfully.',
            NEW_ATTEMPT_REQUEST_DECLINE_CONFIRM: 'Are you sure that you want to decline new attempt request?',
            SUBMISSION_SYNCHRONIZED: 'Submissions synchronized successfully',
            GOOGLE_CLASSROOM_CONFIRM:
                'Are you sure that you want to syncronize course information ( course create, update, invitation for students, assignments, grading etc) with Google Classroom?',
            NOT_FOUND: 'Course assignment not found or deleted',
        },
        TITLE: {
            NOTIFICATION_AND_DISCUSSION_TAB: 'Notification & Discussion',
            REVIEW_AND_GRADING_TAB: 'Review & Grading',
            ASSIGNMENT_AND_SUBMISSION: 'Assignment & Submission',
            NO_DUE_DATE: 'No Due Date',
            NO_QUESTIONS: 'No questions to display. Make sure you have added questions and saved them',
            MY_ASSIGNMENTS: 'My Assignments',
            ASSIGNED_TO_ALL: 'All Course Students',
            ASSIGNED_TO_GROUPS: 'Groups ({{count}})',
            ASSIGNED_TO_STUDENTS: 'Students ({{count}})',
            SELECT_GROUPS: 'Select Groups',
            SELECT_STUDENTS: 'Select Students',
            BROWSER: 'Assignment',
            NEW: 'New Assignment',
            OUT_OF: 'Out of {{weight}}%',
            EXTRA_ATTEMPT: 'Extra Attempt',
            COPY: 'Assignment Copy',
            ASSIGNMENT_GROUPS: 'Assignment Groups',
            ASSIGNMENT_SETTINGS: 'Assignment Settings',
            QUIZ_TIME: 'Quiz Time',
            CORRECT: 'Correct',
            INCORRECT: 'Incorrect',
            CORRECT_ANSWER: 'Correct Answer',
            STUDENT_ASSIGNMENTS: 'Student Assignments',
            TEACHER_COMMENTS: 'Teacher Comments',
            GROUP_CHAT: 'Group Chat',
            ONLY_IMPORTANT: 'Show Only Marked',
            ENROLL_TO_ASSIGNMENTS: 'Assign to existing course assignments',
        },
    },
    SUBMISSION: {
        BUTTON: {
            NEW_ATTEMPT: 'New Attempt',
            GRADE: 'Grade',
            CHANGE_GRADE: 'Change Grade',
            GRADES: 'Grades',
            UNASSIGN: 'Unassign',
            REQUEST_NEW_ATTEMPT: 'Request New Attempt',
        },
        MESSAGE: {
            CONFIRM_SUBMIT: 'Do you want to submit?',
            SUCCESS_SAVED_AS_DRAFT: 'Successfully saved as a draft',
            SUCCESS_DELETED_DRAFT: 'Successfully deleted a draft',
            SUCCESS_SUBMITTED_TO_REVIEW: 'Successfully submitted to review',
            MAX_ATTEMPTS_USED: 'All {{maxAttempt}} attempts used',
            SUCCESS_GRADE_CHANGED: 'Grade successfully changed',
            SAVE_GRADE: 'Do you want to save these students grades',
            NO_REVIEW_COMMENT_LEFT: 'No review comment was left',
            GRADE_EXCUSE_SAVED: 'Grade Excuse Successfully Saved',
            GRADE_SAVE_CONFIRMATION: 'Do you want to save these Grade Excuses? ',
            WORD_COUNT_EXCEEDS: 'Maximum allowed word count for this assignment is {{count}}',
            UPLOAD_FILE_COUNT_EXCEEDS_LIMIT: 'Maximum allowed file count for this assignment is {{count}}',
            UPLOAD_FILE_SIZE_EXCEEDS_LIMIT:
                'Maximum allowed file size for each file for this assignment is {{size}}MB ',
            GRADE_UNGRADED_STUDENTS:
                'No grades have been entered for all students. To publish the results, please enter grades for students who have not entered grades.',
            NEW_ATTEMPT_REQUEST_CONFIRM: 'Are you sure that you want to request a new attempt?',
        },
        FIELD: {
            GRADE: 'Grade',
            GRADE_WITH_PARAM: 'Grade ({{gradeMin}} - {{gradeMax}})',
            MAX_ATTACHED_FILE_SIZE: 'Max Attached File Size (MB)',
            MAX_ATTEMPTS: 'Max.Attempts',
            QUIZ_MAX_ATTEMPTS: 'Max.Attempts',
            MAX_UPLOADED_FILES: 'Max.Number of Uploaded Files',
            WORD_LIMIT: 'Word Limit',
            TEXT_SUBMISSION: 'Text Submission',
            FILE_SUBMISSION: 'File Submission',
            ALLOW_SUBMISSION_FROM: 'Allow Submission from',
            SUBMISSION: 'Submission',
            TEXT: 'Text',
            ALL_SUBMISSIONS: 'All Submissions',
            SUBMITTED_TIME: 'Submitted Time',
            SUBMIT_ATTEMPT: 'Submit {{attempt}} of {{maxAttempt}} Attempts',
            LAST_SUBMISSION: 'Last Submission',
            LAST_SUB_TIME: 'Last Sub.Time',
            SHOW_ONLY_NOT_GRADED_STUDENTS: 'Show Only not Graded Students',
            GRADE_EXCUSE_TYPE: 'Excuses',
            SUBMISSION_COUNT: 'Submissions',
            LATE: 'Late',
            ON_TIME: 'On Time',
            NEEDS_GRADING: 'Needs Grading',
            NO_NEEDS_GRADING: 'No Needs',
            NOT_GRADED: 'Not Graded',
            NEW_ATTEMPT_REQUEST: 'Attempts',
            STUDENT_MESSAGE: 'Student Message',
        },
        TITLE: {
            BROWSER: 'Submissions',
            NEW: 'New Submission',
            EDIT: 'Submission',
            SUBMIT: 'Submit',
            ATTEMPT_OF: 'Submission {{attempt}} of {{maxAttempt}} Attempt(s)',
            ATTEMPT: 'Submission Attempt(s): {{attempt}}',
            UNLIMITED: 'Unlimited',
            GRADES: 'Grades',
            GRADE_EXCUSE: 'Grade Excuse',
            SUBMISSION_STATUS: 'Submission Status',
            GRADE_UNGRADED_STUDENTS: 'Grade Ungraded Students',
            SUBMISSION_HISTORY: 'Submission History',
        },
        ERROR: {
            GRADE_CAN_NOT_GREATER_THAN_MAX_POINT:
                'The grade you have entered cannot be greater than max. point: {{maxPoint}}',
        },
    },
    REPORT_CARD: {
        BUTTON: {
            GENERATE_REPORT_CARD: 'Generate Report Cards',
        },
        TITLE: {
            GENERATE_REPORT_CARD_CONFIRMATION: 'Do you want to generate report cards?',
            GENERATED_REPORT_CARD: 'Generated report cards',
            REPORT_CARD_WARNING: 'Report card not generated yet',
        },
        FIELD: {
            LAST_ACTION: 'Last Action',
        },
    },
    CUSTOM_PARAMETERS: {
        TITLE: {
            TITLE: 'Custom Parameter',
            ADD: 'Add New Parameter',
            EDIT: 'Edit Parameter',
            PARAMETER: 'Parameter',
        },
        FIELD: {
            CATEGORY: 'Category',
            CAPTION: 'Caption',
            DESCRIPTION: 'Description',
            REPORT_CODE: 'Reporting Code',
        },
        MESSAGE: {},
    },
    ATTENDANCE_CODES: {
        TITLE: {
            TITLE: 'Attendance Codes',
            ADD: 'Add New Attendance Code',
            EDIT: 'Edit Attendance Code',
        },
        FIELD: {
            ATTENDANCE_CODE: 'Attendance Code',
            CATEGORY: 'Category',
            POINT: 'Point',
            DESCRIPTION: 'Description',
            REPORT_CODE: 'Reporting Code',
            TEACHER_CAN_ASSIGN: 'Teacher Can Assign',
            PRESENCE: 'Presence',
            ABSENCE: 'Absence',
            USE_FOR_COURSE: 'Use for Course Attendance',
            USE_FOR_DAILY: 'Use for Daily Attendance',
        },
        MESSAGE: {
            TEACHER_CAN_ASSIGN_HINT: 'Without approve teacher can assign',
            POINT_HINT: 'Points must be set to "1" for absent and "0" for Present',
        },
    },
    EDUCATION_REPORTS: {
        TITLE: {
            SELECT_EDUCATION_REPORT: 'Select education report',
            EDUCATION_REPORTS: 'Education reports',
            STUDENT_REPORT_CARD: 'Student Report card',
        },
        FIELD: {
            YOUNG_SPECIALIST: 'Young Specialist',
            MENTOR: 'Mentor',
        },
        MESSAGE: {
            DISMISSAL_REPORT_EXCEL:
                'Total for the reporting period from {{fromDate}} to {{toDate}}. Total Students: {{totalStudents}}',
            STUDENT_REGISTRATION_BOOK: 'Book of registration of departed and arrived students',
        },
        NAME: {
            ANALYSIS_REPORT: 'СОР-СОЧ {{periodName}} по предмету {{courseName}}',
        },
    },
    REVIEW: {
        BUTTON: {
            MARK_AS_REVIEWED: 'Mark as Reviewed',
            REVIEW_AND_GRADE: 'Review & Grade',
        },
        FIELD: {
            AS_COMMENT: 'Review as Comment',
            AS_FILES: 'Review via Attachments',
            REVIEW_WITHOUT_SUBMISSION:
                "* If you want to review only submissions with text or files, change 'Submissions' settings in assignment page",
            REVIEW_WITHOUT_TEXT_OR_FILES:
                "* If you want to review as comment or via attachments, change 'Review' settings in assignment page",
        },
        MESSAGE: {
            DRAFT_SUBMISSION_NO_REVIEW: 'Selected submission is "Draft" and you can\'t review it yet',
            NOT_HAVE_SUBMISSIONS: 'This student or group does not have any submissions',
            REVIEWED_SUCCESSFULLY: 'Submission successfully reviewed',
        },
        TITLE: {
            ASSIGNED: 'Assigned',
            ASSIGNED_TO_STUDENTS: 'Assigned to Students',
            ASSIGNED_TO_GROUPS: 'Assigned to Groups',
            BROWSER: 'Review',
            COURSE_ASSIGNMENT: 'Assignment',
            COURSE_ASSIGNMENT_WITH_PARAM: 'Assignment - {{param}}',
            DIALOG: 'Submission Review',
            NEW_SUBMISSIONS: 'New Submissions',
            NO_STUDENTS_WORK: 'There is no submissions',
            REVIEWED: 'Reviewed',
            STUDENTS_WORK: 'Submissions',
            QUIZ_STATISTICS: 'Quiz Statistics',
            SUBMITTED_BY: 'Submitted by',
            VIEW_ALL_SUBMISSIONS: 'View All Submissions',
        },
    },
    PAGINATOR: {
        FIRST_PAGE_LABEL: 'First Page',
        ITEMS_PER_PAGE_LABEL: 'Size',
        LAST_PAGE_LABEL: 'Last Page',
        NEXT_PAGE_LABEL: 'Next Page',
        PREVIOUS_PAGE_LABEL: 'Previous Page',
        RANGE_PAGE_LABEL_1: '0 of {{length}}',
        RANGE_PAGE_LABEL_2: '{{startIndex}} - {{endIndex}} of {{length}}',
    },
    PAYMENT: {
        BUTTON: {
            APPROVE: 'Approve',
            UN_APPROVE: 'Un-Approve',
            REFRESH_PENDING_PAYMENTS: 'Refresh Processing Payments',
            REFRESH_PENDING_PAYMENTS_FROM: 'Refresh processing payments from {{resource}} website',
            UPDATE_INSTALLMENT: 'Update Installment',
        },
        FIELD: {
            PAY: 'Pay',
            PAYMENT_SUCCESS_WAITING:
                'We received your payment. Your balance will change, after your payment is approved.',
            PAY_AMOUNT_DUE: 'Pay Amount Due',
            PAY_MIN_AMOUNT_DUE: 'Pay Minimum Amount Due',
            CHOOSE_AMOUNT_TO: 'Choose Amount to Pay',
            TRANSACTION_FEE: '{{fee}} Applied as Transaction Fee',
            ENABLE_PROVIDER: '{{provider}}',
            PAYMENT_MAX_AMOUNT: 'Maximum Payment Amount is {{amount}}',
            AMOUNT: 'Amount',
            BANK_ACCOUNT: 'Bank Account',
            BANK_TRANSACTION_ID: 'Bank Transaction ID',
            CURRENT_DEBT: 'Current Debt',
            DOCUMENT_ID: 'Document ID',
            PAYMENT_SOURCE: 'Payment Source',
            PAYMENT_STATUS: 'Payment Status',
            PROCESS_DATE: 'Process Date',
            PROCESS_DATE_RANGE: 'Process Date Range',
            STUDENT_PAYMENT: 'Student Payment',
            STUDENT_PAYMENTS: 'Student Payments',
            TOTAL_DEBT: 'Total Debt',
            TRANSACTION_DATE: 'Transaction Date',
            PROVIDER_TYPE: 'Provider Type',
            TRANSACTION_FEE_MINIMUM: 'Flat Transaction Fee',
            TRANSACTION_FEE_PERCENTAGE: 'Percentage transaction fee',
            CARD_HOLDER_NAME: 'Card holder name required',
            PAYMENT_PROCESSING_DATA: 'Processing payment list',
            INSTALLMENT_PLAN_TITLE: 'New Installment Plans',
            PAYMENT_DATE: 'Payment Date',
            STRIPE: {
                TOTAL_PAYMENT_DISCOUNT: 'Pay in full. Get {{amount}} discount',
                TOTAL_PAYMENT_AT_ONCE: 'Pay in full {{amount}} at once.',
            },
        },
        MESSAGE: {
            CONFIRM: {
                APPLY: 'Do you want to apply this student payment?',
                DELETE: "Do you want to delete this student payment and all it's details?",
                DELETE_DETAIL: 'Do you want to delete this student payment detail?',
                UN_APPLY: 'Do you want to unapply this student payments?',
                UPDATE_INSTALLMENT:
                    'Do you want to update installment? If you approve this process, the installment dates will be changed according to the dates in the list and {{provider}} will withdraw money from your account automatically. ',
                CANCEL_INSTALLMENT: 'Do you want to cancel installment?',
            },
            SUCCESS: {
                SUCCESSFUL: 'Payment successful',
                APPLIED: 'Student Payment successfully applied!',
                UN_APPLIED: 'Student Payment successfully unappplied!',
                PENDING: 'Payment is processing',
            },
            WARNING: {
                MORE_THAN_BALANCE: 'Your payment is more than your balance',
                LESS_THAN_MIN: 'Your payment is less than minimum amount',
                MISSING_FEE: 'Student doesn\'t have "Student Fees"!',
                MISSING_FEES: 'Student Payment not approved! Because some students dont have "Student Fees"!',
            },
        },
        TITLE: {
            ADD: 'Add Payments',
            BROWSER: 'Student Payments',
            DETAILS: 'Payment Details',
            EDIT_PAYMENT: 'Edit Payment',
            EDIT_PAYMENTS: 'Payments',
            HINT_INTEGRATION_CODE: 'Integration to another system code (Accounting System etc.)',
            HINT_PAYMENT_PRIORITY: 'Payment Priority',
            HINT_PRODUCT_IMAGE_URL: 'The link of the photo will be displayed when automatic installment is setting',
            NEW_DETAILS: 'New Payment Details',
            NEW_PAYMENT: 'New Payment',
            NEW_PAYMENTS: 'New Payments',
            OUTSTANDING_PAYMENTS: 'Outstanding Payments',
            TOTAL_PAYMENTS: 'Total Payments',
            SUPPORTED_CURRENCIES: 'Supported currencies are: {{currencies}}',
            WIDGETS_DISABLED: 'All payment widgets are disabled',
            NO_SUPPORTED_WIDGETS: '{{currency}} is not supported by any payment widgets',
            HAS_ACTIVE_INSTALLMENT:
                'Fee has montly installment. It will be withdrawed automatically by {{provider}} from your account.',
            PAYMENT_COMPLETED: 'Payment is completed',
            INSTALMENT_IN_PROCESS: 'Instalment process is being started',
        },
        PROVIDER: {
            TITLE_SELECT: 'Select Provider for Payment',
            DISCOUNT_AMOUNT_AT_ONCE_PAYMENT: 'Discount amount in case of full payment',
            CREATE_INSTALLMENT: 'Create Installment for Future Payment',
            KASSA24: {
                TITLE: 'Kassa24',
                MERCHANT_ID: 'Merchant ID',
                PASSWORD: 'Password',
                TRANSACTION_ENDPOINT: 'Transaction Endpoint',
                CALLBACK_ENDPOINT: 'Callback Endpoint',
            },
            PAYPAL: {
                TITLE: 'Paypal',
                CLIENT_ID: 'Client ID',
                CLIENT_SECRET: 'Client Secret',
                TRANSACTION_ENDPOINT: 'Transaction Endpoint',
            },
            STRIPE: {
                TITLE: 'Stripe',
                PUBLISHABLE_KEY: 'Publishable Key',
                SECRET_KEY: 'Secret Key',
                WEBHOOK_ENDPOINT_SECRET_KEY: 'Webhook Secret Key',
            },
            CLOUDPAYMENTS: {
                TITLE: 'Cloud Payments',
                PUBLIC_ID: 'Public ID',
                API_PASSWORD: 'API Password',
            },
        },
    },
    PERIOD_FEE: {
        BUTTON: {
            ADD_PERIOD_DISCOUNT: 'Add Period Discount',
            ADD_PERIOD_FEE: 'Add Period Fee',
        },
        FIELD: {
            FORMULA_EXAMPLE: 'Formula (Ex:  FEE_VALUE * 0.15)',
            FORMULA_TYPE: 'Formula Type',
            VALUE_TYPE: 'Value Type',
        },
        MESSAGE: {
            CONFIRM: {
                LIST_CHANGES: 'You have unsaved changes in fee list. Do you want to discard your changes?',
                PERIODLIST_CHANGES:
                    'You have unsaved changes in period info and fee list. Do you want to discard your changes?',
                PERIOD_CHANGES: 'You have unsaved changes in period info. Do you want to discard your changes?',
            },
        },
        TITLE: {
            FEES: 'Fees',
            NEW_PERIOD_FEE: 'New Period Fee',
            PERIOD_FEE: 'Period Fee',
        },
    },
    POSITIONS: {
        BUTTON: {
            POSITION_SALARY: 'Position Salary',
        },
        FIELD: {
            EXPERIENCE: 'Experience',
            TYPE: 'Position Type',
        },
        TITLE: {
            ADD: 'Add Position Salary',
            BROWSER: 'Position Salary',
            NEW: 'New Position Salary',
        },
    },
    POSITION_CATEGORY: {
        FIELD: {
            POSITION_CATEGORY: 'Position Category',
        },
        TITLE: {
            ADD: 'Add Position Category',
            BROWSER: 'Position Categories',
            NEW: 'New Position Category',
        },
    },
    POSITION_SALARY: {
        ERROR: {
            FORM_INVALID: 'Position data you have entered is invalid! Please check your information and try again',
        },
        FIELD: {
            EXPERIENCE: 'Experience Range (Ex.: 0-3, 4-6)',
            SALARIES: 'Salaries',
            SALARY: 'Salary',
        },
        MESSAGE: {
            SUCCESS: {
                ADDED: 'Position Salary were successfully added',
                UPDATED: 'Position Salary were successfully updated',
            },
        },
        TITLE: {
            BROWSER: 'Position Salary',
            NEW_SALARY: 'New Salary',
            SALARY_HISTORY: 'Salary History',
            TABLE_EXPERIENCE: 'Experience',
        },
    },
    ROOMS: {
        FIELD: {
            MAX_PARALLEL_LESSONS: 'Max. Simultaneous Lesson',
        },
        TITLE: {
            BROWSER: 'Locations',
            ADD: 'Add Location',
            EDIT: 'Location',
            NEW: 'New Location',
            IMPORT_ROOMS: 'Import Locations from Excel Sheet',
            TEMPLATE_FILENAME: 'location-excel-template',
        },
        MESSAGE: {
            NO_ROOMS_TO_IMPORT: 'There were not found any new locations to import',
        },
    },
    SALARY_CONSTANTS: {
        DOES_NOT_EXIST: 'This salary parameter has already been deleted!',
        FIELD: {
            VALUE: 'Value',
        },
        TITLE: {
            ADD: 'Add Salary Parameter',
            BROWSER: 'Salary Parameters',
            NEW: 'New Salary Parameter',
        },
    },
    SALARY_HISTORY: {
        ERROR: {
            SALARY_LIST_IS_EMPTY: 'Salary Table is empty. Please calculate Salary',
        },
        FIELD: {
            BANK_NAME: 'Bank',
            DEDUCTIONS: 'Deductions',
            EARNINGS: 'Earnings',
            EMPLOYEE_TAXES: 'Employee Taxes',
            EMPLOYER_TAXES: 'Employer Taxes',
            GROSS_SALARY: 'Gross Salary',
            NET_SALARY: 'Net Salary',
            SALARY: 'Salary',
            SALARY_SLIP: 'Salary Slip',
            SALARY_WITH_PARAM: 'Salary {{param}}',
            STATUS: 'Salary Status',
            TOTAL_RATE: 'Total  Rate',
            TOTAL_SALARY: 'Total Salary',
        },
        TITLE: {
            BROWSER: 'Salaries',
            CURRENCY_RATE: 'Currency Rate',
            NEW_SALARY_CALCULATION: 'New salary calculation',
        },
    },
    SALARY_MODIFIER: {
        FIELD: {
            APPLY_TO_ALL: 'Apply to Employees',
            FORMULA_EXAMPLE: 'Formula (Ex:  BASE_SALARY * 0.15)',
            VALUE: 'Value',
            VALUE_NAME: 'Value Name',
            VARIABLE: 'Variable',
        },
        MESSAGE: {
            CONFIRM: {
                MODIFIER_CHANGES:
                    'You have unsaved changes in salary modifier info. Do you want to discard your changes?',
            },
            ERROR: {
                DUPLICATE_VALUE_NAME: 'Duplicate Value Name',
                DUPLICATE_VARIABLE_HANDLE: 'There is already formula variable with name  "{{item}}"',
                NOT_APPLIED: 'But not applied to selected employees.',
                ONLY_ONE_VARIABLE_NAME: 'You can write only 1 formula variable name',
            },
            INFO: {
                NO_MODIFIERS_VARIABLES: 'No Modifier Variables',
            },
        },
        TITLE: {
            ADD: 'Add Salary Modifier',
            BROWSER: 'Salary Modifiers',
            MODIFIER: 'Modifier',
            MODIFIER_VARIABLE: 'Modifier Variable',
            MODIFIER_VARIABLES: 'Modifier Variables',
            MODIFIER_VARIABLES_LIST: 'List of Possible Values',
            NEW: 'New Salary Modifier',
            NEW_MODIFIER: 'New Modifier',
            NEW_MODIFIER_VARIABLE: 'New Modifier Variable',
        },
    },
    SALARY_PARAMETER: {
        TITLE: {
            ADD: 'Add Salary Parameter',
            ASSIGNED_SALARY_MODIFIERS: 'Salary Modifiers',
            BANK_INFO: 'Bank Information',
            BASE_SALARY_MODIFIER: 'Base Salary Modifier',
            EMPLOYEE_TAX: 'Employee Tax',
            EMPLOYER_TAX: 'Employer Tax',
            NEW: 'New Salary Parameter',
            POSITIONS: 'Positions',
            WORK_CALENDAR: 'Work Calendars',
        },
    },
    SALARY_PLAN: {
        MESSAGE: {
            ERROR: {
                BUDGET_ACCOUNT_ALREADY_USED: 'Budget Account is already used',
                COST_CENTER_SHOULD_NOT_BE_EMPTY: 'Cost Centers should not be empty!',
                INVALID_SALARY_PLAN_INFO: 'Invalid Salary Plan Info!',
                PLAN_DETAIL_SHOULD_NOT_BE_EMPTY: 'Salary Plan Details should not be empty!',
            },
        },
        TITLE: {
            ADD: 'Add Salary Plan',
            ADD_SALARY_PLAN_DETAIL: 'Add Salary Plan Detail',
            AVERAGE_SALARY: 'Average Salary',
            BROWSER: 'Salary Plans',
            NEW: 'New Salary Plan',
            SALARY_PLAN_DETAIL: 'Salary Plan Detail',
            SALARY_PLAN_DETAILS: 'Salary Plan Details',
            SALARY_PLAN_INFO: 'Salary Plan Info',
            VALUE_IN_UNITS: 'Value (in hours, days, square meters, etc.)',
        },
    },
    SALARY_TYPE: {
        FIELD: {
            ROLES: 'User Type',
        },
        TITLE: {
            ADD: 'Add Salary Type',
            BROWSER: 'Salary Type',
            NEW: 'New Salary Type',
        },
    },
    SCHOOL: {
        BUTTON: {
            ADD_SERVER: 'Add Server',
            CHECK_CONNECTION: 'Check Connection',
            SHOW_BALANCE: 'Show Balance',
            FAILOVER: 'Failover server',
        },
        MESSAGE: {
            ADD_BACKGROUND_IMAGE: 'Add Background Image in School Setup',
            ADD_MEETING_SERVERS: 'Please contact with System Administrator to add conference servers to the school',
            API_KEY_EMPTY: 'API Key is empty!',
            MAIL_SERVER_SUCCESSFULLY_CONNECTED: 'Mail server successfully connected',
            BBB_SERVER_CONNECTION_FAILURE:
                'BBB Server connection failed. Please check the validity of the URL and secret code',
            BBB_SERVER_SUCCESSFULLY_CONNECTED: 'BBB Server successfully connected',
            SERVER_ID_DUPLICATED: 'There is already Server with ID "{{item}}"',
            SERVER_URL_DUPLICATED: 'There is already Server with URL "{{item}}"',
            SMS_BALANCE: 'Your balance is: {{item}}',
            ACCOUNTING_SERVER_SUCCESSFULLY_CONNECTED: 'Accounting system server successfully connected!',
            CONFIRM_SCHOOL_DELETION: 'Please confirm that you want to delete "{{item}}" school',
            SCHOOL_DELETION_CONFIRMATION_SENT:
                'School deletion confirmation requested, please check you e-mail for confirmation link',
            CAN_SEND_MESSAGE_TO: '{{item}} can send message to...',
            SHOW_GRADE_LEVEL_TO_SCHOOL: 'Only those selected schools can use this grade level.',
            SHOW_SUBJECT_TO_SCHOOL: 'If you select schools, only those schools can use this subject.',
        },
        TITLE: {
            ADD: 'Add School',
            ADDRESS_INFO: 'Address',
            API_KEY: 'API Key',
            BROWSER: 'Schools',
            CONSIDER_EMPLOYEE_CONTRACT: 'Employee Contract Required',
            CONSIDER_STUDENT_ENROLLMENT: 'Student Enrollment Required',
            CONSIDER_ORDER: 'Consider Order',
            ENROLL_UNENROLLED_STUDENT: 'Assign unenrolled students to this school',
            CONTACT_INFO: 'Contact Info',
            COPY_LINK: 'Copy Link',
            DEFAULT_CURRENCY: 'Default Currency',
            DEFAULT_TIME_ZONE: 'Default Time Zone',
            DOMAIN_NAME_EMPTY: 'Domain name for registration is not set',
            EMAIL: 'E-mail',
            EMAIL_AND_SMS: 'E-mail & SMS',
            EMPLOYEES: 'Employees',
            ENABLE: 'Enable',
            EXAM_REGISTRATION_LINK: 'Registration Link',
            EXAM_STATUS_LINK: 'Registration Status Link',
            FAX: 'Fax',
            HOST: 'Host',
            INFO: 'School Info',
            LINK_COPIED: 'Link Copied',
            MAIL: 'Mail',
            MEETING_SERVERS: 'Meeting Servers',
            MIN_BALANCE: 'Min Balance',
            NEW: 'New School',
            ONLINE_EDUCATION_SETTINGS: 'Online Education',
            ONLINE_PAYMENT_SETTINGS: 'Online Payment',
            SETTINGS: 'Settings',
            PASSWORD: 'Password',
            PHONE_MASK: 'Phone Mask',
            PORT: 'Port',
            POSTAL_CODE: 'Postal Code',
            SCHOOL_CONSTANTS: 'Parameters',
            SCHOOL_DELETION: 'School Deletion in Progress',
            SCHOOL_DELETION_CONFIRMMATION: 'School Deletion Confirmation',
            SERVER_SETTINGS: 'E-Mail Settings',
            PAYPAL_SETTINGS: 'Paypal Settings',
            GRADE_SETTINGS: 'Grade Settings',
            DEFAULT_GRADE_CATEGORY: 'Default Grade Category',
            DEFAULT_GRADING_SCHEME: 'Default Grading Scheme',
            ENABLE_CREDIT_SYSTEM: 'Credit System',
            GRADE_PERIOD: 'Grading Period',
            ROLE_MESSAGE_SETTINGS: 'Message Settings',
            SMS: 'SMS',
            SMTP_AUTH: 'SMTP Auth',
            STREET: 'Street',
            TLS_ENABLED: 'START TLS Enabled',
            TLS_REQUIRED: 'SSL/TLS Required',
            USERNAME: 'Username',
            WEBSITE: 'Website',
            WORK_PHONE: 'Work Phone',
            SCHOOL_SETTINGS: 'Settings',
            SENDER_PHONE_NUMBER: 'Sender phone number or signature(if exist)',
            ENABLE_DAILY_ATTENDANCE: 'Enable Daily Attendance',
            ENABLE_DAILY_ABSENT_LIMIT: 'Absent Limit',
            UI_SETTINGS: 'User Interface Settings',
            BANNER_BACKGROUND: 'Background Color',
            SELECTED_BUTTON_BACKGROUND: 'Selected Button Background',
            SELECTED_BUTTON_TEXT: 'Selected Button Color',
            SELECTED_BUTTON_BADGE_CLASS: 'Selected Button Badge Class',
            NORMAL_BUTTON_BADGE_CLASS: 'Normal Button Badge Class',
            LOGO_WIDTH: 'Logo Width',
            TEXT_COLOR: 'Text Color',
            TOOLBAR_HEIGHT: 'Banner Height(px)',
            HIDE_SCHOOL_NAME: 'Hide School Name',
            ACADEMIC_YEAR_POSITION_LEFT: 'Academic Year Position(Left)',
            ACADEMIC_YEAR_POSITION_BOTTOM: 'Academic Year Position(Bottom)',
            TEXT_TO_SPEECH_VOICES: 'Text to Speech Voices',
            ENABLED_GROUPS: 'Enabled Groups',
            ENABLED_DISCOUNTS: 'Enabled Fee Discounts',
            ENABLED_SIMPLE_MEDICAL: 'Enabled Simple Medical Info',
            ENABLED_ACHIEVEMENT: 'Enabled Achievements',
            ENABLED_AGREEMENT: 'Enabled Agreement',
            ENABLED_ID_CARD: 'Enabled ID Card Generation',
            ENABLED_CERTIFICATES: 'Enabled Certificates',
            ENABLED_CONTRACTS: 'Enabled Contracts',
            ENABLED_EDUCATION: 'Enabled Education',
            ENABLED_EXPERIENCE: 'Enabled Experience',
            ENABLED_ATTESTATION: 'Enabled Attestation',
            ENABLED_SIBLINGS: 'Enabled Sibling Info',
            DAILY_ATTENDANCE_ABSENT_LIMIT: 'Daily Attendance ABSENT Limit',
            ATTENDANCE_NOTIFICATION_TIME: 'Attendance Notification Time',
            NOTIFICATION_TYPES: 'Attendance Notify By',
            TWILIO_SERVICE_ID: 'Message Service SID',
            ENABLE_CHAT: 'Chat Enabled',
            ENABLE_STANDART_BASED_GRADING: 'Enable Standard Based Grading',
        },
    },
    SCHOOL_BALANCE_REPORT: {
        FIELD: {
            NOT_PAID_PERCENT: 'Not Paid (%)',
            SCHOOL_BALANCE: 'Schools Fee Balance',
            TOTAL_CANCELLED: 'Total Cancelled',
            TOTAL_REFUNDED: 'Total Refunded',
        },
        TITLE: {
            BROWSER: 'Schools Balance Report',
        },
    },
    SCHOOL_CLASSES: {
        TITLE: {
            ADD: 'Add School Class',
            BROWSER: 'School Classes',
            NEW: 'New School Class',
        },
    },
    SCHOOL_DEPARTMENT: {
        ERROR: {
            SECTION_NAME_DUPLICATED: 'The following Section names were duplicated: "{{item}}"',
            SECTION_SHORTNAME_DUPLICATED: 'The following Section short names were duplicated: "{{item}}"',
        },
        FIELD: {
            VALUE: 'Value',
            COPY_FROM: 'Copy from School Department:',
        },
        TITLE: {
            ADD: 'Add School Department',
            BROWSER: 'School Departments',
            NEW: 'New School Department',
        },
    },
    SCHOOL_LOCATION: {
        TITLE: {
            ADD: 'Add Location',
            BROWSER: 'Locations',
            NEW: 'New Location',
            TYPE: 'Location Type',
        },
    },
    SCHOOL_LOG: {
        TITLE: {
            ADD: 'Add School Log',
            BROWSER: 'School Logs',
            DESCRIPTION: 'School Log',
            EDIT: 'School Log',
            NEW: 'New School Log',
        },
        FIELD: {
            LOG_TYPE: 'Log Type',
            POINT: 'Point',
            REPORTED_BY: 'Reported By',
            INVOLVED_ENTITY: 'Involved Entity',
            NOTIFY_VIA: 'Notify via',
            NOTIFICATION_SUBSCRIBERS: 'Notification Subscribers',
            VALUE: 'Value',
            ABSOLUTE_VALUE: 'Absolute Value',
        },
    },
    SCHOOL_LOG_TYPE: {
        TITLE: {
            ADD: 'Add School Log Type',
            BROWSER: 'School Log Types',
            DESCRIPTION: 'School Log Type',
            EDIT: 'School Log Type',
            NEW: 'New School Log Type',
            NOTIFY_WITH_MESSAGE: 'Notify via Message',
            NOTIFY_WITH_EMAIL: 'Notify via E-Mail',
            NOTIFY_WITH_VOICE: 'Notify via Voice',
            POINTS_RANGES: 'Point Ranges',
            RANGES: 'Ranges',
            ADD_NEW_POINT_RANGE: 'Add New Point Range',
            EDIT_POINT_RANGE: 'Edit Point Range',
        },
        FIELD: {
            POINTS: 'Points',
            POINTS_ENABLED: 'Points Enabled',
            INITIAL_POINT_VALUE: 'Initial Point Value',
            ENABLE_OVERRIDE_POINTS: 'Can change default value',
            DISPLAY_IN_REPORT: 'Display in Report',
            TRACE_STATUS: 'Follow the Log Status',
        },
        MESSAGE: {
            POINT_RANGE_OVERLAP: 'There is an overlap with the following ranges: {{item}}',
            POINT_RANGE_FROM_AND_TO_EMPTY: 'Please fill either "From" or "To". Both cannot be empty.',
            POINT_RANGE_FROM_TO_SMALLER: '"From" must be smaller than "To".',
        },
    },
    SCHOOL_LOG_POINT: {
        TITLE: {
            ADD: 'Add Point',
            BROWSER: 'Points',
            DESCRIPTION: 'Point',
            EDIT: 'Point',
            NEW: 'New Point',
        },
        FIELD: {
            POINT: 'Point',
            TOTAL: 'Total',
            INITIAL: 'Initial',
            POSITIVE: 'Positive',
            NEGATIVE: 'Negative',
        },
    },
    SCHOOL_MESSAGE_SETTINGS: {
        COURSE_MEMBERS: 'Course Members',
        CLASS_MEMBERS: 'Class Members',
        CLASSMATES: 'Classmates',
        TEACHER: 'Teacher',
        SCHOOL_ADMINISTRATORS: 'School Administrators',
        TENANT_ADMIN: 'Tenant Admin',
    },
    STATE: {
        TITLE: {
            ADD: 'Add State',
            ALL: 'All',
            BROWSER: 'States',
            EDIT: 'State',
            NEW: 'New State',
            STATE: 'State',
        },
    },
    STUDENTS: {
        FIELD: {
            ACCOUNT_NOT_ACTIVATED: 'Not Activated',
            FROM_CLASS: 'From Class',
            MOVED_SCHOOL: 'Moved School Name',
            NOTE: 'Note',
            STUDENT_CARDS: 'Student Cards',
            STUDENTS_LIST: 'Students List',
            STUDENT_FULLNAME: 'Student Fullname',
            TO_CLASS: 'To Class',
            TO_ACADEMIC_YEAR: 'To Academic Year',
            FROM_ACADEMIC_YEAR: 'From Academic Year',
            USE_STUDENT_AS_REPRESENTATIVE: 'Use Student as Parent',
            USER_ACCOUNT: 'User Account',
            NOT_ASSIGNED: 'Show students who are not assigned any classes',
            COUNSELOR_NOT_ASSIGNED: 'Not Assigned',
            COUNSELOR_ASSIGN: 'Assign Counselor',
            COUNSELOR_REMOVE: 'Remove Counselor',
            SPECIAL_CODE: 'Special Code',
            FROM: 'From',
            TO: 'To',
            ENTRY_DATE: 'Entry Date',
            LEAVE_DATE: 'Leave Date',
            LEAVE_PLACE: 'Where did (he/she) go',
            OLD_COUNSELOR: 'Old Counselor',
            NEW_COUNSELOR: 'New Counsoler',
        },
        TITLE: {
            ACHIEVEMENTS: 'Achievements',
            ADD_ACHIEVEMENT: 'Add Achievement',
            ACHIEVEMENT: 'Achievement',
            IN_WHICH_CLASS_GET: 'In which class did get it',
            ADD: 'Add Student',
            AGREMENT_DOCUMENT: 'Agreement',
            BROWSER: 'Students',
            CHANGE_STUDENT_CLASS:
                "Enrollment request will be performed. However, do you want the current/selected student's class information to change it?",
            CHANGE_STUDENT_STATUS:
                "Enrollment request will be performed. However, do you want the current/selected student's status information to change it?",
            CHOOSE_ACTION: 'Select Action',
            CLASS_TRANSFER_HINT: 'Select "{{item}}" if Student was transferred to another Class',
            CONFIRM: 'Confirm',
            ENROLLMENT: 'Enrollment',
            ENROLLMENTS: 'Enrollments',
            ENROLLMENT_TYPE: 'Enrollment Type',
            SCHOOL_ENTRY_DATE: 'School Entry Date',
            ENTRY_FROM: 'Entry From',
            ENTRY_HINT: 'Select "{{item}}" if Student was enrolled for the first time or returned to school',
            FILL_INFO: 'Fill Info',
            GRADUATED_HINT: 'Select "{{item}}" if Student has graduated from the school',
            IMPORT: 'Import Students',
            LEFT_HINT: 'Select "{{item}}" if Student has left the school',
            NEW: 'New Student',
            PRE_REGISTERED: 'Pre-Registered Students',
            STUDENT_LIST: 'Student List',
            TO_NEW: 'Add student to {{item}}',
            TRANSFER_HINT: 'Select "{{item}}" if Student was transferred to another School',
            EXCEL_TEMPLATE: 'Students Excel Template',
            SEND_SPECIAL_CODE: 'Send special code via e-mail',
            SEARCH_HINT:
                'Students can be searched by entering first name, middle name, last name, personal id or student id.',
            STUDYING_NOW: 'Study at School',
            STUDENTS_COUNT_BY_GRADE_LEVEL: 'Students by Grade',
            STUDENTS_COUNT: 'Student Count',
            GENERATE_STUDENT_ID: 'Generate Student ID',
            GENERATE_STUDENT_ID_FOR_ALL_STUDENTS: 'Generate Student ID for all students',
            REGENERATE_STUDENT_ID: 'Regenerate also for students who have a student ID',
            REPORT_PRE_SCHOOL_EDUCATION_HINT:
                'To receive information about student pre school education, you need to add an custom field to the student with the code {{param}}',
        },
        MESSAGE: {
            VERIFICATION_CODE_SENDED: 'Verification code sent to Student(s) email',
            COUNSELOR_REMOVE_CONFIRM: 'Are you sure do you want to cancel guidance counselor assign?',
            STUDENT_USERS_CREATING: "Please wait while creating students' user accounts",
            STUDENT_DATA_IMPORT: 'Please wait while importing students data',
            STUDENT_COURSE_ASSIGN: 'Please wait while assigning course(s) to students',
            NO_USER_INFO:
                'The student do not have a user account. To proceed you must create a user account for this student.',
            USER_CREATE_CONFIRM:
                'The student do not have a user account. Are you sure to create new user for the student?',
            STUDENT_IMPORT_DETAIL: 'Successfully imported: {{successCount}}, Not imported: {{errorCount}}',
            STUDENT_USER_ACCOUNT_REMOVED_SUCCESSFULLY: 'Student user account successfully removed',
            STUDENT_BULK_IMPORT: 'Are you sure to import {{count}} student(s)?',
            SELECT_CLASS: 'You have to select at least one class from list',
            SELECT_COURSE: 'You have to select at least one course from list',
            SPECIAL_CODE_DESCRIPTION: 'This code is needed so that a parent can add a student as their child',
            SPECIAL_CODE_INVALID: 'Special code you have entered is invalid! Please try again',
            GENERATE_STUDENT_ID_CONFIRMATION:
                "Are you sure you want to generate a student ID for all students who don't have one?",
            USER_CREATED: 'User created successfully',
            STUDENT_ID_GENERATED_LOADING: 'Please wait while creating the student IDs...',
            REGENERATE_STUDENT_ID_CONFIRMATION:
                'Are you sure you want to generate a Student ID for all students, if student already has an Student ID it will be regenerated',
            REPORT_NATIVE_LANGUAGE_HINT:
                "To receive information about student's native language, you need to add an custom field to the student with the code 'REPORT_NATIVE_LANGUAGE'",
            REPORT_FAMILY_COUNT_HINT:
                "To receive information about student's family composition, you need to add an custom field to the student with the code {{param}}",
            REPORT_FAMILY_CATEGORY_HINT:
                "To receive information about student's family category, you need to add an custom field to the student with the code {{param}}",
            ENROLLMENT_CONFIRM_TITLE: 'Enroll Student(s)?',
            DELETE_CONFIRMATION:
                "There are informations (assignment, course and class enrollment, attendance, grading etc.) about this student. That's why it couldn't be deleted. However, if you still want to continue the deletion process, it will be deleted all about this student informations. Are you sure you want to continue (delete)?",
        },
    },
    STUDENTS_ATTENDANCE: {
        TITLE: {
            ACTUAL: 'Actual',
            ATTENDED: 'Attended',
            ABSENT: 'Absent',
            PERMITTED: 'Permitted',
            EXCUSED: 'Excused',
            FULL_ABSENT: 'Absent - Full Day',
            SHOW_ABSENT: 'Show Absent',
            PLANNED: 'Planned',
            PRESENT: 'Present',
            TARDY: 'Tardy',
            YEAR: 'Year',
            TOTAL: 'Total',
            LESSONS: 'Lessons',
            PARTICIPATION_RATE: 'Participation Rate',
            SELECT_ATTENDANCE_CHART: 'Select Attendance Chart',
            SELECT_ATTENDANCE_TABLE: 'Select Attendance Report',
            START_TIME: 'Start Time',
            TEACHER: 'Teacher',
            COURSE: 'Course',
            TEACHER_NOTE: 'Note',
            MARK_FOR_MESSAGE: 'Unmark or mark to send message',
            MARKED: 'Marked?',
            NOT_TAKEN: 'Not Taken',
            TAKEN: 'Taken',
            LAST: 'Last {{item}}',
            TODAYS_COURSE_ATTENDANCE: "Today's Course Attendance",
            TODAYS_DAILY_ATTENDANCE: "Today's Daily Attendance",
            AVG_COURSE_ATTENDANCE: 'Average Course Attendance',
            AVG_DAILY_ATTENDANCE: 'Average Daily Attendance',
            DAILY_ATTENDANCE: 'Daily Attendance',
            COURSE_ATTENDANCE: 'Course Attendance',
            BULK_ATTENDANCE_CHANGE: 'Bulk Attendance Change',
            TOTAL_ABSENT: 'Total Absent',
            CHANGE_DAILY_ATTENDANCE: 'Change Daily Attendance',
            SHOW_ONLY_NOT_SAVED_CLASSS: 'Show only not taken classes',
            SWITCH_TO_DAILY_ATTENDANCE: 'Switch to Daily Attendance',
            SWITCH_TO_COURSE_ATTENDANCE: 'Switch to Course Attendance',
            SEE_PRESENT_STUDENTS: 'Click to see the list of present students in school today',
            SEE_ABSENT_STUDENTS: 'Click to see the list of absent students in school today',
            SEND_MESSAGE_TO_TEACHER: 'Send Message to Teacher(s)',
            SEND_MESSAGE_TO_REPRESENTATIVE: 'Send Message to Parent(s)',
            TEACHER_TAKE_ATTENDANCE:
                'Please, take the attendance for the course {{courseName}} on the Date {{date}} at Period {{periodName}}.',
            THE_STUDENT_ATTENDANCES: 'The Attendance of Student {{ fullName }} for the Date {{ date }}:',
            REMINDER: 'Teacher Reminder',
            ATTENDANCE_NOT_TAKEN_COURSES: "Teachers that didn't take attendance yet",
            ALL_ATTENDANCE_TAKEN: 'All teachers take attendance for all the courses',
            REMINDER_SUCCESSFULLY_SENT: 'Reminder Sent Successfully',
            FROM: 'From',
            APPLY_TO_ALL_TODAY_COURSES: 'Apply to all today`s course attendances',
            COURSE_ATTENDANCE_NOT_TAKEN:
                'One or more course attendances for the student have been not taken by the courses teacher !',
            ATTENDANCE_CALCULATION_HINT:
                'When the attendance grade is being calculated it will take the following coefficients for each attendance status.',
            DAILY_ATTENDANCE_PERMISSION_ERROR:
                'Daily attendance can take only by the attendance manager or head teacher',
            COURSE_ATTENDANCE_NOT_TAKEN_WARNING:
                'You did not complete to take the course attendance . Do you want to complete it?',
            COURSE_ATTENDANCE_STARTED_WARNING:
                'There are {{ count }} course events incompleted(STARTED) in active academic year. Please complete the course events by entering attendance information(end/complete).',
        },
    },
    STUDENTS_OF_CLASS: {
        MESSAGE: {
            AT_LEAST_ONE_STUDENT: 'Please select at least one student',
            TRANSFER_TO_SAME_CLASS:
                'Student(s) cannot be transferred/assigned to the same class. Make sure the classes are different',
            CREATE_USER_FIRST:
                'You have selected students with no user(s) account(s). Please, firstly create user(s) account(s) to the following students: {{param}}',
            SELECT_TARGET_CLASS: 'Please select target class',
            SELECT_CLASS: 'Please select class',
            ADD_STUDENT_SUCCESS: 'Student(s) added to selected class',
            REMOVE_STUDENT_SUCCESS: 'Student(s) removed from selected class',
        },
        TITLE: {
            AVAILABLE_STUDENTS: 'Available Students',
            BROWSER_WITH_PARAM: 'Accounts & ID Card {{param}}',
            CLASS_STUDENTS: 'Class Students',
            STUDENT_TRANSFER: 'Class Enrollment',
            COURSE_ASSIGN: 'Course Assign',
            COURSE_ENROLLMENT: 'Course Enrollment',
            PROGRAM_SERVICE: 'Program Enrollment',
        },
    },
    STUDENT_GROUP: {
        BUTTON: {
            CREATE_GROUP: 'Create Group',
            MANAGE_STUDENTS: 'Manage Students',
        },
        FIELD: {
            PUBLIC: 'Public',
            PRIVATE: 'Private',
            VISIBILITY_TO_STUDENT: 'Visibility to Student',
        },
        MESSAGE: {
            SELECT_GROUP: 'Please select group to add students',
        },
        TITLE: {
            STUDENT_GROUP: 'Student Groups',
            ASSIGNING_TO_GROUP: 'Assigning students to "{{param}}" group',
            GROUP_STUDENTS: 'Students of Group',
            STUDENT_ASSIGN: 'Assigning Students to Group',
        },
    },
    STUDENT_FEE: {
        BUTTON: {
            ADD_FEE: 'Add Fee',
            ADD_STUDENT_FEE: 'Add Student Fee',
            CANCEL_FEE: 'Cancel Fee',
            REFUND_PAYMENT: 'Refund Payment',
            REPORT: 'Report',
        },
        FIELD: {
            AMOUNT_TO_CANCEL: 'Cancel the Amount',
            BALANCE: 'Balance',
            CANCELLED_FEES: 'Cancelled Fees',
            CREDIT: 'Credit',
            DEBIT: 'Debit',
            PAY_FULL_AMOUNT: 'Pay full amount',
            SELECT_FROM_REPRESENTATIVES: 'Select from Parents',
            TOTAL_CANCELLED_FEE: 'Total Cancelled Fee',
            TOTAL_DEBT: 'Total Debt',
            TOTAL_REFUNDED: 'Total Refunded',
            TOTAL_REVENUE: 'Total Revenue',
            TRANSACTION_DETAILS: 'Transaction Details',
            TRANSFERRED_AMOUNT: 'Transferred Amount',
            TRANSFERRED_DEBT_AMOUNT: 'Transferred Debt Amount',
            TYPE: 'Type',
            WARNING: 'Warning!',
        },
        MESSAGE: {
            CONFIRM: {
                APPROVE_CANCEL: 'Do you want to cancel these amounts?',
                APPROVE_CONFIRMATION: 'Do you want to approve this Student Fee?',
                SAVE_CONFIRMATION: 'Do you want to save without Payment Plans? ',
                DELETE: 'Do you want to delete this Student Fee?',
                FEE: 'Student Fee',
                FEE_DATE: 'Fee Created Date',
                MERGE: 'Found already approved fee. Do you want to merge with it?',
                TOTAL: 'Total',
                CANCEL_REFUND: 'Are you sure that you want to cancel refund?',
            },
            ERROR: {
                ADD_FEE_TYPE: 'Please, first add fees to calculate payment calendar',
                FEE_EMPTY: 'Fee cannot be empty!',
                STUDENT_NOT_EXISTS: "Selected Student doesn't exists in selected Academic Period",
                TOTAL_INVALID: 'Refund Total you have entered is invalid! Please try again',
                TRANSFER_AMOUNT_MORE_THAN_TOTAL: 'Transferred Amount cannot be more than Grand total fee!',
            },
            SUCCESS: {
                CANCELLED: 'Amount successfully canceled',
                REFUNDED: 'Student payment successfully refunded',
            },
            WARNING: {
                DEBT: 'You have {{amount}} debt from other academic period. Would you like to transfer  them into this fee?',
                TRANSFER:
                    'You have  {{amount}} money from other completed student fees. Would you like to transfer  them into this fee?',
            },
            INFO: {
                HAS_NO_DEBT_TO_CANCEL: 'There is no debt to be canceled for this person.',
                HAS_NO_PAYMENT_TO_REFUND: 'There is no payments to be refunded for this person.',
            },
        },
        TITLE: {
            BALANCE: 'Balance',
            BROWSER: 'Student Fee',
            CANCEL_FEE: 'Cancel Fee',
            FEE_DETAIL: 'Fee Detail',
            FEE_DETAIL_EDIT: 'Fee Detail Edit',
            FEE_DISCOUNT_EDIT: 'Edit Discounts',
            NEW: 'New Student Fee',
            REFUND: 'Payment Refund for: {{name}}',
            REFUNDED_PAYMENTS: 'Refunds',
            STUDENTS_FEES: 'Students Fees',
            TOTAL_STUDENTS_FEES: 'Total Students Fees',
        },
    },
    STUDENT_PAYMENT_REPORT: {
        FIELD: {
            PAID_PERCENT: 'Paid (%)',
            TOTAL_PAID: 'Total Paid',
        },
        TITLE: {
            BROWSER: 'Student Payment Reports',
        },
    },
    SUBJECTS: {
        TITLE: {
            ADD: 'Add Subject',
            BROWSER: 'Subjects',
            EDIT: 'Subject',
            NEW: 'New Subject',
            SPEECH_LANGUAGE_HINT: 'Text To Speech',
            IMPORT_SUBJECTS: 'Import Subjects from Excel Sheet',
            TEMPLATE_FILENAME: 'subjects-excel-template',
        },
        FIELD: {
            SPEECH_LANGUAGE: 'Speech Language',
            SHOW_TO_ALL_SCHOOLS: 'Enable for only selected Schools',
        },
        MESSAGE: {
            NO_SUBJECTS_TO_IMPORT: 'There were not found any new subjects to import',
        },
    },
    SUBJECT_CATEGORIES: {
        TITLE: {
            ADD: 'Add Subject Category',
            BROWSER: 'Subject Categories',
            NEW: 'New Subject Category',
        },
    },
    STUDENT_PROGRAM: {
        TITLE: {
            NEW: 'New Program Service',
            EDIT: 'Program Service',
            PROGRAMS: 'Student Programs',
            ADD: 'Add New Program Service',
            SETTINGS: 'Program Service Settings',
            PARENT_HINT: 'This service will be added automatically.',
            NO_ENROLLED_PROGRAMS: 'There is no program enrolled for the student',
        },
        FIELD: {
            CATEGORY: 'Category',
            PARENT: 'Parent Program Service',
            NAME: 'Service Name',
            USE_ONLY_ONE_TIME: 'Service can only be used once for a student.',
            CHILD_ONLY_USE_ONE_TIME: 'Only one of the services in this category can be used for a student.',
            AVAILABLE_SERVICES: 'Available Services',
            MIN_AVAILABLE_SERVICES: 'Min. Available Services',
            REQUIRED_SERVICES: 'Required Services',
            EXCLUDED_SERVICES: 'Excluded Services',
            BEDS_CODE_REQUIRED: 'BEDS Code Required',
            BEDS_CODE: 'Beds Code',
            ENTRY_CODE_REQUIRED: 'Entry Reason Code Required',
            EXIT_CODE_REQUIRED: 'Exit Reason Code Required',
            INTENSITY_REQUIRED: 'Program Intensity Required',
            PROVIDER_REQUIRED: 'Program Provider Required',
            ENTRY_CODE1: 'Entry Reason 1',
            ENTRY_CODE2: 'Entry Reason 2',
            ENTRY_CODE3: 'Entry Reason 3',
            EXIT_CODE1: 'Exit Reason 1',
            EXIT_CODE2: 'Exit Reason 2',
            EXIT_CODE3: 'Exit Reason 3',
            INTENSITY: 'Program Intensity',
            PROVIDER: 'Program Provider',
        },
        MESSAGE: {
            PROGRAM_OVERRIDE: 'If a program has been entered before, change it.',
            PROGRAM_APPROVE_CONFIRM:
                'Newly added program services will be added, and old services will be updated. Are you sure?',
        },
    },
    SUBJECT_CURRICULUM: {
        TITLE: {
            FORM: 'Subject Curriculums',
            SELECT: 'Select a curriculum to edit or create a new one..',
            ALLOWED_SCHOOLS_NOT_SELECTED: 'By default, all schools are allowed to import this curriculum',
            CURRICULUM_EXCEL_TEMPLATE: 'Curriculum excel template',
            DOWNLOAD_CURRICULUM_EXCEL_TEMPLATE: 'Download Curriculum Excel Template',
            UPLOAD_CURRICULUM_EXCEL_TEMPLATE: 'Import from Curriculum Excel Template',
            EXPORT_CURRICULUM_EXCEL: 'Export curriculum as excel',
        },
        FIELD: {
            PARENT_CURRICULUM: 'Parent Curriculum',
            ALLOWED_SCHOOLS: 'Schools allowed to import this curriculum',
        },
    },
    SURVEYS: {
        TITLE: {
            BROWSER: 'My Surveys',
            NEW: 'New Survey',
            EDIT: 'Survey',
            PREVIEW: 'Survey Preview',
            ANONYMOUS_SUBMISSIONS: 'Anonymous Submissions',
            ANONYMOUS: 'Anonymous',
            SURVEY_ENDED: 'Survey Submitted',
            SURVEY_SUBMISSIONS: 'Survey Submissions',
            SURVEY_SUBMISSION: 'Survey Submission',
            SUBMISSIONS: 'Submissions',
            STATISTICS: 'Statistics',
            NUMBER_SUBMISSIONS: 'Number of submissions: {{number}}',
            ANSWERED: 'Answered',
            EMPTY: 'Not Answered',
            PRIVACY: 'Privacy',
        },
        MESSAGE: {
            SUBMIT_CONFIRM: 'Do you want to submit and end survey?',
            RESUBMIT_ERROR: 'You cannot resubmit a submitted survey',
        },
    },
    TEACHERS: {
        TITLE: {
            BROWSER: 'Teachers',
            ADD: 'Add Teacher',
            EDIT: 'Teacher',
            NEW: 'New Teacher',
            DOWNLOAD_TEMPLATE: 'Download Excel Template',
            IMPORT_TEACHERS: 'Import Teachers from Excel Sheet',
            TEMPLATE_FILENAME: 'teachers-excel-template',
        },
        MESSAGE: {
            NO_TEACHERS_TO_IMPORT: 'There were not found any new teachers to import',
        },
    },
    TERM_GRADE: {
        BUTTON: {
            ADJUST: 'Adjust',
        },
        FIELD: {
            AVERAGE: 'Average',
            BY_HIGHEST_GRADE: 'By Highest Grade',
            CURVE_TYPES: 'Curve Types',
            FINAL: 'Final',
            FOR_PERIOD: 'For Period',
            INCREASE_BY: 'Increase by',
            MEAN: 'Mean',
            PERCENT: 'Percent',
            RECALC_BY_OLD_TEMPLATE: 'Recalculate by old template',
            STANDARD_DEVIATION: 'Standard Deviation',
            TOTAL_OUT_OF_GRADE_MAX: 'Total (out of Maximum Grade)',
            WEIGHT_FROM_TOTAL: 'Weight from Total',
            ATTENDANCE_WEIGHT_ENABLE: 'Enable Attendance Weight',
        },
        MESSAGE: {
            CALCULATE_CONFIRMATION:
                'Do you want to calculate term grades? While calculating grades all applied changes will be discarded and will be changed to new calculated grades',
            CALCULATED_SUCCESS: 'Course term grades successfully calculated',
            FINAL_CALCULATED_SUCCESS: 'Course final grades successfully calculated',
            GRADE_NOTE_SAVED_SUCCESS: 'Note successfully saved',
            RECALC_BY_OLD_TEMPLATE:
                "Recalculation will be performed according to the last calculation's template, if you calculated this period earlier. If you calculate for the first time, you can ignore this.",
            SAVE_CONFIRMATION: 'Do you want to save applied changes?',
            SAVED_SUCCESS: 'Course term grades successfully saved',
            SUM_OF_PERCENT_VALIDATION: 'Sum of percent must not be bigger than 100',
            WILL_BE_GRADED_ON_NEXT_QUARTER: 'This course will be term graded on next quarter',
        },
        TITLE: {
            ADJUST_TOTALS: 'Adjust Totals',
            COMPUTED_GRADE: 'Computed',
            CONFIRM_CALCULATION: 'Confirm to Calculate',
            TERM_GRADE: 'Calculate Term Grade at',
            FINAL_GRADE: 'Final',
            QUARTER_DESCRIPTION: 'Detail',
            FINAL_DESCRIPTION: 'Summary',
            YEAR_FINAL_GRADE: 'Year Final',
            SELECT_STUDENT_GRADES_CHART: 'Student Grades Chart',
            STUDENT_OVERALL_GRADES: 'Student Overall Grades',
            GRADES_YEARLY_TREND: 'Grades Yearly Trend',
            TERM_GRADE_CHANGE_TO: 'Term Grades Change To',
            TERM_GRADE_CHANGE_NOTES:
                'All grades with a selected term grades below {{point}} will be changed to {{point}}. This process cannot be undone.',
        },
    },
    TEXT_TO_SPEECH_VOICE: {
        TITLE: {
            ADD: 'Add Text to Speech Voice',
            UPDATE: 'Update Text to Speech Voice',
            NEW: 'New Text to Speech Voice',
        },
    },
    TIME_PERIOD: {
        TITLE: {
            COURSE_EVENT_LENGTH_HINT: '1 week = 7 days. For example, 8 April + 1 week = 15 April',
            INFO: 'Info',
            NEW_PERIOD: 'New Period',
            NEW_TIME_PERIOD: 'New Time Period',
            PERIODS: 'Periods',
            PERIOD: 'Period',
            TIME_PERIOD: 'Time Period',
        },
        FIELD: {
            SHORT_NAME: 'Short Name',
            ACADEMIC_PERIOD_TYPE: 'Academic Period Type',
            ACADEMIC_YEAR: 'Academic Year',
            ACADEMIC_YEAR_SHORT: 'Academic Year',
            ACADEMIC_SEMESTER: 'Semester',
            ACADEMIC_QUARTER: 'Quarter',
            LENGTH: 'Length (minutes)',
            USED_FOR_ATTENDANCE: 'Used for Attendance',
            IGNORE_SCHEDULING: 'Ignore for Scheduling',
            ORDER: 'Order',
            WORKING_DAYS: 'Working Days',
            COPY_FROM: 'Copy from Time Period',
            HIDE_EMPTY_PERIODS: 'Hide Empty Periods on Timetable',
        },
        MESSAGE: {
            DATE_RANGE_OF_PERIOD: 'Date range must be between {{startDate}} and {{endDate}}',
            ADD_PERIOD: 'Empty periods not allowed. Add period',
            ORDER_EXISTS: 'Duplicate order found. Change order',
            SELECT_WORKING_DAYS: 'Select working days',
            ACTIVE_PERIOD_NOT_FOUND: 'There is no active time period',
            COURSE_EVENT_NOT_FOUND: 'There are no course events for this week',
        },
    },
    TIME_SHEET_MONTHLY: {
        FIELD: {
            ACTUAL_MONTHLY_WORK_HOURS: 'Actual Monthly Work Hours',
            PLANNED_MONTHLY_WORK_HOURS: 'Planned Monthly Work Hours',
            WORKING_TIME_BALANCE: 'Working Time Balance',
        },
        MESSAGE: {
            CONFIRM: {
                APPROVE: 'Do you want to approve these monthly hourly timesheet plans?',
                DELETE: 'Do you want to delete these monthly hourly timesheet plans?',
            },
            SUCCESS: {
                CALCULATED: 'Monthly Hourly Timesheet successfully calculated',
                DELETED: 'Monthly Hourly Timesheet successfully deleted',
            },
        },
        TITLE: {
            BROWSER: 'Monthly Hourly Timesheet',
        },
    },
    TIME_SHEET_MULTIPLIER: {
        FIELD: {
            TURNOUT: 'Turnout',
        },
        TITLE: {
            ADD_BUTTON: 'Add Notation Key',
            BROWSER: 'Timesheet Notation Keys',
            EDIT: 'Notation Key',
            NEW: 'New Notation Key',
        },
    },
    TOOLBAR: {
        MENU_ITEMS: {
            CHANGE_PASSWORD: 'Change Password',
            LANGUAGE: 'Language',
            PROFILE: 'Profile',
            SETTINGS: 'Settings',
            SYSTEM_MANAGEMENT: 'System Management',
            SCHOOLS: 'Schools',
            SIGN_OUT: 'Sign Out',
            TENANTS: 'Change Tenant',
            ENABLE_WEB_PUSH: 'Enable Notifications',
            DISABLE_WEB_PUSH: 'Disable Notifications',
            ADD_STUDENT: 'Add Child',
            SELECT_CHILD: 'Select Child',
            MANAGE_CHILDS: 'Manage Children',
            HEAD_TEACHER_DASHBOARD: 'Head Teacher Dashboard',
            INCIDENT_MANAGER_DASHBOARD: 'Incident Dashboard',
            HEALTH_MANAGER_DASHBOARD: 'Health Man.Dashboard',
            COUNSELOR_DASHBOARD: 'Counselor Dashboard',
        },
    },
    TIMETABLE_COURSES: {
        TITLE: {
            ADD_LESSON: 'Add Lesson',
            LESSON: 'Lesson',
            LESSONS: 'Lessons',
            CLASSES: 'Classes',
            ADD_CLASS: 'Add Class',
            GROUP: 'Group',
            DIVISION: 'Division',
            REMOVE_CLASS: 'Remove Class',
            TOTAL_LESSONS_PER_WEEK: 'Total Lessons per Week',
            MAX_LESSONS_PER_DAY: 'Max. Lessons per Day',
            IMPORT_COURSES: 'Import Courses',
            IMPORT_COURSES_FROM_CAMPUS: 'Import Courses from SIS',
            IMPORT_COURSES_FROM_EXCEL: 'Import Courses from Excel Sheet',
            TEMPLATE_FILENAME: 'courses-excel-template',
            PARALLEL_COURSES: 'Parallel courses',
        },
        MESSAGE: {
            EMPTY_LESSONS: 'Lessons cannot be empty. Please add a new lesson',
            SELECT_CLASS: 'Please, select the first class',
            SAME_WEEK_PLAN: 'For joint course classes should be in same week plan',
            JOINT_CLASS: 'joint class',
        },
        TOOLTIP: {
            ADD_JOINT: 'Add Joint Class',
        },
    },
    TIMETABLE_PANEL: {
        TITLE: {
            APPLY_WITH_CONFLICTS: 'Apply with conflicts',
            CLEAR_CONFLICTS: 'Clear conflicts',
            CONFLICTS: 'Conflicts',
            FROM: 'From',
            PANEL: 'Panel',
            UNASSIGNED_LESSONS: 'Unassigned Lessons',
            LESSON: 'Lesson',
            LESSON_DETAILS: 'Lesson Details',
            LESSON_RELOCATION: 'Lesson Relocation',
            PROBLEMS: 'Problems',
            RELOCATE: 'Relocate',
            TO: 'To',
            BEFORE_CHANGE: 'Before Change',
            AFTER_CHANGE: 'After Change',
        },
        MESSAGE: {
            CONFIRM_APPLY_CONFLICTS: 'Are you sure to apply?',
            CONFIRM_CLEAR_CONFLICTS:
                'Are you sure to clear conflicts? Conflicted lessons will be moved to the unassigned list.',
            LESSON_UPDATED: 'Lesson successfully updated',
            LESSON_UPDATED_FAILURE: "The lesson couldn't be updated. Please, refresh the panel",
            TEACHER_TIME_CONFLICT:
                'Teacher {{teacher}} has the following conflicted lessons at this period: {{lessons}}',
            CLASS_TIME_CONFLICT: 'Class {{class}} has the following conflicted lessons at this period: {{lessons}}',
            ROOM_TIME_CONFLICT: 'Room {{room}} has the following conflicted lessons at this period: {{lessons}}',
            TEACHER_UNAVAILABLE: 'The teacher has time availability restrictions for the given period.',
            CLASS_UNAVAILABLE: 'The class has time availability restrictions for the given period.',
            ROOM_UNAVAILABLE_BY_TIME: 'The room has time availability restrictions for the given period.',
            ROOM_NOT_IN_AVAILABLES: 'The lesson should be held in the following rooms: {{classrooms}}',
            ROOMS_NOT_PROVIDED: 'No rooms have been assigned for this course.',
            COURSE_UNAVAILABLE: 'The course has time availability restrictions for the given period.',
        },
    },
    TIMETABLE_PROJECTS: {
        TITLE: {
            BROWSER: 'Projects',
            ADD: 'Add Project',
            EDIT: 'Project',
            NEW: 'New Project',
            CONSTRAINT_WEIGHTS: 'Constraint Weights',
            CLASS_DAILY_LESSON_GAPS: 'There are no gaps between the lessons in one day',
            DAILY_LESSONS_MIN_COUNT: 'Classes have at least minimum number of lessons in one day',
            PARALLEL_COURSE_LESSONS: 'Paired lessons are held in parallel',
        },
        MESSAGE: {
            EMPTY_PERIODS: 'Periods cannot be empty',
            EMPTY_WEEK_DAYS: 'Week days cannot be empty',
            CONFLICT_WEEK_PLANS: 'Some week plans have conflicts: {{item}}',
            CONFLICT_WEEK_PLAN: 'Week plan has conflicts',
            IMPORT_FROM_CAMPUS_CONFIRMATION: 'Do you want to import from SIS?',
        },
        CONTRIBUTORS: 'Contributors',
    },
    TIMETABLE_REPORT: {
        TITLE: {
            BROWSER: 'Timetable Report',
        },
    },
    TIMETABLE_SELECTION: {
        TITLE: {
            AVAILABLE: 'Available',
            HOME_ROME_CLASSES: 'Classes Location',
            HOME_ROME_SUBJECTS: 'Subjects Location',
            HOME_ROME_TEACHERS: 'Teachers Location',
            MORE_ROOMS: 'More Location',
            ROOMS: 'Locations',
            SELECTED: 'Selected',
            SELECT_CLASSES: 'Select Classes',
            SELECT_ROOMS: 'Select Locations',
            SELECT_SUBJECTS: 'Select Subjects',
            SELECT_TEACHERS: 'Select Teachers',
            SHARED: 'Shared',
        },
        MESSAGE: {
            CONFIRM_CLEAR_TEACHERS: 'Do you want to clear the selected list of teachers?',
            CONFIRM_CLEAR_SUBJECTS: 'Do you want to clear the selected list of subjects?',
            CONFIRM_CLEAR_CLASSES: 'Do you want to clear the selected list of classes?',
            CONFIRM_CLEAR_ROOMS: 'Do you want to clear the selected list of locations?',
            SELECT_ROOMS: 'Please, select locations.',
            NO_ROOMS_SELECTED: 'No locations have been selected',
            NO_DIVISIONS_SELECTED: 'No divisions have been selected',
            ASSIGN_ONLY_TO_SPECIFIC_ROOMS: 'Only assign lessons to these specific locations',
        },
    },
    TRANSCRIPT: {
        FIELD: {
            BY_PERIOD: 'By Period',
            BY_YEAR: 'By Year',
            SHOW_NOTES: 'Show Notes',
            SHOW_SUBJECTS: 'Show Subjects',
            SHOW_TEACHERS: 'Show Teachers',
            SHOW_CREDITS: 'Show Credit',
            SHOW_PARENT_BLOCK: 'Show Parent Block',
            SHOW_AUTORIZATION_BLOCK: 'Show Authorization Block',
            AUTORIZATION_BLOCK_ORIENTATION: {
                TITLE: 'Align to',
                LEFT: 'Left',
                RIGHT: 'Right',
                CENTER: 'Center',
            },
            TITLE_ORIENTATION: {
                CAPTION: 'Place',
                ABOVE: 'Above Signature',
                BELOW: 'Below Signature',
            },
            HIDE_FINAL_GRADE: 'Hide Final Grade',
            DISPLAY_SCHEME_BLOCK: 'Display Grading Scheme',
            DISPLAY_ATTENDANCE_BLOCK: 'Display Attendance',
            PAGE_SETTINGS: 'Page Settings',
            PAGE_VIEW: {
                TITLE: 'Orientation',
                LANDSCAPE: 'Landscape',
                PORTRAIT: 'Portrait',
            },
            GRADE_TABLE_OPTIONS: {
                TITLE: 'Grade Table Settings',
                USE_ABBREVIATION: 'Use short names for grade categories and academic periods',
                FONT_SIZE: 'Font Size',
                SIZE_GROUP: 'Size',
            },
            GRADE_DISPLAY_OPTIONS: {
                LABEL: 'Display Grade as',
                ONLY_POINT: 'Percentage',
                ONLY_LABEL: 'Name',
                BOTH: 'Both (Percentage + Name)',
            },
            SHOW_TEST_RESULTS: 'Show Test results',
            SHOW_AWARDS_AND_HONORS: 'Show Awards and Honors',
            SHOW_RANK: 'Show Rank',
            SHOW_COUNSELOR: 'Show Counselor',
            COUNSELOR: 'Counselor',
            NUMERIC_GRADE: 'Numeric grade (percentage)',
            POINTS: 'Points',
        },
        MESSAGE: {
            REPORT_CARDS_ARE_BEING_GENERATED: 'Please wait for report cards to be generated...',
            TRANSCRIPTS_ARE_BEING_GENERATED: 'Please wait while the transcripts are being generated...',
            REPORT_CARDS_PREVIEW_DATA_IS_BEING_GENERATED: 'Report card preview data is being generated',
            REPORT_CARDS_GENERATED: '{{param}} report cards successfully generated',
            REPORT_CARDS_NOT_GENERATED: 'Report card could not be generated',
            TRANSCRIPTS_GENERATED: '{{param}} transcripts successfully generated',
            TRANSCRIPTS_NOT_GENERATED: 'Transcript could not be generated',
            DOWNLOAD_FILENAME: 'Transcript {{param}}',
            PREPARING: 'Preparing...',
        },
        TITLE: {
            TRANSCRIPT_SETTINGS: 'Transcript Settings',
            CREATE_REPORT: 'Create Transcript',
            SEND_EMAIL: 'Sent via E-Mail',
            PREVIEW: 'Preview',
            DISPLAY_GPA: 'Display GPA as',
            GENERATE_TRANSCRIPT: 'Generate Transcript',
        },
    },
    TRIAL: {
        TITLE: {
            BROWSER: 'Trials',
            NEW: 'New Trial',
            EDIT: 'Trial',
            GENERATE: 'Generate',
            TERMINATE: 'Terminate',
            TIMETABLES: 'Timetables',
            HIDE_EMPTY_PERIODS: 'Hide Empty Periods',
            SYNC: 'Sync',
        },
        MESSAGE: {
            SYNC_SUCCESS: 'Trial has successfully synced',
            SYNC_CONFIRM: 'Do you want to sync with the project?',
        },
    },
    USER_PROFILE: {
        ACTIVE_SCHOOL: 'Active School',
        PROFILE: 'Profile',
        USER_NAME: 'Username',
        THIRD_PARTY_CONNECTION: {
            REVOKE_ACCESS: 'Revoke Access',
            ENABLE_ACCESS: 'Enable Access',
            PERMISSIONS: 'Permissions: {{item}}',
            READ_ONLY: 'Read Only',
            VIEW_AND_CREATE_CALENDAR_EVENTS: 'View and create calendar events',
            VIEW_AND_CREATE_CLASSROOM: 'View and create Google Classroom courses, assignments, grading',
            LOGIN: 'Login',
        },
        PASSWORD_INVALID: 'The password you have entered is incorrect! Please try again',
        PASSWORD_CHANGED: 'User password has changed successfully!',
        ENABLE_CONFIRMATION: 'Are you sure to enable access to Campus with your {{item}} account?',
        DISABLE_CONFIRMATION: 'Are you sure to disable access to Campus with your {{item}} account?',
    },
    WEBCAM: {
        TITLE: {
            DIALOG: 'Camera',
        },
    },
    WEEK_PLAN: {
        TITLE: {
            BROWSER: 'Week Plans',
            NEW: 'Week Plan',
        },
        MESSAGE: {
            TIME_CONFLICT: 'This period conflicts with another period: ',
            POSITIVE_DURATION: 'Period has to have positive duration',
        },
        FIELD: {
            CLASSES_COMMENT: 'Unchecked classes are assigned to the first week plan by default',
            LESSON_DURATION: 'Lesson Duration (minutes)',
            BELL_DURATION: 'Bell Duration (minutes)',
            DEFAULT_NAME: 'Default Week Plan',
            NAME_PLACEHOLDER: 'Week Plan Name',
            CONFLICTS: 'Conflicts',
            ADD_PERIOD: 'Add new Period',
            REMOVE_PERIOD: 'Remove The Last Period',
            SELECTED_CLASSES: 'Selected Classes: ',
            ADD_BREAK: 'Add Break',
            BREAK: 'Break',
            USE_MULTI: 'Use Multiple Week Plans',
        },
    },
    WORK_CALENDAR: {
        MESSAGE: {
            ERROR: {
                WORK_CALENDAR_NOT_FOUND: 'Work Calendar not found',
            },
            WEEKLY_WORKING_TIME: 'Weekly working time',
        },
        TITLE: {
            ADD: 'Add Work Calendar',
            BROWSER: 'Work Calendars',
            FORM: 'Work Calendar',
            NEW: 'New Work Calendar',
        },
    },
    TIME_TABLE: {
        TITLE: {
            NAME: 'Timetable',
            NEW_TIME_TABLE: 'New Timetable',
            ADD_NEW_TIME_TABLE: 'Add New Timetable',
            TIME_TABLE_WITH_PARAM: 'Timetable - {{param}}',
        },
        FIELD: {
            CHANGE_LOCATION_FOR_ALL: 'Apply this location for other schedules',
            SHOW_ONLY_EMPTY: 'Show only empty courses(*)',
            FIXED_DATE_RANGE: 'Fixed with Academic Period Date Range',
            CHANGE_LOCATION: 'Change Location',
            SELECT_ALL_COURSES: 'Select All Courses',
            DELETE_ARCHIVED_COURSES: 'Only Archived Courses',
            DELETE_COURSE_PROGRESS: 'Delete course progresses if exists',
            CHECK_CONFLICTS: 'Check Conflicts',
            SHOW_ALL_TEACHERS: 'Show All Teachers',
            CONFLICTED_PERIOD_COUNT: 'Conflicted Period Count',
            CHANGE_WITH: 'Change With',
            PERIOD_SHORT_NAME: 'Period Short Name',
            COURSE_TIME_PERIOD_CONFLICT: 'Course Time Period Conflict',
            TRANSFER_DATE: 'Transfer Date',
            DAYS: 'Days',
            START_FROM: 'Start From',
        },
        MESSAGE: {
            CLEAR: 'Do you want to clear schedule for course: "{{item}}"? Changes will not applied until you save it.',
            CLEAR_ALL:
                'Do you want to clear schedules for all courses? Changes will be saved and you can not restore them!',
            CONFLICTED_COURSES: 'There are conflicts in {{count}} courses.',
            COURSE_WITH_NAME: 'Course "{{item}}" ',
            NO_CONFLICTED_COURSES: 'Congratulations! There is no conflict in courses.',
            SELECT_COURSE: 'Select Course',
            DELETE: 'Do you want to delete completely all course events (events, attendance records, meetings) in this period?',
            SCHEDULE_CLEARED: 'All Schedules cleared successfully!',
            SAVE_WITH_CONFLICTS:
                'You have some conflicting schedules with other schedules. Do you want to save this schedule anyway?',
            SUCCESSFULLY_IMPORTED: 'Successfully imported courses count: {{count}}',
            SELECTED_COURSE_HAS_CONFLICT: 'Selected course has period conflicts with current courses.',
            NEW_PERIOD_COURSE_CONFLICT: '{{name}} has conflict on {{period}}: {{courseNames}}',
        },
        BROWSER: 'Timetables',
        BROWSER_WITH_PARAM: 'Timetable - {{param}}',
    },
    USER_MESSAGES: {
        TITLE: {
            NAME: 'Message',
            NEW: 'New Message',
            FROM_USER: 'From',
            TO_USER: 'To',
            SENT_TIME: 'Sent Time',
            ADD_SUBSCRIBER: 'Choose message receiver',
            SUBJECT: 'Subject',
            RECEIVERS: 'Receivers',
            SEND_VIA_EMAIL: 'Send via E-mail',
            REPLY: 'Reply',
            INBOX: 'Inbox',
            OUTBOX: 'Outbox',
            TRASH: 'Trash',
            MOVE_TO_TRASH: 'Move to Trash',
            MESSAGE: 'Message',
            WHOM: 'Whom',
            NEW_MESSAGE: 'New Message',
            SEND_MESSAGE: 'Send Message',
            SEND_REMINDER: 'Send Reminder',
            RESTORE: 'Restore',
            WRITE_NEW_MESSAGE: 'Write New Message',
        },
        BUTTONS: {
            RECEIVER: 'Add Receiver(s)',
            ADD_ROLE: 'Role',
            ADD_CLASS: 'Class',
            ADD_COURSE: 'Course',
            ADD_USER: 'Users',
            SEND: 'Send',
        },
        ERROR: {
            SUBSCRIBER_EMPTY: 'Message receivers are empty',
        },
        MESSAGE: {
            MOVE_MESSAGE_TO_TRASH:
                'Do you want to move this message to trash? All replied messages also will be moved!',
            MOVE_MESSAGES_TO_TRASH:
                'Do you want to move these messages to trash? All replied messages also will be moved!',
            RESTORE_MESSAGE_FROM_TRASH:
                'Do you want to restore this message from trash? All replied messages also will be moved!',
            RESTORE_MESSAGES_FROM_TRASH:
                'Do you want to restore these messages from trash? All replied messages also will be moved!',
            SUCCESSFULLY_MOVED_TO_TRASH: '{{item}} successfully moved to trash!',
            SUCCESSFULLY_RESTORED_FROM_TRASH: '{{item}} successfully restored from trash',
            SUCCESSFULLY_SENT: 'Message Successfully sent',
            YOU_HAVE_MESSAGE: 'You have a new message !',
        },
    },
    USER_SELECT: {
        TITLE: {
            NAME: 'User Select or Create a New Account',
        },
    },
    TENANT_SELECT: {
        TITLE: {
            NAME: 'Select Tenant',
        },
    },
    ACADEMIC_CALENDAR: {
        TITLE: {
            DAY_INFO: 'Day information ({{item}})',
            FORM: 'Academic Calendar',
            WORK_DAYS: 'Work Days',
            HAVE_LESSONS: 'Have Lessons',
            DEFAULT_CODE_ASSIGNMENT: 'Default Code Assignment',
            EXCLUDE_WEEKEND: 'Exclude weekends',
        },
        MESSAGE: {
            HOLIDAY_EVENTS: 'There are events during the holidays. You can transfer, delete or leave them',
            UNAVAILABLE_DATE: 'Date not available, you can choose another free date',
        },
    },
    IMPORTED_DATA: {
        TITLE: 'Imported Data',
        MANAGEMENT: 'Imported Data Management',
        USER_TITLE: 'Imported Users',
    },
    MY_PAGE: {
        TAB_TITLE: {
            STUDENT_INFO: 'Info',
            DISCUSSIONS: 'Discussions',
            ASSIGNMENTS: 'Assignments',
        },
        FIELDS: {
            ASSIGNMENT_DISCUSSIONS: 'Latest assignment discussions',
            SELECT_ASSIGNMENT_FOR_DISCUSSIONS: 'Select assignment to see discussions',
            NO_DISCUSSIONS_YET: 'No assignment discussions yet',
        },
        TITLE: {
            VIEW: 'View',
            PANEL_VIEW: 'Panel View',
            TIMETABLE_VIEW: 'Timetable View',
        },
    },
    QUESTION_BANK: {
        PAGE_TITLE: {
            QUESTIONS: 'Questions',
            IMPORT_QUESTIONS: 'Import Questions',
        },
        BUTTON: {
            DOWNLOAD_TEMPLATE: 'Download Template',
            IMPORT_QUESTIONS: 'Upload File',
            SAVE: 'Save Questions',
        },
        TITLE: {
            NEW_QUESTION: 'New Question',
            ADD_ANSWER: 'Add Answer',
            SELECT_CORRECT_ANSWER: 'Select Correct Answer',
            ADD_OPTION: 'Add Option',
            SELECT_ANSWER: 'Please, select Answer for the Question',
            FROM_QUESTION_BANK: 'Select Questions from Question Bank',
            QUESTIONS_FOR_QUIZ: 'Select Questions for Quiz',
            QUIZ_ENDED: 'Quiz finished',
            WRITE_ANSWER_HERE: 'Write your answer here...',
            START_QUIZ: 'Start Quiz',
            CONTINUE_QUIZ: 'Continue Quiz',
            QUIZ_RESULT: 'Quiz Result',
            START: 'Start',
            CONTINUE: 'Continue',
            POINT: 'Point Out of {{item}} ',
            MATCHING_DESCRIPTION:
                'You must provide at least two questions and three answers. You can provide extra wrong answers by giving an answer with a blank question. Entries where both the question and the answer are blank will be ignored.',
            DRAG_AND_DROP_INTO_TEXT_DESC:
                "In the content above use double square brackets '[[n]]' with a number in place of the word you wish the exam-taker to find",
            SELECT_ONE_DESC:
                "In the content above use double square brackets '[[1]]' in place of the word you wish the exam-taker to find. It must be used exactly once",
            QUIZ_REVIEW: 'Quiz Review',
            WRITE_FEEDBACK: 'Write Comment',
            TEACHER_COMMENT: 'Teacher Comment:',
            SHARE_WITH_QUESTION: 'Share this question',
            SHARED_QUESTIONS: 'Shared questions',
            ANSWER_REQUIRED: 'The Answer is Required',
            EDITABLE_BY: 'Editable by',
            HAVE_TO_BE_REVIEWED_BY_TEACHER: 'Some questions have to be reviewed by teacher*',
            NOT_POINTED_YET: 'Not reviewed yet',
            SHOW_ANSWERS: 'Show answers after finishing quiz',
            SHOW_RESULT: 'Show result(grading) after finishing quiz',
            CHOOSE_NUMBER_OF_ANSWERS: 'Choose the {{item}} correct answers*',
            RATE: 'Rate',
            SHOW_CORRECT_ANSWERS: 'Show Correct Answers',
            REATTEMPT_QUIZ: 'Reattempt',
            QUIZ_NAVIGATION: 'Quiz Navigation',
            TOTAL_QUESTIONS: 'Total Questions:',
            NOT_VIEWED: 'Not Viewed',
            VIEWED: 'Viewed',
            ANSWERED: 'Answered',
            MARKED: 'Marked',
            MARK_QUESTION: 'Mark the Question to Review',
            COLUMN_COUNT_HINT: 'Number of Option Columns',
            ADD_EXPLANATION: 'Add Answer Explanation',
            EXCEL_TEMPLATE: 'Question List',
            INSTRUCTIONS: 'Instruction and Requirements',
            QUESTIONS_TO_IMPORT: 'Questions to Import',
            NO_QUESTIONS: 'No questions yet to import. Upload file with questions for importing questions',
        },
        FIELD: {
            QUESTION_DIFFICULTY_LEVEL: 'Difficulty Level',
            RANDOM_GENERATE: 'Randomly Generate Quiz',
            DIFFERENT_QUESTIONS: 'Different Questions to Everyone',
            QUESTION: 'Question',
            LABEL: 'Label',
            ANSWER: 'Answer',
            ANSWERS: 'Answers',
            QUESTION_CONTENT: 'Question',
            AUDIO_QUESTION_CONTENT: 'Audio',
            CHOOSE_TYPE_QUESTION: 'Choose Type of Question',
            DIFFICULTY_LEVEL_HINT: 'Difficulty of question; smaller easier, greater harder, e.g. 1 is Easy',
            LABEL_HINT: "Label is used for quick search, it's not visible to Student",
            MULTIPLE_CHOICE_QUESTION_TYPE: 'One or Multiple Answers',
            CHOICE_NUMBERING: 'Number the Choices',
            GRADE: 'Grade (%)',
            RIGHT_ANSWER: 'Right Answer',
            OPTION_NO: 'Option {{item}}',
            OPTION: 'Option',
            GROUP: 'Group',
            CHOICE: 'Choice [[{{item}}]]',
            PAGE: 'Page',
            QUESTION_PER_PAGE: 'Questions per Page',
            QUESTION_SIZE: 'Question Size',
            NEXT: 'Next',
            PREVIOUSE: 'Prev',
            RATING: 'Rating',
            RATING_BIGGER_THAN: 'Rating Bigger Than',
            RATING_SMALLER_THAN: 'Rating Smaller Than',
            SHUFFLE_QUESTIONS: 'Shuffle Questions',
            SHUFFLE_OPTIONS: 'Shuffle Options',
            NOT_USED_QUESTIONS: 'Not used Questions',
            HORIZONTAL_VIEW: 'Horizontal View',
            INTENT: 'Question Intent',
            CANCELED: 'Canceled',
            CANCEL: 'Cancel',
            ADD_QUESTION: 'Add Question',
            ANSWER_WIDTH: 'Answer Width in Pixel',
            ANSWER_EXPLANATION: 'Answer Explanation',
        },
        MESSAGE: {
            AT_LEAST_TWO_QUESTION: 'Please, add at least two questions!',
            ADD_TWO_QUESTION: 'Add at least two questions and all questions type must be the same!',
            TYPE_CAN_NOT_BE_DIFFERENT:
                "The type of all the questions must be the same! Your previous type is '{{type}}'",
            SELECT_SUBJECT: 'Please, select a subject first!',
            BY_DEFAULT_VERTICAL_VIEW: 'By Default it shown in vertical view',
            RANKING_ANSWER_WARNING:
                'Write options in the correct order. When you share the quiz, options will appear in random order!',
            QUESTION_NOT_RATED: "You didn't rate this question yet!",
            QUESTION_REVIEWS_SIZE: 'based on {{size}} reviews',
            CANCEL_QUESTION:
                'Are you sure to cancel this question? This Question will be canceled from all the submitted quizzes and you will not be able to undo this question!',
            SUBMIT_CONFIRM: 'Do you want to submit and end quiz?',
            COPY_FROM: 'Are you sure to create a new question using this question?',
            START_CONFIRM: 'Do you want to start quiz?',
            CONTINUE_CONFIRM: 'Do you want to continue quiz?',
            REATTEMPT_CONFIRM: 'Do you want to reattempt quiz?',
            CHOICE_IS_EMPTY: 'In content must be at least one choice',
            CHOICE_MUST_BE_NUMERIC: 'Character between double square brackets [[]] in content always must be a numeric',
            ANSWER_OF_CHOICE_IS_EMPTY: 'Please, fill the Answer of Choiсe [[{{item}}]]',
            ANSWER_WIDTH_OF_CHOICE_IS_EMPTY:
                'Please, fill the Answer Width of Choiсe [[{{item}}]]. At least must be 30',
            NUMBER_OF_CHOICE_IS_DUBLICATED: 'Number of Choiсe [[{{item}}]] is duplicated',
            ONLY_ONE_PLACEHOLDER_ALLOWED:
                "Placeholder can be used only once. Make sure description includes only one '[[n]]' placeholder",
            NOT_ENOUGH_OPTIONS: 'There must be at least 2 non-empty options',
            NO_CORRECT_ANSWER: 'No option is marked as right answer. Please select one of the options as right answer',
            QUESTIONS_SHOULD_BE_POINTED:
                'All questions should be pointed! Question with number {{number}} is not pointed.',
            NO_QUESTIONS_ADDED: 'There is no question for this {{intent}}. Please add questions!',
            QUESTION_POINT_EXCEEDS: 'Point should not exceed {{point}}',
            QUESTION_POINT_LESS_THAN_0: 'Point can not be less than 0',
            BREAK_CONTENT_INTO_LINES: 'Divide the long content into several lines to make the question look beautiful',
            NO_QUESTIONS_ADDED_TO_GENERATE: 'You have to add at least one question to generate a random quiz',
            QUESTION_WITH_THESE_PARAMETERS_EXTSTS: 'The Questions with These parameters already exists',
            EXACTLY_ONE_CORRECT_ANSWER_REQUIRED:
                'Question must have exactly one correct answer. Make sure exactly one answer is selected as correct answer',
            SUM_OF_GRADE_MUST_BE_100: 'Sum of grades must be exactly 100%',
            INVALID_QUESTION: 'The question is not valid',
            DO_YOU_WANT_TO_DELETE: 'Do you want to delete this question?',
            SHOW_ALL_QUESTION: 'Show All Question',
            SHOW_QUESTIONS_WITH_PAGINATION: 'Show Questions With Pagination',
            INSTRUCTION: `To import successfully, follow the formatting and saving requirements:
            • Only questions can be included in the file – no titles, instructions, etc.
            • The questions must be all on one line (paragraph). No line breaks.
            • The questions cannot be numbered.
            • Each answer choice must start with an uppercase letter, followed by a period or a bracket then a space. Ex: “A. “ or “B) “. Choose one of these options only.
            • The answer must start with the word “ANSWER” all in uppercase. After the word “ANSWER”, a colon must be placed followed by a space, then the corresponding letter of the correct answer. Ex: "ANSWER: C". No line break between the last choice and the answer.
            • Each question set must be separated by a single line break.
            • The file must be saved in plain text format (.txt). When a new window pops up with encoding options, choose “other encoding” then “UTF-8”.`,
            IMPORT_WARNING:
                'All invalid questions will be skipped. Are you sure to continue importing valid questions?',
        },
    },
    SYLLABUS: {
        TITLE: {
            SYLLABUS: 'Syllabus',
            SYLLABUS_CONTENT: 'Syllabus Content',
            PARENT_SYLLABUS: 'Parent Syllabus',
            SELECT_SYLLABUS: 'Select a Section / Topic for editing or create a new one...',
            IMPORT_SYLLABUS: 'Import Syllabus',
            PREVIEW: 'Preview',
            SELECT_CURRICULUM: 'Select Curriculum',
            SELECT_COURSE: 'Select Course',
            EXTERNAL_RESOURCE: 'External Resource URL',
            EXTERNAL_RESOURCE_TEACHER: 'External Resource URL (Teacher)',
            RESOURCE_TYPE: 'Resource type',
            IQERA_STUDENT_RESOURCE: 'Student Resource URL',
            IQERA_TEACHER_RESOURCE: 'Teacher Dashboard URL',
            VIEW_MODE: 'View Mode',
            PROGRESS: 'Syllabus Progress',
            VIDEO_CONTENT_PROGRESS: 'Video Content Progress',
            CONTENT_STATUS_CHANGE: 'Content Status Change',
            CONTENT_NAME: 'Content',
            VIDEO_URL_HINT: 'YouTube URL',
            IMPORT_FROM: 'Import From',
            FROM_SYLLABUS: 'From Section / Topic',
            TILL_SYLLABUS: 'Till Section / Topic',
            GENERATE_SYLLABUS_TOOLTIP: 'Adjust with Timetable',
            FROM_DATE: 'Starting from',
            TAGS: 'Tags',
            ENTER_NEW_TAG: 'Enter new Tag...',
            PRESS_ENTER_TO_EDIT: 'press enter to edit {{item}}',
            REMOVE_ITEM: 'remove {{item}}',
            IMPORT_ITEMS_INTO: 'Import Items Into',
            LAST_VIDEO_POSITION: "Student's last watched  date and position",
            VIDEO_NOT_OPENED: "Student didn't watch yet this video",
            HOURS: 'hours',
            HOUR: 'hour',
            MINUTES: 'minutes',
            MINUTE: 'minute',
            SECONDS: 'seconds',
            SECOND: 'second',
            LAST_POSITION: 'Last Position',
            STUDENT_QUESTION_RESULT: 'Video Questions Result',
            QUESTION_POSITION: 'Question Position(in seconds)',
        },
        BUTTON: {
            ADD_ASSIGNMENT: 'Add Assignmet',
            ADD_QUIZ: 'Add Quiz',
            VIEW_EXTERNAL_URL: 'View external URL',
            CREATE_NEW: 'Create New',
            ADD_CONTENT: 'Add Content',
            SEE_CONTENT: 'See Content',
            SAVE_AUDIO: 'Save Audio(s)',
            GENERATE_GRADEBOOK: 'Add to the Gradebook',
            GENERATE_SYLLABUS: 'Adjust with Timetable',
            SYLLABUS_DESCRIPTION: 'Syllabus Description',
        },
        MESSAGE: {
            SYLLABUS_NOT_FOUND: 'Syllabus not found. Please, import or create syllabus to current course',
            SYLLABUS_NOT_EXIST: 'Selected course does not have a syllabus.',
            SEARCH_ON_SYLLABUS: 'Search on syllabus',
            CONTENT_NOT_CREATED_YET: 'Content has not been created yet.',
            UPLOAD_NOT_ALLOWED: 'Only students can upload their documents.',
            NO_CONTENT: 'This syllabus item has no interactive content.',
            COURSE_EVENT_NOT_FOUND: 'Course event cannot be found for the selected date.',
            SYLLABUS_COMPLETED: 'Syllabus marked "Completed" successfully.',
            PUBLISHED_CONTENT_EDIT_CONFIRM:
                'Current content status is PUBLISHED now. In order to edit, it should be DRAFT. Do you want to make content status DRAFT.',
            BUTTON_NOT_ALLOWED: 'Only students are able to use this button.',
            PUBLISH_TOOLTIP: 'The students are not able to see this content unless you publish it.',
            UNPUBLISH_TOOLTIP: 'The students are able to see this content unless you make it unpublished.',
            PUBLISH_SUCCESS: '{{item}} content has been published successfully.',
            UNPUBLISH_SUCCESS: '{{item}} content has been made unpublished successfully.',
            PUBLISH_CONFIRM:
                'Are you sure that you want to publish syllabus content. Once you did it, the students will be able to see this content.',
            UNPUBLISH_CONFIRM:
                'Are you sure that you want to make syllabus content unpublished. Once you did it, the students will not be able to see this content?',
            VIDEO_DESCRIPTION:
                'If your URL is correct, a video preview will appear here. Large videos may take a few minutes to appear.',
            VIDEO_NOT_FOUND: 'YouTube video cannot be found. Please check again.',
            IMPORT_COURSE_NOT_FOUND: 'No courses were found to import the curriculum.',
            ONLY_ONE_IMAGE_ALLOWED: ' You can upload only one image.',
            ONLY_ONE_VIDEO_ALLOWED: ' You can upload only one video.',
            SUCCESS_GRADEBOOK_GENERATED: 'Gradebook was succesfully updated',
            SUCCESS_SYLLABUS_GENERATED: 'Syllabus was succesfully updated',
            CONFIRMATION_GRADEBOOK_GENERATE: 'Are you sure to update the Gradebook?',
            CONFIRMATION_SYLLABUS_GENERATE_DATE:
                'Are you sure you want to link the completed syllabus (thematic plan) to the dates in the timetable? Please note that the lesson dates entered earlier will be replaced with the actual lesson dates in the timetable. This change will not affect the content, i.e. created lessons and submitted materials, but will only add the dates according to the schedule',
            SELECT_WITH_CHILDREN_OPTION: 'Enable to select parent items along with their children.',
            IMPORT_ITEMS_INTO_SELECTION_CONFIRM_MESSAGE:
                'Are you sure you want to import the selected items into {{item}}?',
            IMPORT_ITEMS_CONFIRM_MESSAGE: 'Are you sure you want to import the selected items?',
            RECORDING_UNAVAILABLE: 'The recording is not available or you do not have a permission to watch',
            ASSIGNMENT_DATE_CHANGED: 'The due date of assignment / quiz will also be changed',
        },
    },
    IMPORT_GRADES: {
        BUTTON: {
            ENTER_GRADES: 'Enter Grades',
            ENTER_GRADES_DEF:
                'If this student studied in other school, and you have to enter his/her grades to this school, you can enter them from here',
        },
        FIELD: {
            INSTITUTION_NAME: 'Institution Name',
            LEGACY_COURSE_NAME: 'Legacy Course Name',
            GPA: 'GPA',
            MATCHED_COURSE: 'Matched Subject',
            MATCHED_CLASS: 'Matched Course',
            LEGACY_COURSE_CODE: 'Legacy Course Code',
            CREDIT: 'Credit',
            FINAL_GRADE: 'Final Grade',
            ADD_TO_GPA: 'Add to GPA',
        },

        MESSAGE: {
            CONFIRMATION_PUBLISH: 'Are you sure to save and publish the grades?',
            CONFIRMATION_UNPUBLISH: 'Are you sure to unpublish the grades?',
            SUCCESSFULLY_PUBLISHED: 'Grades successfully published!',
            SUCCESSFULLY_UNPUBLISHED: 'Grades successfully unpublished!',
            SELECT_ACADEMIC_PERIOD_AND_GRADE_LEVEL: 'Please select Academic Period and Grade Level!',
            SELCET_ACADEMIC_PERIOD: 'Please select Academic Period!',
            SELECT_GRADE_LEVEL: 'Please select Grade Level!',
            ALREADY_HAVE_COURSES: 'Already have courses with this Academic Period and Grade Level',
            STUDENT_IS_NOT_SELECTED: 'Student is not selected. Please select student to put grades',
            SCHOOL_IS_NOT_SELECTED: "Student's school is not selected. Please select school for this student!",
            AT_LEAST_ONE_COURSE: 'Add at least one course grade! ',
            GRADE_MUST_BE_BETWEEN: 'Grade must be between ({{gradeMin}} - {{gradeMax}})',
        },
    },
    PARENT: {
        BUTTON: {
            CREATE_ACCOUNT_BULK: 'Create Parent Account Bulk',
        },
        DIALOG: {
            TITLE: 'Select Parent to Create Account',
            HAS_ACCOUNT: 'Has Account',
            CREATE_ACCOUNT_HINT: 'Parent should have an e-mail in order to create a user account.',
        },
        MESSAGE: {
            ACCOUNT_CREATED: 'Parent account successfully created.',
            EMAIL_REQUIRED_WARNING: 'To create a user from selected representative, please add an e-mail.',
            REPRESENTATIVE_NOT_FOUND: '{{student}} has not any representatives, please add representative first.',
            REPRESENTATIVE_ALREADY_HAVE_ACCOUNT: '{{student}} all representatives have an account.',
            REPRESENTATIVE_EMAIL_NOT_FOUND: '{{student}} representative does not have an e-mail.',
            REPRESENTATIVE_NOT_SELECTED:
                'No representative are selected for {{student}}, please select representatives for account creation.',
            ACCOUNTS_CREATED: "Selected students' representatives' accounts successfully created.",
            EMAIL_UNIQUE_ERROR: "The e-mail you have entered cannot be the same with the student's e-mail.",
        },
    },
    CONTRACT_TEMPLATES: {
        FIELD: {
            CONTRACT_TEMPLATE: 'Template',
        },
        MESSAGE: {
            USE_AS_STUDENT_FULLNAME: "Student's fullname",
            USE_AS_STUDENT_DATE_OF_BIRTH: "Student's date of birth",
            USE_AS_STUDENT_DOCUMENT_NUMBER: "Student's document number",
            USE_AS_STUDENT_PERSONAL_ID: "Student's personal ID",
            NO_CONTRACT_TEMPLATE: "You don't have any active templates. You need to add it",
            USE_AS_DOCUMENT_GIVEN_DATE: "Student's document issue date",
            USE_AS_DOCUMENT_DUE_DATE: "Student's document due date",
            USE_AS_DOCUMENT_GIVEN_BY: "Student's document issued by",
            USE_AS_STUDENT_ID: "Student's ID",
            USE_AS_STUDENT_PHONE: "Student's phone",
            USE_AS_STUDENT_EMAIL: "Student's e-mail",
            USE_AS_STUDENT_PARENT: 'Parent fullname',
            CURRENT_DATE: 'Current Date',
            CURRENT_TIME: 'Current Time',
            STUDENT_ADDRESS_COUNTRY: "Student's country",
            STUDENT_ADDRESS_CITY: "Student's city",
            STUDENT_ADDRESS_STREET: "Student's street",
            STUDENT_ADDRESS_POSTAL_CODE: "Student's postal code",
            PARENT_ADDRESS_COUNTRY: 'Parent country',
            PARENT_ADDRESS_CITY: 'Parent city',
            PARENT_ADDRESS_STREET: 'Parent street',
            PARENT_ADDRESS_POSTAL_CODE: 'Parent postal code',
            PARENT_PHONE: 'Parent phone',
            PARENT_EMAIL: 'Parent e-mail',
            PARENT_DATE_OF_BIRTH: 'Parent date of birth',
            PARENT_DOCUMENT_NUMBER: 'Parent document number',
            PARENT_PERSONAL_ID: 'Parent personal ID',
            PARENT_DOCUMENT_GIVEN_DATE: 'Parent document issue date',
            PARENT_DOCUMENT_DUE_DATE: 'Parent document due date',
            PARENT_DOCUMENT_GIVEN_BY: 'Parent document issued by',
            PARENT_CITIZENSHIP: 'Parent citizenship',
            PARENT_NATIONALITY: 'Parent nationality',
            PARENT_TYPE: 'Parent type',
            PARENT_SECOND_FULLNAME: '2nd Parent fullname',
            PARENT_SECOND_ADDRESS_COUNTRY: '2nd Parent country',
            PARENT_SECOND_ADDRESS_CITY: '2nd Parent city',
            PARENT_SECOND_ADDRESS_STREET: '2nd Parent street',
            PARENT_SECOND_ADDRESS_POSTAL_CODE: '2nd Parent postal code',
            PARENT_SECOND_PHONE: '2nd Parent phone',
            PARENT_SECOND_EMAIL: '2nd Parent e-mail',
            PARENT_SECOND_DATE_OF_BIRTH: '2nd Parent date of birth',
            PARENT_SECOND_DOCUMENT_NUMBER: '2nd Parent document number',
            PARENT_SECOND_PERSONAL_ID: '2nd Parent personal ID',
            PARENT_SECOND_DOCUMENT_GIVEN_DATE: '2nd Parent document issue date',
            PARENT_SECOND_DOCUMENT_DUE_DATE: '2nd Parent document due date',
            PARENT_SECOND_DOCUMENT_GIVEN_BY: '2nd Parent document issued by',
            PARENT_SECOND_CITIZENSHIP: '2nd Parent citizenship',
            PARENT_SECOND_NATIONALITY: '2nd Parent nationality',
            PARENT_SECOND_TYPE: '2nd Parent type',
            CONTRACT_START_DATE: 'Contract start date',
            CONTRACT_END_DATE: 'Contract end date',
            STUDENT_CURRENT_CLASS: "Student's class",
            STUDENT_CURRENT_GRADE_LEVEL: "Student's grade level",
            STUDENT_CITIZENSHIP: "Student's citizenship",
            CONTRACT_NUMBER: 'Contract Number',
            CONTRACT_NUMBER_HINT:
                'This is not a required field, if you leave it empty then the contract number will be empty',
            CONTRACT_NOT_REQUIRED_FIELDS_HINT:
                'These fields are optional, if you leave them empty, the fields will be empty',
            PARENT_FULL_ADDRESS: 'Parent full address',
            INCIDENT_DATE: 'Incident Date',
            STUDENT_FIRST_NAME: 'Student First Name',
            STUDENT_MIDDLE_NAME: 'Student Middle name',
            STUDENT_LAST_NAME: 'Student Last Name',
            REGISTRATION_NAME: 'Registration Name',
            REGISTRATION_NUMBER: 'Registration Number',
            PARENT_FIRST_NAME1: 'First Name of the 1st Parent',
            PARENT_LAST_NAME1: 'Last Name of the 1st Parent',
            PARENT_RELATIONSHIP1: '1st Parent Relationship',
            REGISTRATION_START_DATE: 'Registration Start Date',
            REGISTRATION_END_DATE: 'Registration End Date',
        },
        TITLE: {
            ADD: 'Add Template',
            BROWSER: 'Templates',
            NEW: 'New Template',
            STUDENT_FIELDS: 'Student Fields',
            PARENT_FIELDS: '1st Parent Fields',
            PARENT_SECOND_FIELDS: '2nd Parent Fields',
            GENERAL_FIELDS: 'General Fields',
            EMPLOYEE_FIELDS: 'Employee Fields',
        },
    },
    CERTIFICATE_TYPE: {
        TITLE: {
            ADD: 'Add Certificate Type',
            BROWSER: 'Certificate Types',
            EDIT: 'Certificate Type',
            NEW: 'New Certificate Type',
        },
    },
    CERTIFICATE: {
        TITLE: {
            CERTIFY: 'Certify Students',
            CERTIFICATE: 'Student Certificate',
            CERTIFY_DATE: 'Certify Date',
            CERTIFIED_BY: 'Certified by',
            CERTIFIED_BY_POSITION: 'Certified by Position',
        },
        FIELD: {
            CERTIFY_DATE: 'Certified Date',
            CERTIFIED_BY: 'Certifier',
            CERTIFIED_BY_POSITION: 'Certifier Position',
            CERTIFICATE_TEXT: 'Certificate Text',
        },
        BUTTON: {
            CERTIFY: 'Certify',
        },
        MESSAGE: {
            CONFIRM_CERTIFY: 'Do you want to certify?',
            USE_AS_CERTIFY_DATE: 'Use {{value}} as Certify Date',
            USE_AS_CERTIFIED_BY: 'Use {{value}} as Certified by',
            USE_AS_CERTIFIED_BY_POSITION: 'Use {{value}} as Certified By  Position',
            STUDENTS_CERTIFIED_SUCCESSFULLY: 'Students certified successfully!',
            WRITE_CERTIFICATE_TEXT_HERE: 'Write certificate text here...',
            TINY_SUGGESTIONS: "Type character '{' and name to see suggestions",
            TEMPLATE_TEXT: 'You may write certificate text template here:',
        },
    },
    ORDER: {
        FIELD: {
            WHOM: 'Whom',
        },
        TITLE: {
            ADD: 'Add Order',
            BROWSER: 'Orders',
            NEW: 'New Order',
            ORDER: 'Order',
            ORDER_WITH_PARAM: 'Order - {{param}}',
        },
    },
    ADVANCED_SEARCH: {
        TITLE: {
            SELECT_SEARCH: 'Select saved search',
            EDIT_SEARCH: 'Edit search',
            SAVE_SEARCH: 'Save search',
            RELATION_BETWEEN_GROUPS: 'Relationship between groups:',
            RELATION_WITHIN_GROUP: 'Relationship within the group',
            FIELD_CATEGORY: 'Field Category',
            CONDITION: 'Condition',
            SAVED_SEARCHES: 'Saved searches',
            SEARCHES: 'Searches',
            SAVE_AS: 'Save as',
            ADD_SEARCH_NAME: 'Add name of the search',
            ADD_RULE: 'Add Rule',
            ADD_GROUP: 'Add Group',
        },
        MESSAGE: {
            NO_SAVED_SEARCH: 'There is no any saved searches',
        },
    },
    SIBLING: {
        TITLE: {
            SIBLINGS: 'Siblings',
            SIBLING: 'Sibling',
            REPRESENTATIVE_NUM: 'Parent {{num}}',
            ADD_REPRESENTATTIVE_FROM_SIBLING: 'Add Parents from Sibling accounts',
        },
        MESSAGE: {
            REMOVE_STUDENT_FROM_HOUSEHOLD: 'Do you want to remove student from household?',
            ADD_SIBLINGS: 'Add Siblings',
            CANNOT_ADD_ITSELF_AS_SIBLING: 'You cannot add {{fullname}} as sibling',
        },
    },
    COURSE_SNAPSHOT: {
        TITLE: {
            COURSE_SNAPSHOT: 'Student Progress',
            GPA: 'GPA',
            CREDITS_EARNED: 'Credits Earned',
            CUMULATIVE_YEAR_GPA: 'Cumulative year GPA',
            CUMULATIVE_CREDITS: 'Cumulative Credits',
            GRADE_PERCENT: 'Grade %',
            GRADE: 'Grade',
            POINT: 'Point',
            CREDIT_EARNED_SHORT: 'Cr. Earned',
            PRESENCE: 'Presence',
            ABSENCE: 'Absence',
        },
    },

    HEALTH_MANAGEMENT: {
        TITLE: {
            MEDICATION: 'Medications',
            MEDICATION_PLAN: 'Medication Plan',
            INVENTORY_ACTION: 'Inventory Action',
            INVENTORY_AVAILABLE: 'Inventory Available',
            MEDICATION_LOG: 'Medication Log',
            VISION_TEST: 'Vision Tests',
            HEARING_TEST: 'Hearing Tests',
            SCOLIOSIS_TEST: 'Scoliosis Tests',
            OFFICE_VISIT: 'Office Visits',
            IMMUNIZATION: 'Immunizations',
            ATTACHMENTS: 'Attachments',
            ALERTS: 'Medical Alerts',
            ALERT: 'Medical Alert',
            TODAY_ATTANCE: 'Today`s Attendance',
            SCHEDULE: 'Schedule',
            PARENT_CONNECTION: 'Parent/Guardian communication',
            ATTACH_MEDICATION_ORDER: 'Attach Medication Order',
            NEW_MEDICATION_LOG: 'New Medication Log',
            NEW_INVENTORY_ACTION: 'New Inventory Action',
            NEW_HEARING_SCREEN: 'New Hearing Test',
            HEARING_SCREEN: 'Hearing Test',
            MEDICAL_ATTACHMENT: 'Medical Attachment',
        },
        FIELD: {
            IMMUNIZATION_UP_TO_DATE: 'Immunization up to Date',
            IMMUNIZATION_RECORDS: 'Immunization Records',
            DISTANCE_OS: 'Distance OS',
            DISTANCE_OD: 'Distance OD',
            DISTANCE_OU: 'Distance OU',
            NEAR_OS: 'Near OS',
            NEAR_OD: 'Near OD',
            NEAR_OU: 'Near OU',
            COLOR: 'Color',
            NURSE: 'Nurse',
            REFERAL: 'Referral',
            SCOLIOSIS_TEST: 'Scoliosis Test',
            LEFT_EYE: 'Left Eye',
            RIGHT_EYE: 'Right Eye',
            BOTH_EYES: 'Both Eyes',
            CORRECTED: 'Corrected',
            DISTANCE: 'Distance Vision',
            NEAR: 'Near Vision',
            TIME_IN: 'Time In',
            TIME_OUT: 'Time Out',
            VISIT_TYPE: 'Visit Type',
            COMPLAINT: 'Complaint',
            INTERVENTION: 'Intervention',
            DISPOSITION: 'Disposition',
            VITAL_SIGNS: 'Vital Signs',
            TEMPERATURE: 'Temperature',
            BLOOD_PRESSURE: 'Blood Pressure',
            HEART_RATE: 'Heart Rate',
            O2: 'O2(Oxygen)',
            RESPIRATORY_RATE: 'Respiratory Rate',
            MEANS_OF_CONTACT: 'Means of Contact',
            MEDICATION: 'Medication',
            DOSE: 'Dose',
            ROUTE: 'Route',
            FREQUENCY: 'Frequency',
            REASON: 'Reason',
            HOURS_BETWEEN_INTAKE: 'Hours Between in Take',
            UNIT: 'Unit',
            MEDICATION_ORDER_ATTACHMENT: 'Medication Order Attachment',
            ACTION_TYPE: 'Action Type',
            EXPIRE_DATE: 'Exp.Date',
            BALANCE: 'Balance',
            HEARING_TEST: 'Hearing Test',
            ALLERGIES: 'Allergies',
            ALERT_NOTE: 'Alert Note',
        },
        MESSAGE: {
            ADD_VISION_SCREEN: 'Add Vision Screening',
            VISION_SCREENING: 'Vision Screening',
            ADD_SCOLIOSIS_SCREEN: 'Add Scoliosis Screening',
            SCOLIOSIS_SCREEN: 'Scoliosis Screening',
            ADD_OFFICE_VISIT: 'Add Office Visit',
            OFFICE_VISIT: 'Office Visit',
            PARENT_CONTACTED: 'Was parent contacted?',
            ADD_INVENTORY_TYPE: 'Add Intervention Type',
            ADD_DISPOSITION_TYPE: 'Add disposition type',
            ADD_MEDICATION_PLAN: 'Add Medication Plan',
            MEDICATION_PLAN: 'medication plan',
            ADD_MEDICATION: 'Add Medication',
            ADD_ROUTE: 'Add Route',
            ADD_UNIT: 'Add Unit',
            ADD_MEDICATION_LOG: 'Add Medication Log',
            ADD_INVENTORY_ACTION: 'Add Inventory Action',
            STUDENT_ID_EMPTY: 'There no student info(ID)',
            ADD_HEARING_SCREENING: 'Add Hearing Screening',
            HEARING_SCREENING: 'hearing screening',
            ADD_MEDICAL_ALERT: 'Add Medical Alert',
            ADD_ALLERGIES: 'Allergies',
            MEDICAL_ALERT_SAVED: 'Medicial Alerts saved successfully',
            ADD_MEDICAL_ATTACHMENT: 'Add Medical Attachment',
            NEW_MEDICAL_ATTACHMENT: 'Medical Attachment',
            ALERT_NOTE_HINT: 'This information will be visible to teachers.',
            NO_AVAILABLE_INVENTORY: 'No inventory items available',
        },
    },
    CLASS_RANKING: {
        TITLE: {
            EDIT_RANK: 'Edit Rank',
            NEW_RANK: 'New Rank',
            RANKING_MAP: 'Ranking Map',
        },
        FIELD: {
            RANK: 'Rank',
            RANKING_TYPE: 'Ranking Type',
        },
    },
    CLEVER: {
        FIELD: {
            FTP_URL: 'Ftp URL (Ex: sftp.xxxx.com)',
            EMAILS: 'E-Mails',
            SEND_EMAIL_WHEN_ERROR_OCCURED: 'Send E-Mail When Error Occured',
            SAVE_SENDIG_FILES: 'Save Submitted Files',
            SAVE_HISTORY: 'Save Submit History',
            SCHOOL_NUMBER: 'School Number',
            SCHOOL_ID: 'School Id',
        },
        TITLE: 'Clever Setting',
        MESSAGE: {
            TEST_SUCCESS: 'Connection test was successfully',
            TEST_FAILED: 'Connection test was failed! Please check your information you have entered and try it again',
            EMAILS_HINT: 'Comma seperated. Ex: jhon.doe@test121.com,jane.doe@test121.com',
            SEND_FILES: 'Send Files',
            LOGS: 'Logs',
            SEND_FILE_SUCCESS: 'Roster files sent successfully',
            SEND_FILE_FAILED: 'Roster files sending failed. Please check the logs',
        },
    },
    CLASSLINK: {
        TITLE: 'ClassLink Setting',
    },
    FRONTLINE: {
        TITLE: 'Frontline Setting',
        LOG_TITLE: 'Frontline Logs',

        TAB: {
            BASIC_CONFIG: 'Basic Configuration',
            STUDENT_MAPPING: 'Student Field Mappings',
            CONTACT_MAPPING: 'Contact Field Mappings',
        },

        FIELD: {
            FTP_HOST: 'FTP Host',
            PORT: 'Port',
            USERNAME: 'Username',
            PASSWORD: 'Password',
            SCHOOLS: 'Schools',
            EMAILS: 'Email Addresses',
            ENABLED: 'Enabled',
            EMAIL_ON_ERROR: 'Send Email When Error Occurred',
            SAVE_FILES: 'Save Sending Files',
            SAVE_HISTORY: 'Save History',
        },

        MESSAGE: {
            EMAILS_HINT: 'Separate multiple email addresses with commas',
            INFO_STUDENT_MAPPING:
                "Configure how student data fields from your system map to Frontline's required fields.",
            INFO_CONTACT_MAPPING:
                "Configure how contact/guardian data fields map to Frontline's required contact fields.",
            REQUIRED_FIELDS_MISSING: 'Please map all required fields',
            TEST_SUCCESS: 'Connection test was successful',
            TEST_FAILED: 'Connection test failed! Please check your information and try again',
            SEND_FILE_SUCCESS: 'Roster files sent successfully',
            SEND_FILE_FAILED: 'Roster files sending failed. Please check the logs',
            DOWNLOAD_SUCCESS: 'File downloaded successfully',
            DOWNLOAD_FAILED: 'File download failed. Please try again',
        },

        BUTTON: {
            CHECK_CONNECTION: 'Check Connection',
            SEND_FILES: 'Send Files',
            DOWNLOAD_INFO_FILES: 'Download Info Files',
            LOGS: 'Logs',
        },
    },
    ASSESSMENT: {
        TITLE: 'Assessment Setup',
        TEACHER_ACCESS: 'Teacher Access',
        FINAL_SCORE_CHOICE: 'Final Score Choice',
        SHOW_IN_REPORD_CARD: 'Show in Report Card',
        POINT: 'Number',
        PERCENT: 'Percent',
        ALPHA: 'Alphabetic',
        EXAM: 'Exam',
        ASSESSMENT_GROUP: 'Assessment Group',
        ADD_NEW_ASSESSMENT: 'Add New Assessment',
        ASSESSMENT_ENABLED: 'Enable Assessment Module',
        ADD_SCORE: 'Add New Score',
        EDIT_SCORE: 'Score',
        NEW_SCORE: 'New Score',
        REGULAR_PASS_SCORE: 'Regular Pass Score',
        SPECIAL_ED_PASS_SCORE: 'Special Ed. Pass Score',
        PASSED: 'Passed',
        FAILED: 'Failed',
        SCORES: 'Assessment Scores',
        SCORE_OVERRIDE: 'If a score has been entered before, change it.',
        SCORE_APPROVE_CONFIRM:
            'Newly added scores will be saved and approved, and old draft scores will be approved. Are you sure?',
    },
    WEBHOOK: {
        TITLE: {
            WEBHOOK: 'Webhook',
            CUSTOM_HEADERS: 'Custom Headers',
        },
        FIELD: {
            EVENT_TYPE: 'Event Type',
            URL: 'URL',
            AUTH_TYPE: 'Authentication Type',
            USERNAME: 'Username',
            PASSWORD: 'Password',
            API_KEY_NAME: 'API Key Name',
            API_KEY_VALUE: 'API Key Value',
            HEADER_NAME: 'Header Name',
            HEADER_VALUE: 'Header Value',
        },
        EVENT_TYPE: {
            ATTENDANCE: 'Attendance Update',
            STUDENT: 'Student Update',
            GRADE: 'Grade Update',
        },
        AUTH_TYPE: {
            BASIC: 'Basic Auth',
            API_KEY: 'API Key',
        },
        BUTTON: {
            ADD: 'Add Webhook',
            ADD_HEADER: 'Add Header',
            TEST: 'Test',
            SAVE: 'Save All',
        },
        ERROR: {
            INVALID_URL: 'Please enter a valid URL starting with http:// or https://',
            DUPLICATE_EVENT: 'Duplicate event types are not allowed',
        },
        MESSAGE: {
            ERROR: {
                LOAD_FAILED: 'Failed to load webhook settings',
                REQUIRED_FIELDS: 'Please fill all required fields correctly',
                TEST_FAILED: 'Webhook test failed: {{message}}',
                VALIDATION_ERRORS: 'Please fix validation errors before saving',
                SAVE_FAILED: 'Failed to save webhook settings: {{message}}',
            },
            SUCCESS: {
                TEST_SUCCESS: 'Webhook test successful',
                SAVE_SUCCESS: 'Webhook settings saved successfully',
            },
        },
    },
    GPA_CALCULATION: {
        BUTTON: {
            CALCULATE_GPA: 'Calculate GPA',
        },
        MESSAGE: {
            CALCULATE_GPA_FOR_ALL_ACTIVE_STUDENTS: 'Calculate GPA for all active students',
            CALCULATE_GPA_FOR_SELECTED_STUDENTS: 'Calculate GPA for selected students',
            SUCCESS: 'GPA calculation process completed successfully',
        },
    },
    SOLANA_SETTING: {
        FIELD: {
            FTP_URL: 'Ftp URL (Ex: sftp.xxxx.com)',
            EMAILS: 'E-Mails',
            SEND_EMAIL_WHEN_ERROR_OCCURED: 'Send E-Mail When Error Occured',
            SAVE_SENDIG_FILES: 'Save Submitted Files',
            SAVE_HISTORY: 'Save Submit History',
            SCHOOL_NUMBER: 'School Number',
            SCHOOL_ID: 'School Id',
        },
        TITLE: 'Solana Settings',
        MESSAGE: {
            TEST_SUCCESS: 'Connection test was successfully',
            TEST_FAILED: 'Connection test was failed! Please check your information you have entered and try it again',
            EMAILS_HINT: 'Comma seperated list. Ex: jhon.doe@test121.com,jane.doe@test121.com',
            SEND_FILES: 'Send Files',
            LOGS: 'Logs',
            SEND_FILE_SUCCESS: 'Roster files sent successfully',
            SEND_FILE_FAILED: 'Roster files sending failed. Please check the logs',
        },
    },
    COUNSELOR_HOME: {
        TITLE: {
            APPOINTMENT: 'Upcoming Appointments',
            STUDENT_LIST: 'Student List',
        },
    },
};
